{
  "decorations": [
    {
      "id": "warfish-logo-outline",
      "shape": "M 914.61 775.13 C 914.51 775.16 914.24 775.29 914.01 775.40 C 913.78 775.52 913.51 775.64 913.41 775.67 C 913.22 775.72 912.71 776.05 912.23 776.42 C 911.59 776.91 910.96 777.88 910.70 778.76 C 910.50 779.48 910.24 779.67 909.56 779.61 C 909.12 779.58 908.93 779.60 908.53 779.72 C 908.06 779.87 907.91 779.87 905.57 779.86 C 903.49 779.84 903.06 779.86 902.80 779.95 C 902.42 780.09 902.09 780.09 901.64 779.96 C 901.21 779.82 898.35 779.81 897.47 779.94 C 896.98 780.01 896.83 780.01 896.38 779.90 C 896.10 779.83 895.57 779.74 895.20 779.69 C 894.23 779.56 894.08 779.43 894.18 778.81 C 894.42 777.29 894.09 776.46 893.14 776.15 C 892.54 775.96 887.73 775.89 887.15 776.05 C 886.44 776.27 886.25 776.28 885.60 776.14 C 885.06 776.02 884.71 776.01 883.07 776.02 C 881.13 776.03 880.82 776.07 880.28 776.34 C 879.92 776.53 879.76 776.51 879.13 776.21 C 878.43 775.88 874.07 775.82 873.25 776.12 C 872.82 776.29 872.34 776.74 872.17 777.16 C 871.97 777.62 872.11 781.41 872.35 782.59 C 872.45 783.03 872.53 783.86 872.60 784.98 C 872.67 786.30 872.73 786.89 872.87 787.48 C 872.99 788.03 873.06 788.58 873.10 789.38 C 873.17 791.16 873.52 791.76 874.64 792.06 C 875.35 792.25 879.59 792.19 880.33 791.98 C 881.07 791.76 881.08 791.76 881.77 791.99 C 882.39 792.18 882.29 792.18 886.84 791.99 C 887.71 791.95 888.38 791.47 888.77 790.58 C 889.08 789.89 889.27 789.91 889.84 790.66 C 890.91 792.08 893.16 792.80 894.78 792.23 C 895.46 791.99 895.70 791.97 896.38 792.11 C 897.12 792.27 899.58 792.23 900.29 792.05 C 900.79 791.93 900.88 791.92 901.31 792.02 C 902.51 792.25 905.97 792.17 906.63 791.88 C 907.35 791.57 907.73 790.60 907.92 788.57 C 908.04 787.38 908.28 786.88 908.75 786.88 C 909.15 786.88 909.23 787.47 908.94 788.34 C 908.08 790.98 908.75 792.07 911.27 792.14 C 913.01 792.18 915.16 792.06 915.79 791.87 C 916.29 791.71 916.31 791.71 916.67 791.83 C 917.56 792.14 920.66 792.21 922.48 791.97 C 923.43 791.84 923.63 791.86 925.05 792.21 C 925.92 792.42 927.60 792.38 928.60 792.13 C 929.56 791.88 930.26 791.85 931.35 792.04 C 932.26 792.18 935.06 792.21 935.84 792.07 C 936.26 792.00 936.42 792.01 936.95 792.11 C 938.00 792.32 941.49 792.13 942.60 791.80 C 942.81 791.75 942.98 791.77 943.73 791.99 C 944.83 792.31 945.76 792.35 946.38 792.10 C 946.82 791.92 947.32 791.90 947.99 792.06 C 948.42 792.16 948.67 792.16 950.47 792.07 C 952.73 791.97 952.85 791.97 955.83 792.09 C 958.41 792.19 958.84 792.14 959.37 791.65 C 959.98 791.09 960.19 791.08 960.92 791.56 C 961.18 791.73 961.51 791.89 961.64 791.91 C 961.78 791.94 962.15 792.04 962.46 792.14 C 963.39 792.44 965.43 792.46 966.36 792.17 C 966.73 792.05 967.14 791.94 967.27 791.92 C 967.41 791.89 967.70 791.76 967.93 791.62 C 968.64 791.19 968.95 791.18 969.43 791.59 C 970.11 792.18 974.31 792.49 975.46 792.02 C 976.29 791.69 976.81 791.05 976.91 790.24 C 976.95 789.98 977.05 789.50 977.15 789.18 C 977.25 788.87 977.36 788.30 977.41 787.94 C 977.44 787.57 977.49 787.20 977.51 787.11 C 977.56 786.85 977.96 786.46 978.36 786.27 C 979.04 785.95 979.37 785.42 979.50 784.45 C 979.54 784.14 979.66 783.58 979.75 783.20 C 980.11 781.83 980.02 781.20 979.40 780.54 C 978.98 780.10 978.99 780.14 979.02 779.31 C 979.04 778.42 978.38 777.45 977.62 777.26 C 977.12 777.13 972.41 777.26 972.12 777.42 C 971.49 777.75 971.00 778.33 971.00 778.75 C 970.99 779.13 970.75 779.52 970.14 780.11 C 969.45 780.79 969.26 780.84 968.78 780.50 C 968.03 779.96 967.40 779.77 965.85 779.64 C 964.93 779.56 963.41 779.73 962.86 779.96 C 962.72 780.03 962.43 780.13 962.23 780.21 C 962.01 780.28 961.64 780.49 961.39 780.67 C 960.38 781.41 960.40 781.41 959.78 780.81 C 959.24 780.27 958.58 779.89 958.04 779.79 C 957.33 779.66 955.95 779.61 955.53 779.71 C 955.26 779.77 954.31 779.80 952.40 779.81 C 949.68 779.82 949.65 779.82 949.34 779.99 C 948.23 780.56 947.92 781.26 947.62 783.94 C 947.54 784.72 947.15 784.97 946.55 784.62 C 946.18 784.41 946.11 784.39 945.34 784.37 C 944.32 784.35 944.18 784.25 944.11 783.46 C 943.89 781.34 942.74 780.03 940.84 779.74 C 939.62 779.56 939.39 779.30 939.64 778.40 C 939.98 777.20 939.78 776.30 939.06 775.79 C 938.18 775.15 933.75 775.13 932.71 775.77 C 932.30 776.03 931.98 776.60 931.90 777.19 C 931.84 777.70 931.33 779.85 931.23 780.00 C 931.10 780.20 930.84 780.20 930.37 780.00 C 929.66 779.69 928.88 779.61 927.48 779.70 C 925.92 779.81 925.96 779.83 925.82 778.80 C 925.55 776.85 924.82 775.99 922.80 775.23 C 922.30 775.04 921.15 775.13 920.59 775.41 C 919.94 775.72 919.54 775.72 918.84 775.37 C 918.31 775.11 915.21 774.94 914.61 775.13 Z",
      "fill": "#000000",
      "role": "warfish-logo"
    },
    {
      "id": "warfish-logo-lettering",
      "shape": "M 915.29 777.04 C 913.81 777.31 912.76 778.58 912.32 780.65 C 912.16 781.38 912.06 781.52 911.55 781.75 C 910.96 782.02 910.91 782.12 910.64 783.69 C 910.59 784.04 910.72 784.38 911.03 784.66 C 911.45 785.05 911.47 785.18 911.31 785.89 C 911.23 786.22 911.14 786.86 911.09 787.30 C 911.04 787.75 910.93 788.42 910.84 788.78 C 910.50 790.12 910.58 790.19 912.67 790.23 C 914.61 790.26 914.62 790.25 914.79 788.77 C 914.85 788.26 914.97 787.56 915.07 787.21 C 915.16 786.85 915.26 786.27 915.30 785.91 C 915.39 784.98 915.58 784.77 916.40 784.63 C 917.11 784.52 917.23 784.37 917.34 783.44 C 917.38 783.11 917.44 782.70 917.46 782.52 C 917.52 782.09 917.34 781.87 916.86 781.75 C 915.88 781.51 916.08 780.34 917.14 780.17 C 917.80 780.06 917.85 780.01 918.15 778.87 C 918.59 777.21 918.48 777.07 916.68 777.01 C 916.10 776.99 915.47 777.00 915.29 777.04 Z M 920.75 777.12 C 919.69 777.43 919.00 779.01 919.49 780.02 C 920.52 782.14 923.57 781.25 923.57 778.83 C 923.57 777.40 922.34 776.66 920.75 777.12 Z M 934.03 777.29 C 933.80 777.45 933.73 777.62 933.62 778.33 C 933.57 778.68 933.47 779.15 933.42 779.37 C 933.36 779.58 933.26 780.20 933.21 780.74 C 933.14 781.28 933.02 782.03 932.93 782.42 C 932.83 782.80 932.72 783.49 932.68 783.93 C 932.64 784.37 932.51 785.13 932.40 785.62 C 932.29 786.10 932.17 786.78 932.12 787.14 C 932.08 787.49 931.97 788.09 931.87 788.46 C 931.45 790.08 931.56 790.19 933.59 790.19 C 935.56 790.19 935.49 790.26 935.98 787.38 C 936.34 785.30 936.79 784.58 937.50 784.92 C 937.95 785.13 937.95 785.41 937.53 787.87 C 937.14 790.16 937.10 790.08 938.89 790.15 C 940.63 790.22 940.98 790.12 941.08 789.49 C 941.11 789.35 941.20 788.96 941.30 788.61 C 941.39 788.27 941.52 787.71 941.58 787.35 C 941.64 787.00 941.76 786.32 941.86 785.86 C 942.29 783.73 942.01 782.40 941.03 781.85 C 940.44 781.52 938.92 781.54 938.19 781.88 C 937.21 782.34 937.04 782.14 937.24 780.82 C 937.32 780.35 937.42 779.59 937.46 779.15 C 937.50 778.71 937.56 778.23 937.59 778.09 C 937.66 777.76 937.57 777.43 937.38 777.34 C 937.10 777.20 934.21 777.17 934.03 777.29 Z M 889.05 777.74 C 887.77 777.80 887.58 777.92 887.22 778.89 C 887.11 779.17 886.89 779.74 886.72 780.17 C 886.56 780.59 886.39 781.08 886.34 781.26 C 886.01 782.61 885.56 783.54 885.27 783.49 C 884.97 783.45 884.94 783.25 884.94 780.84 C 884.94 777.57 885.04 777.76 883.16 777.75 C 881.27 777.75 881.27 777.75 880.51 779.89 C 879.50 782.79 879.32 783.21 879.05 783.27 C 878.78 783.34 878.67 783.16 878.64 782.62 C 878.62 782.35 878.56 781.50 878.50 780.73 C 878.45 779.96 878.39 779.09 878.38 778.80 C 878.34 777.90 878.29 777.88 876.18 777.88 C 873.91 777.88 873.84 777.94 874.14 779.50 C 874.19 779.79 874.26 780.29 874.29 780.62 C 874.31 780.96 874.37 781.60 874.43 782.07 C 874.48 782.53 874.54 783.13 874.56 783.40 C 874.59 783.67 874.65 784.34 874.71 784.88 C 874.81 785.83 875.05 788.45 875.12 789.30 C 875.19 790.13 875.41 790.21 877.64 790.17 C 879.30 790.15 879.30 790.15 879.50 789.98 C 879.80 789.69 880.70 787.77 881.22 786.25 C 881.67 784.91 882.19 785.09 882.27 786.61 C 882.46 790.18 882.43 790.12 884.27 790.19 C 884.94 790.22 885.62 790.26 885.77 790.29 C 886.55 790.42 886.73 790.20 887.75 787.87 C 887.86 787.61 888.22 786.82 888.55 786.10 C 888.88 785.38 889.16 784.77 889.16 784.75 C 889.16 784.72 889.36 784.29 889.61 783.77 C 890.23 782.48 890.99 780.79 891.32 779.96 C 891.48 779.57 891.69 779.07 891.79 778.84 C 892.27 777.74 891.91 777.59 889.05 777.74 Z M 973.27 779.25 C 972.97 779.39 972.86 779.58 972.72 780.27 C 972.55 781.12 972.40 781.38 971.85 781.67 C 971.39 781.91 971.21 782.16 971.21 782.54 C 971.21 782.63 971.13 782.98 971.03 783.32 C 970.80 784.11 970.83 784.32 971.23 784.67 C 971.75 785.14 971.79 785.31 971.56 786.18 C 971.49 786.47 971.37 787.10 971.32 787.59 C 971.25 788.07 971.15 788.68 971.07 788.94 C 970.73 790.08 970.81 790.13 972.87 790.10 C 974.96 790.08 974.74 790.26 975.25 788.11 C 975.38 787.53 975.54 786.71 975.61 786.29 C 975.79 785.10 975.99 784.79 976.70 784.64 C 977.37 784.49 977.46 784.37 977.64 783.44 C 977.69 783.11 977.79 782.71 977.83 782.54 C 977.95 782.12 977.83 781.92 977.35 781.74 C 976.71 781.50 976.58 781.14 976.77 780.12 C 976.86 779.62 976.78 779.39 976.45 779.25 C 976.11 779.11 973.60 779.11 973.27 779.25 Z M 908.91 781.54 C 908.81 781.57 908.46 781.71 908.14 781.86 L 907.55 782.12 L 906.99 781.93 C 906.30 781.71 903.87 781.65 903.39 781.85 C 903.00 782.02 902.80 782.83 902.27 786.36 C 902.17 787.01 902.02 788.00 901.94 788.55 C 901.70 790.12 901.72 790.15 903.75 790.15 C 905.10 790.15 905.19 790.15 905.33 790.00 C 905.52 789.82 905.92 788.46 906.06 787.55 C 906.37 785.51 907.06 784.70 908.31 784.90 C 909.24 785.05 909.48 784.67 909.61 782.92 C 909.68 781.96 909.63 781.67 909.36 781.55 C 909.17 781.46 909.16 781.46 908.91 781.54 Z M 963.91 781.61 C 960.48 782.35 958.79 786.86 961.04 789.26 C 962.11 790.41 964.43 790.82 966.22 790.19 C 967.36 789.77 967.87 789.41 968.39 788.64 C 968.93 787.83 968.77 787.52 967.78 787.44 C 966.41 787.32 966.12 787.35 965.43 787.66 C 964.69 788.00 964.39 787.97 964.17 787.53 C 963.82 786.84 964.47 786.66 967.55 786.56 C 969.58 786.49 969.72 786.33 969.35 784.40 C 968.94 782.23 966.60 781.03 963.91 781.61 Z M 965.73 784.13 C 966.13 784.53 965.91 784.88 965.27 784.87 C 964.57 784.86 964.31 784.48 964.75 784.11 C 965.06 783.85 965.46 783.86 965.73 784.13 Z M 894.01 781.68 C 890.98 782.16 889.41 787.61 891.70 789.73 C 892.69 790.64 893.65 790.77 894.92 790.13 C 895.78 789.70 895.96 789.69 896.51 789.98 C 897.19 790.34 899.56 790.22 899.77 789.81 C 899.89 789.56 900.25 788.22 900.40 787.40 C 900.48 786.98 900.61 786.40 900.69 786.11 C 900.76 785.82 900.86 785.17 900.91 784.67 C 900.94 784.16 901.04 783.47 901.12 783.14 C 901.40 781.93 901.31 781.84 899.67 781.79 C 898.17 781.73 898.05 781.75 897.59 782.14 C 897.15 782.52 897.00 782.53 896.60 782.20 C 895.96 781.67 895.14 781.50 894.01 781.68 Z M 896.33 784.88 C 897.19 785.32 896.95 786.71 895.94 787.19 C 895.10 787.59 894.27 786.40 894.70 785.43 C 894.96 784.86 895.76 784.58 896.33 784.88 Z M 926.79 781.68 C 925.57 781.85 924.47 783.02 924.40 784.24 C 924.32 785.42 924.86 786.29 926.02 786.85 C 926.58 787.12 926.70 787.24 926.70 787.53 C 926.70 787.95 926.23 787.97 925.43 787.59 C 924.45 787.11 924.35 787.15 923.57 788.22 C 922.84 789.21 923.02 789.53 924.64 790.17 C 926.87 791.05 929.52 790.44 930.45 788.84 C 931.34 787.33 930.61 785.17 929.11 784.84 C 928.48 784.69 928.15 784.32 928.43 784.04 C 928.59 783.87 928.88 783.91 929.27 784.14 C 929.93 784.53 930.20 784.38 930.75 783.32 C 931.18 782.47 931.16 782.38 930.48 782.07 C 929.64 781.68 928.00 781.51 926.79 781.68 Z M 955.95 781.65 C 955.52 781.73 955.19 781.85 954.92 782.04 C 954.44 782.37 954.26 782.38 953.80 782.06 C 953.41 781.79 953.41 781.79 951.95 781.76 C 949.86 781.74 949.81 781.76 949.69 783.18 C 949.65 783.61 949.53 784.36 949.41 784.84 C 949.29 785.33 949.13 786.13 949.06 786.64 C 948.99 787.14 948.84 788.01 948.75 788.56 C 948.46 790.17 948.48 790.19 950.60 790.19 C 952.46 790.19 952.30 790.32 952.71 788.46 C 952.82 787.96 952.94 787.36 952.96 787.13 C 953.13 785.56 953.46 784.91 954.10 784.91 C 954.83 784.91 954.93 785.36 954.62 787.06 C 954.17 789.36 954.15 789.79 954.43 790.05 C 954.67 790.28 957.55 790.26 957.82 790.03 C 958.03 789.84 958.51 788.18 958.59 787.30 C 958.62 787.05 958.74 786.40 958.85 785.86 C 959.50 782.89 958.35 781.22 955.95 781.65 Z M 920.08 781.74 C 919.17 781.84 918.97 782.24 918.69 784.49 C 918.65 784.86 918.52 785.62 918.41 786.18 C 917.56 790.55 917.44 790.19 919.74 790.19 C 921.76 790.19 921.77 790.18 921.96 788.61 C 922.02 788.06 922.16 787.19 922.27 786.67 C 922.39 786.15 922.50 785.52 922.52 785.27 C 922.55 785.01 922.65 784.46 922.73 784.04 C 923.05 782.50 923.03 782.01 922.64 781.82 C 922.42 781.71 920.80 781.67 920.08 781.74 Z M 944.49 786.40 C 943.34 786.73 942.70 788.11 943.22 789.17 C 944.10 790.95 946.50 790.80 947.42 788.91 C 948.22 787.30 946.50 785.84 944.49 786.40 Z",
      "fill": "#ffffff",
      "role": "warfish-logo"
    }
  ],
  "id": "normulli-sector",
  "name": "Normulli Sector",
  "specialRules": [
    "Up to 6 players, each dealt one of the six outer mesas (spread as evenly round the ring as the count allows), starting with 7 troops on its crystal. Unused bases stay neutral.",
    "Neutral garrisons: each outer mesa's two gates 20, warp crystals 8, home crystals 7, field crystals 5, towers 3, plains and middle gates 2, every other mesa space 1.",
    "Bonuses: a whole mesa (its wedges and core) +8; each crystal and warp crystal +5; each tower +1.",
    "Towers are the red crosses on the mesa frames; they attack two territories away into the plains (one-way).",
    "Plains attack towers at 5 v 7 (a 5-sided die against a 7-sided die).",
    "Crystals (cyan) and warp crystals (green) defend with 4-sided dice.",
    "The three warp crystals are linked to each other, and attack each other at 5 v 7."
  ],
  "legacy": "warfish",
  "addedOn": "2026-11-02",
  "backgroundImage": "normulli-sector",
  "wallsOverlay": "normulli-sector-lines",
  "opaqueTerritoryFills": true,
  "hideAdjacencyLines": true,
  "greyArtInRegionView": true,
  "regionBordersInArt": true,
  "viewBox": {
    "x": 0,
    "y": 0,
    "width": 1252,
    "height": 1043
  },
  "edgeConfig": {
    "internalBorderWidth": 2,
    "regionBorderWidth": 4,
    "bridgeStrokeWidth": 0
  },
  "selectionInnerGlow": true,
  "backdropColor": {
    "light": "#d9d9d6",
    "dark": "#2a2826",
    "topBar": true
  },
  "gameLayout": {
    "playerBarPosition": "right"
  },
  "fitTroopBadges": true,
  "fixedSetup": {
    "playerCount": 6,
    "minPlayers": 2,
    "areas": [
      {
        "id": "halcyon",
        "armies": {
          "halcyon-crystal": 7
        }
      },
      {
        "id": "zenith",
        "armies": {
          "zenith-crystal": 7
        }
      },
      {
        "id": "corona",
        "armies": {
          "corona-crystal": 7
        }
      },
      {
        "id": "penumbra",
        "armies": {
          "penumbra-crystal": 7
        }
      },
      {
        "id": "nadir",
        "armies": {
          "nadir-crystal": 7
        }
      },
      {
        "id": "umbra",
        "armies": {
          "umbra-crystal": 7
        }
      }
    ],
    "seating": "ring",
    "seatPlans": {
      "4": [
        [
          0,
          2,
          3,
          5
        ]
      ],
      "5": [
        [
          0,
          2,
          3,
          4,
          5
        ],
        [
          0,
          1,
          2,
          3,
          5
        ]
      ]
    },
    "neutralArmies": 1,
    "neutralOverrides": {
      "argent-basin": 2,
      "argent-expanse": 2,
      "argent-reach": 2,
      "ashen-dunes": 2,
      "ashen-flats": 2,
      "ashen-reach": 2,
      "ashen-ridge": 2,
      "aster-crystal": 5,
      "basalt-basin": 2,
      "basalt-shelf": 2,
      "basalt-steppe": 2,
      "basalt-waste": 2,
      "beryl-ene-tower": 3,
      "beryl-ese-tower": 3,
      "beryl-n-gate": 2,
      "beryl-s-gate": 2,
      "chrome-dunes": 2,
      "chrome-flats": 2,
      "chrome-ridge": 2,
      "cinder-basin": 2,
      "cinder-shelf": 2,
      "cinder-steppe": 2,
      "cobalt-barrens": 2,
      "cobalt-shelf": 2,
      "cobalt-steppe": 2,
      "cobalt-waste": 2,
      "corona-crystal": 7,
      "corona-s-gate": 20,
      "corona-sw-tower": 3,
      "corona-w-gate": 20,
      "dust-barrens": 2,
      "dust-plateau": 2,
      "dust-waste": 2,
      "east-warp": 8,
      "ember-basin": 2,
      "ember-expanse": 2,
      "ember-reach": 2,
      "ember-steppe": 2,
      "flint-drift": 2,
      "flint-hollows": 2,
      "flint-plateau": 2,
      "frost-barrens": 2,
      "frost-shelf": 2,
      "frost-waste": 2,
      "garnet-e-gate": 2,
      "garnet-nne-tower": 3,
      "garnet-sse-tower": 3,
      "ghost-basin": 2,
      "ghost-expanse": 2,
      "ghost-steppe": 2,
      "glass-barrens": 2,
      "glass-plateau": 2,
      "glass-shelf": 2,
      "glass-waste": 2,
      "halcyon-crystal": 7,
      "halcyon-e-gate": 20,
      "halcyon-s-gate": 20,
      "halcyon-se-tower": 3,
      "halo-barrens": 2,
      "halo-plateau": 2,
      "halo-waste": 2,
      "hollow-basin": 2,
      "hollow-expanse": 2,
      "hollow-reach": 2,
      "hollow-ridge": 2,
      "ion-dunes": 2,
      "ion-flats": 2,
      "ion-ridge": 2,
      "ion-scarp": 2,
      "iron-barrens": 2,
      "iron-drift": 2,
      "iron-plateau": 2,
      "jade-reach": 2,
      "jasper-ene-tower": 3,
      "jasper-ese-tower": 3,
      "jasper-nnw-tower": 3,
      "jasper-ssw-tower": 3,
      "lumen-crystal": 5,
      "mica-fields": 2,
      "mica-flats": 2,
      "mica-scarp": 2,
      "nadir-crystal": 7,
      "nadir-n-tower": 3,
      "nadir-ne-gate": 20,
      "nadir-nw-gate": 20,
      "nexus-warp": 8,
      "nova-crystal": 5,
      "ochre-barrens": 2,
      "ochre-drift": 2,
      "ochre-plateau": 2,
      "opal-n-gate": 2,
      "opal-s-gate": 2,
      "ozone-fields": 2,
      "ozone-hollows": 2,
      "ozone-scarp": 2,
      "pale-basin": 2,
      "pale-expanse": 2,
      "pale-shelf": 2,
      "pale-steppe": 2,
      "penumbra-crystal": 7,
      "penumbra-n-gate": 20,
      "penumbra-nw-tower": 3,
      "penumbra-w-gate": 20,
      "quartz-nne-tower": 3,
      "quartz-sse-tower": 3,
      "quartz-wnw-tower": 3,
      "quartz-wsw-tower": 3,
      "quiet-drift": 2,
      "quiet-fields": 2,
      "quiet-hollows": 2,
      "quiet-plateau": 2,
      "rust-shelf": 2,
      "rust-steppe": 2,
      "rust-waste": 2,
      "sable-dunes": 2,
      "sable-flats": 2,
      "sable-scarp": 2,
      "salt-dunes": 2,
      "salt-reach": 2,
      "salt-ridge": 2,
      "shale-drift": 2,
      "shale-fields": 2,
      "shale-hollows": 2,
      "shale-scarp": 2,
      "silica-dunes": 2,
      "silica-fields": 2,
      "silica-flats": 2,
      "silica-scarp": 2,
      "slate-dunes": 2,
      "slate-reach": 2,
      "slate-ridge": 2,
      "static-fields": 2,
      "static-flats": 2,
      "static-hollows": 2,
      "static-scarp": 2,
      "topaz-ene-tower": 3,
      "topaz-ese-tower": 3,
      "topaz-nnw-tower": 3,
      "topaz-ssw-tower": 3,
      "topaz-w-gate": 2,
      "umber-drift": 2,
      "umber-fields": 2,
      "umber-hollows": 2,
      "umbra-crystal": 7,
      "umbra-e-gate": 20,
      "umbra-n-gate": 20,
      "umbra-ne-tower": 3,
      "vapor-expanse": 2,
      "vapor-reach": 2,
      "vapor-ridge": 2,
      "vesper-crystal": 5,
      "west-warp": 8,
      "zenith-crystal": 7,
      "zenith-s-tower": 3,
      "zenith-se-gate": 20,
      "zenith-sw-gate": 20
    }
  },
  "regions": [
    {
      "id": "halcyon-mesa",
      "name": "Halcyon Mesa",
      "bonus": 8,
      "color": "#E04A3A",
      "territoryIds": [
        "halcyon-core",
        "halcyon-e",
        "halcyon-n",
        "halcyon-s",
        "halcyon-se",
        "halcyon-sw",
        "halcyon-w"
      ],
      "shape": "M 12.0 54.0 L 13.0 109.0 L 55.0 147.0 L 114.0 150.0 L 119.7 144.3 L 119.7 132.2 L 122.2 129.7 L 127.2 129.7 L 128.6 128.3 L 127.6 124.3 L 131.2 120.7 L 143.3 120.7 L 147.0 117.0 L 146.0 51.0 L 104.0 13.0 L 55.0 12.0 Z",
      "bonusAnchor": {
        "x": 150.05,
        "y": 37.35
      }
    },
    {
      "id": "zenith-mesa",
      "name": "Zenith Mesa",
      "bonus": 8,
      "color": "#E8A21C",
      "territoryIds": [
        "zenith-core",
        "zenith-ne",
        "zenith-nw",
        "zenith-s",
        "zenith-se",
        "zenith-sw",
        "zenith-w"
      ],
      "shape": "M 592.0 17.0 L 553.0 53.0 L 550.0 108.0 L 564.8 124.2 L 589.0 148.0 L 607.6 150.9 L 611.1 145.7 L 624.9 145.7 L 629.5 151.9 L 647.0 148.0 L 652.0 145.5 L 678.0 119.5 L 683.6 112.6 L 688.0 104.0 L 688.0 53.0 L 671.0 35.0 L 644.0 14.0 L 603.0 12.0 Z",
      "bonusAnchor": {
        "x": 543.11,
        "y": 112.55
      }
    },
    {
      "id": "corona-mesa",
      "name": "Corona Mesa",
      "bonus": 8,
      "color": "#C9C21A",
      "territoryIds": [
        "corona-core",
        "corona-e",
        "corona-n",
        "corona-nw",
        "corona-s",
        "corona-sw",
        "corona-w"
      ],
      "shape": "M 1106.0 53.0 L 1104.0 116.0 L 1108.7 120.7 L 1120.8 120.7 L 1124.3 124.2 L 1124.3 128.2 L 1125.8 129.7 L 1129.8 129.7 L 1133.3 133.2 L 1133.3 145.3 L 1138.0 149.0 L 1200.0 147.0 L 1242.0 108.0 L 1242.0 53.0 L 1202.0 15.0 L 1146.0 15.0 Z",
      "bonusAnchor": {
        "x": 1102.13,
        "y": 36.92
      }
    },
    {
      "id": "penumbra-mesa",
      "name": "Penumbra Mesa",
      "bonus": 8,
      "color": "#2E9E4A",
      "territoryIds": [
        "penumbra-core",
        "penumbra-e",
        "penumbra-n",
        "penumbra-ne",
        "penumbra-nw",
        "penumbra-s",
        "penumbra-w"
      ],
      "shape": "M 1133.3 901.7 L 1133.3 913.8 L 1129.8 917.3 L 1125.8 917.3 L 1124.3 918.8 L 1124.3 922.8 L 1120.8 926.3 L 1108.7 926.3 L 1105.0 931.0 L 1105.0 994.0 L 1144.0 1031.0 L 1186.0 1033.0 L 1208.0 1028.0 L 1240.0 993.0 L 1241.0 939.0 L 1197.0 899.0 L 1138.0 897.0 Z",
      "bonusAnchor": {
        "x": 1100.14,
        "y": 1003.74
      }
    },
    {
      "id": "nadir-mesa",
      "name": "Nadir Mesa",
      "bonus": 8,
      "color": "#2B6FD6",
      "territoryIds": [
        "nadir-core",
        "nadir-e",
        "nadir-n",
        "nadir-ne",
        "nadir-nw",
        "nadir-se",
        "nadir-sw"
      ],
      "shape": "M 564.0 939.0 L 562.0 994.0 L 597.0 1030.0 L 659.0 1030.0 L 692.0 1004.0 L 697.0 994.0 L 700.0 939.0 L 653.0 892.0 L 648.1 892.0 L 646.8 893.3 L 643.8 893.3 L 642.3 894.8 L 642.3 897.9 L 636.8 902.3 L 623.0 901.3 L 618.1 893.3 L 615.1 893.3 L 614.1 892.0 L 609.0 892.0 Z",
      "bonusAnchor": {
        "x": 560.66,
        "y": 934.08
      }
    },
    {
      "id": "umbra-mesa",
      "name": "Umbra Mesa",
      "bonus": 8,
      "color": "#8E44C9",
      "territoryIds": [
        "umbra-core",
        "umbra-e",
        "umbra-n",
        "umbra-ne",
        "umbra-s",
        "umbra-se",
        "umbra-w"
      ],
      "shape": "M 55.0 900.0 L 46.0 903.0 L 11.0 941.0 L 11.0 992.0 L 57.0 1033.0 L 103.0 1033.0 L 147.0 996.0 L 148.0 930.0 L 143.5 926.3 L 130.2 926.3 L 127.7 923.8 L 127.7 918.8 L 126.2 917.3 L 122.2 917.3 L 118.7 913.8 L 118.7 905.9 L 105.0 899.0 Z",
      "bonusAnchor": {
        "x": 147.47,
        "y": 995.06
      }
    },
    {
      "id": "quartz-mesa",
      "name": "Quartz Mesa",
      "bonus": 8,
      "color": "#D9539B",
      "territoryIds": [
        "quartz-core",
        "quartz-e",
        "quartz-n",
        "quartz-ne",
        "quartz-nw",
        "quartz-s",
        "quartz-se",
        "quartz-sw",
        "quartz-w"
      ],
      "shape": "M 137.0 457.0 L 99.3 487.8 L 99.3 495.9 L 94.0 500.1 L 94.0 542.7 L 95.8 542.7 L 99.3 546.2 L 99.3 555.3 L 127.0 581.0 L 138.0 585.0 L 187.7 590.0 L 187.7 588.2 L 192.2 583.7 L 201.3 583.7 L 233.0 551.0 L 233.0 495.0 L 192.6 457.3 L 187.8 456.0 L 187.2 453.1 Z",
      "bonusAnchor": {
        "x": 163.2,
        "y": 521.4
      }
    },
    {
      "id": "beryl-mesa",
      "name": "Beryl Mesa",
      "bonus": 8,
      "color": "#3FA7A0",
      "territoryIds": [
        "beryl-core",
        "beryl-e",
        "beryl-n",
        "beryl-ne",
        "beryl-nw",
        "beryl-s",
        "beryl-se",
        "beryl-sw",
        "beryl-w"
      ],
      "shape": "M 233.0 495.0 L 233.0 551.0 L 273.0 589.0 L 327.0 588.0 L 352.7 568.2 L 352.7 561.1 L 360.7 556.1 L 360.7 553.2 L 364.2 549.7 L 372.0 549.7 L 372.0 494.0 L 371.3 493.3 L 363.1 493.3 L 359.6 488.6 L 360.5 486.7 L 359.2 485.3 L 355.1 485.3 L 351.7 480.7 L 352.1 474.3 L 327.0 455.0 L 275.0 455.0 Z",
      "bonusAnchor": {
        "x": 299.8,
        "y": 521.8
      }
    },
    {
      "id": "garnet-mesa",
      "name": "Garnet Mesa",
      "bonus": 8,
      "color": "#A8322D",
      "territoryIds": [
        "garnet-core",
        "garnet-e",
        "garnet-n",
        "garnet-ne",
        "garnet-nw",
        "garnet-s",
        "garnet-se",
        "garnet-sw",
        "garnet-w"
      ],
      "shape": "M 416.0 457.0 L 406.0 461.0 L 390.3 476.2 L 390.3 483.0 L 382.3 487.0 L 382.3 490.8 L 379.8 493.3 L 372.7 493.3 L 372.0 494.0 L 372.0 549.7 L 378.9 549.7 L 383.6 555.6 L 382.6 556.5 L 383.8 557.7 L 386.9 557.7 L 391.3 563.2 L 390.8 570.6 L 409.0 586.0 L 466.6 591.0 L 470.1 585.7 L 479.3 585.7 L 511.0 553.0 L 510.0 492.0 L 478.3 457.3 L 470.1 457.3 L 466.6 452.0 Z",
      "bonusAnchor": {
        "x": 443.6,
        "y": 522.2
      }
    },
    {
      "id": "topaz-mesa",
      "name": "Topaz Mesa",
      "bonus": 8,
      "color": "#C77D2A",
      "territoryIds": [
        "topaz-core",
        "topaz-e",
        "topaz-n",
        "topaz-ne",
        "topaz-nw",
        "topaz-s",
        "topaz-se",
        "topaz-sw",
        "topaz-w"
      ],
      "shape": "M 746.0 493.0 L 745.0 553.0 L 774.7 584.7 L 782.9 584.7 L 787.0 590.9 L 788.9 591.8 L 839.0 587.0 L 862.2 571.5 L 861.7 564.2 L 866.1 558.7 L 869.2 558.7 L 870.7 557.2 L 870.7 554.2 L 874.2 550.7 L 882.0 550.7 L 883.0 494.3 L 874.1 494.3 L 869.1 486.3 L 866.2 486.3 L 861.7 481.8 L 862.2 474.5 L 850.0 463.0 L 840.0 459.0 L 788.3 453.0 L 788.3 454.8 L 783.8 459.3 L 776.7 459.3 Z",
      "bonusAnchor": {
        "x": 811.4,
        "y": 522.7
      }
    },
    {
      "id": "opal-mesa",
      "name": "Opal Mesa",
      "bonus": 8,
      "color": "#6C7BD8",
      "territoryIds": [
        "opal-core",
        "opal-e",
        "opal-n",
        "opal-ne",
        "opal-nw",
        "opal-s",
        "opal-se",
        "opal-sw",
        "opal-w"
      ],
      "shape": "M 900.3 478.0 L 900.3 482.9 L 892.3 487.9 L 892.3 490.9 L 887.8 494.3 L 883.0 494.3 L 882.0 550.7 L 888.9 550.7 L 893.9 558.7 L 896.8 558.7 L 901.3 563.2 L 900.8 570.5 L 928.0 589.0 L 979.0 589.0 L 1022.0 548.0 L 1022.0 497.0 L 983.0 457.0 L 924.0 456.0 Z",
      "bonusAnchor": {
        "x": 953.2,
        "y": 522.8
      }
    },
    {
      "id": "jasper-mesa",
      "name": "Jasper Mesa",
      "bonus": 8,
      "color": "#7A9B2F",
      "territoryIds": [
        "jasper-core",
        "jasper-e",
        "jasper-n",
        "jasper-ne",
        "jasper-nw",
        "jasper-s",
        "jasper-se",
        "jasper-sw",
        "jasper-w"
      ],
      "shape": "M 1022.0 497.0 L 1022.0 548.0 L 1054.3 585.7 L 1061.9 585.7 L 1064.4 589.5 L 1118.0 588.0 L 1154.7 560.2 L 1154.7 550.2 L 1159.2 545.7 L 1161.0 545.7 L 1162.0 543.7 L 1162.0 500.8 L 1161.1 499.3 L 1158.2 499.3 L 1154.7 495.8 L 1154.7 486.8 L 1119.0 459.0 L 1066.1 456.1 L 1061.8 460.3 L 1054.7 460.3 Z",
      "bonusAnchor": {
        "x": 1091.7,
        "y": 523.4
      }
    },
    {
      "id": "aster-crystal",
      "name": "Aster Crystal",
      "bonus": 5,
      "color": "#19B6E6",
      "territoryIds": [
        "aster-crystal"
      ],
      "shape": "M 863.5 378.5 L 860.5 382.5 L 864.5 394.5 L 861.5 397.5 L 849.5 400.5 L 847.5 402.5 L 860.5 408.5 L 864.5 412.5 L 863.5 419.5 L 873.5 418.5 L 882.5 426.5 L 887.5 417.5 L 896.5 416.5 L 893.5 406.5 L 902.5 397.5 L 895.5 395.5 L 890.5 391.5 L 890.5 379.5 L 887.5 376.5 L 877.5 388.5 Z",
      "bonusAnchor": {
        "x": 896.07,
        "y": 355.23
      }
    },
    {
      "id": "corona-crystal",
      "name": "Corona Crystal",
      "bonus": 5,
      "color": "#19B6E6",
      "territoryIds": [
        "corona-crystal"
      ],
      "shape": "M 1208.5 31.5 L 1205.5 34.5 L 1202.5 48.5 L 1191.5 54.5 L 1196.5 60.5 L 1193.5 70.5 L 1204.5 76.5 L 1205.5 88.5 L 1209.5 92.5 L 1213.5 83.5 L 1217.5 79.5 L 1226.5 85.5 L 1229.5 84.5 L 1227.5 68.5 L 1232.5 61.5 L 1225.5 54.5 L 1225.5 48.5 L 1218.5 47.5 Z",
      "bonusAnchor": {
        "x": 1219.03,
        "y": 114.68
      }
    },
    {
      "id": "halcyon-crystal",
      "name": "Halcyon Crystal",
      "bonus": 5,
      "color": "#19B6E6",
      "territoryIds": [
        "halcyon-crystal"
      ],
      "shape": "M 55.5 20.5 L 52.5 26.5 L 43.5 32.5 L 43.5 38.5 L 28.5 50.5 L 30.5 52.5 L 45.5 53.5 L 50.5 61.5 L 57.5 59.5 L 67.5 62.5 L 68.5 57.5 L 72.5 52.5 L 81.5 50.5 L 85.5 47.5 L 73.5 38.5 L 80.5 27.5 L 77.5 24.5 L 64.5 28.5 Z",
      "bonusAnchor": {
        "x": 21.36,
        "y": 69.14
      }
    },
    {
      "id": "lumen-crystal",
      "name": "Lumen Crystal",
      "bonus": 5,
      "color": "#19B6E6",
      "territoryIds": [
        "lumen-crystal"
      ],
      "shape": "M 380.5 373.5 L 370.5 386.5 L 356.5 377.5 L 353.5 380.5 L 359.5 395.5 L 349.5 404.5 L 361.5 411.5 L 361.5 420.5 L 370.5 418.5 L 379.5 423.5 L 385.5 416.5 L 398.5 417.5 L 401.5 414.5 L 386.5 402.5 L 391.5 394.5 L 384.5 389.5 L 383.5 376.5 Z",
      "bonusAnchor": {
        "x": 350.13,
        "y": 357.87
      }
    },
    {
      "id": "nadir-crystal",
      "name": "Nadir Crystal",
      "bonus": 5,
      "color": "#19B6E6",
      "territoryIds": [
        "nadir-crystal"
      ],
      "shape": "M 583.5 1000.5 L 598.5 1009.5 L 597.5 1017.5 L 608.5 1019.5 L 613.5 1024.5 L 620.5 1018.5 L 635.5 1019.5 L 637.5 1017.5 L 629.5 1006.5 L 638.5 998.5 L 636.5 996.5 L 626.5 995.5 L 621.5 988.5 L 612.5 988.5 L 599.5 979.5 L 597.5 981.5 L 599.5 993.5 L 596.5 996.5 L 586.5 997.5 Z",
      "bonusAnchor": {
        "x": 660.57,
        "y": 1004.65
      }
    },
    {
      "id": "nova-crystal",
      "name": "Nova Crystal",
      "bonus": 5,
      "color": "#19B6E6",
      "territoryIds": [
        "nova-crystal"
      ],
      "shape": "M 884.5 616.5 L 876.5 622.5 L 866.5 619.5 L 865.5 626.5 L 861.5 630.5 L 858.5 629.5 L 854.5 631.5 L 851.5 629.5 L 846.5 634.5 L 849.5 637.5 L 864.5 640.5 L 867.5 643.5 L 861.5 653.5 L 865.5 657.5 L 872.5 652.5 L 876.5 656.5 L 883.5 670.5 L 886.5 667.5 L 887.5 653.5 L 890.5 650.5 L 901.5 649.5 L 894.5 637.5 L 907.5 626.5 L 904.5 623.5 L 889.5 625.5 Z",
      "bonusAnchor": {
        "x": 911.21,
        "y": 655.2
      }
    },
    {
      "id": "penumbra-crystal",
      "name": "Penumbra Crystal",
      "bonus": 5,
      "color": "#19B6E6",
      "territoryIds": [
        "penumbra-crystal"
      ],
      "shape": "M 1217.5 993.5 L 1215.5 991.5 L 1204.5 992.5 L 1197.5 984.5 L 1190.5 989.5 L 1181.5 988.5 L 1180.5 994.5 L 1177.5 997.5 L 1167.5 1000.5 L 1164.5 1003.5 L 1174.5 1007.5 L 1178.5 1011.5 L 1175.5 1020.5 L 1177.5 1024.5 L 1190.5 1019.5 L 1198.5 1024.5 L 1206.5 1014.5 L 1211.5 1013.5 L 1208.5 1003.5 Z",
      "bonusAnchor": {
        "x": 1230.41,
        "y": 978.19
      }
    },
    {
      "id": "umbra-crystal",
      "name": "Umbra Crystal",
      "bonus": 5,
      "color": "#19B6E6",
      "territoryIds": [
        "umbra-crystal"
      ],
      "shape": "M 46.5 949.5 L 36.5 961.5 L 26.5 955.5 L 22.5 957.5 L 26.5 971.5 L 19.5 978.5 L 24.5 984.5 L 23.5 994.5 L 26.5 996.5 L 35.5 993.5 L 44.5 1007.5 L 47.5 1004.5 L 48.5 994.5 L 51.5 991.5 L 61.5 991.5 L 55.5 979.5 L 56.5 970.5 L 49.5 965.5 L 49.5 952.5 Z",
      "bonusAnchor": {
        "x": 31.14,
        "y": 926.14
      }
    },
    {
      "id": "vesper-crystal",
      "name": "Vesper Crystal",
      "bonus": 5,
      "color": "#19B6E6",
      "territoryIds": [
        "vesper-crystal"
      ],
      "shape": "M 371.5 615.5 L 365.5 623.5 L 356.5 624.5 L 359.5 635.5 L 350.5 643.5 L 361.5 649.5 L 361.5 662.5 L 364.5 665.5 L 374.5 653.5 L 384.5 663.5 L 387.5 660.5 L 386.5 647.5 L 389.5 644.5 L 400.5 643.5 L 403.5 640.5 L 402.5 638.5 L 393.5 635.5 L 386.5 630.5 L 388.5 622.5 L 379.5 623.5 Z",
      "bonusAnchor": {
        "x": 349.31,
        "y": 672.94
      }
    },
    {
      "id": "zenith-crystal",
      "name": "Zenith Crystal",
      "bonus": 5,
      "color": "#19B6E6",
      "territoryIds": [
        "zenith-crystal"
      ],
      "shape": "M 619.5 24.5 L 617.5 27.5 L 624.5 41.5 L 614.5 50.5 L 617.5 53.5 L 625.5 53.5 L 630.5 60.5 L 640.5 60.5 L 651.5 69.5 L 654.5 66.5 L 652.5 58.5 L 655.5 55.5 L 667.5 55.5 L 670.5 52.5 L 654.5 39.5 L 655.5 33.5 L 649.5 31.5 L 639.5 20.5 L 633.5 29.5 Z",
      "bonusAnchor": {
        "x": 693.44,
        "y": 46.71
      }
    },
    {
      "id": "east-warp",
      "name": "Eastrift Warp",
      "bonus": 5,
      "color": "#2E9B3A",
      "territoryIds": [
        "east-warp"
      ],
      "shape": "M 1252.9 518.9 L 1250.0 509.0 L 1242.0 498.1 L 1230.3 491.1 L 1216.8 489.2 L 1203.6 492.7 L 1192.9 501.0 L 1186.2 512.9 L 1184.6 526.4 L 1188.5 539.6 L 1197.3 550.2 L 1209.5 556.6 L 1223.2 557.6 L 1236.2 553.2 L 1246.5 544.0 L 1252.3 531.5 Z",
      "bonusAnchor": {
        "x": 1224.33,
        "y": 565.46
      }
    },
    {
      "id": "nexus-warp",
      "name": "Nexus Warp",
      "bonus": 5,
      "color": "#2E9B3A",
      "territoryIds": [
        "nexus-warp"
      ],
      "shape": "M 665.8 523.0 L 663.2 509.6 L 658.2 500.6 L 653.8 495.4 L 642.5 487.6 L 632.7 484.6 L 625.9 484.0 L 615.7 485.3 L 609.2 487.7 L 603.2 491.0 L 595.6 497.9 L 591.6 503.4 L 587.5 512.9 L 586.0 526.5 L 589.1 539.8 L 594.4 548.7 L 599.1 553.7 L 604.6 557.9 L 614.0 562.2 L 627.6 563.9 L 641.0 561.0 L 647.1 557.9 L 655.1 551.3 L 661.1 542.9 L 663.8 536.6 Z",
      "bonusAnchor": {
        "x": 626.09,
        "y": 570.87
      }
    },
    {
      "id": "west-warp",
      "name": "Westrift Warp",
      "bonus": 5,
      "color": "#2E9B3A",
      "territoryIds": [
        "west-warp"
      ],
      "shape": "M 5.3 523.0 L 6.2 529.9 L 8.7 536.4 L 15.0 544.7 L 23.7 550.4 L 37.3 552.8 L 47.5 550.4 L 56.2 544.7 L 62.5 536.4 L 65.0 529.9 L 65.9 523.0 L 64.3 512.8 L 57.2 501.2 L 45.7 493.9 L 35.6 492.2 L 22.3 495.2 L 13.9 501.2 L 8.1 509.7 Z",
      "bonusAnchor": {
        "x": 35.59,
        "y": 561.66
      }
    },
    {
      "id": "beryl-ene-tower",
      "name": "Beryl East-Northeast Tower",
      "bonus": 1,
      "color": "#E02424",
      "territoryIds": [
        "beryl-ene-tower"
      ],
      "shape": "M 365.5 455.5 L 361.5 458.5 L 358.5 464.5 L 355.5 464.5 L 353.5 466.5 L 352.5 480.5 L 355.5 484.5 L 359.5 484.5 L 361.5 486.5 L 360.5 488.5 L 363.5 492.5 L 379.5 492.5 L 381.5 490.5 L 381.5 486.5 L 389.5 482.5 L 389.5 466.5 L 385.5 464.5 L 377.5 455.5 Z",
      "bonusAnchor": {
        "x": 395.25,
        "y": 454.03
      }
    },
    {
      "id": "beryl-ese-tower",
      "name": "Beryl East-Southeast Tower",
      "bonus": 1,
      "color": "#E02424",
      "territoryIds": [
        "beryl-ese-tower"
      ],
      "shape": "M 364.5 550.5 L 361.5 553.5 L 361.5 556.5 L 353.5 561.5 L 353.5 576.5 L 356.5 579.5 L 358.5 579.5 L 364.5 587.5 L 378.5 587.5 L 382.5 581.5 L 389.5 576.5 L 390.5 563.5 L 386.5 558.5 L 383.5 558.5 L 381.5 556.5 L 382.5 555.5 L 378.5 550.5 Z",
      "bonusAnchor": {
        "x": 401.77,
        "y": 583.06
      }
    },
    {
      "id": "corona-sw-tower",
      "name": "Corona Southwest Tower",
      "bonus": 1,
      "color": "#E02424",
      "territoryIds": [
        "corona-sw-tower"
      ],
      "shape": "M 1107.5 121.5 L 1103.5 125.5 L 1103.5 127.5 L 1095.5 133.5 L 1095.5 146.5 L 1099.5 150.5 L 1101.5 150.5 L 1107.5 158.5 L 1120.5 158.5 L 1124.5 154.5 L 1124.5 152.5 L 1132.5 146.5 L 1132.5 133.5 L 1129.5 130.5 L 1125.5 130.5 L 1123.5 128.5 L 1123.5 124.5 L 1120.5 121.5 Z",
      "bonusAnchor": {
        "x": 1115.48,
        "y": 182.27
      }
    },
    {
      "id": "garnet-nne-tower",
      "name": "Garnet North-Northeast Tower",
      "bonus": 1,
      "color": "#E02424",
      "territoryIds": [
        "garnet-nne-tower"
      ],
      "shape": "M 470.5 419.5 L 466.5 423.5 L 466.5 425.5 L 458.5 431.5 L 458.5 443.5 L 462.5 448.5 L 466.5 450.5 L 470.5 456.5 L 484.5 456.5 L 487.5 453.5 L 487.5 450.5 L 495.5 445.5 L 495.5 430.5 L 492.5 427.5 L 489.5 427.5 L 484.5 419.5 Z",
      "bonusAnchor": {
        "x": 477.74,
        "y": 407.3
      }
    },
    {
      "id": "garnet-sse-tower",
      "name": "Garnet South-Southeast Tower",
      "bonus": 1,
      "color": "#E02424",
      "territoryIds": [
        "garnet-sse-tower"
      ],
      "shape": "M 470.5 586.5 L 466.5 592.5 L 458.5 598.5 L 458.5 611.5 L 462.5 615.5 L 464.5 615.5 L 470.5 623.5 L 484.5 623.5 L 487.5 620.5 L 487.5 617.5 L 495.5 612.5 L 495.5 597.5 L 492.5 594.5 L 489.5 594.5 L 484.5 586.5 Z",
      "bonusAnchor": {
        "x": 474.84,
        "y": 640
      }
    },
    {
      "id": "halcyon-se-tower",
      "name": "Halcyon Southeast Tower",
      "bonus": 1,
      "color": "#E02424",
      "territoryIds": [
        "halcyon-se-tower"
      ],
      "shape": "M 131.5 121.5 L 128.5 124.5 L 129.5 128.5 L 127.5 130.5 L 122.5 130.5 L 120.5 132.5 L 120.5 147.5 L 127.5 152.5 L 130.5 158.5 L 145.5 158.5 L 148.5 156.5 L 148.5 152.5 L 155.5 148.5 L 156.5 132.5 L 153.5 129.5 L 150.5 129.5 L 148.5 127.5 L 148.5 124.5 L 144.5 121.5 Z",
      "bonusAnchor": {
        "x": 139.69,
        "y": 180.61
      }
    },
    {
      "id": "jasper-ene-tower",
      "name": "Jasper East-Northeast Tower",
      "bonus": 1,
      "color": "#E02424",
      "territoryIds": [
        "jasper-ene-tower"
      ],
      "shape": "M 1167.5 469.5 L 1163.5 473.5 L 1163.5 475.5 L 1155.5 481.5 L 1155.5 495.5 L 1158.5 498.5 L 1161.5 498.5 L 1166.5 506.5 L 1181.5 506.5 L 1184.5 503.5 L 1184.5 500.5 L 1192.5 495.5 L 1192.5 481.5 L 1188.5 477.5 L 1186.5 477.5 L 1180.5 469.5 Z",
      "bonusAnchor": {
        "x": 1174.55,
        "y": 451.39
      }
    },
    {
      "id": "jasper-ese-tower",
      "name": "Jasper East-Southeast Tower",
      "bonus": 1,
      "color": "#E02424",
      "territoryIds": [
        "jasper-ese-tower"
      ],
      "shape": "M 1168.5 538.5 L 1163.5 542.5 L 1161.5 546.5 L 1159.5 546.5 L 1155.5 550.5 L 1155.5 563.5 L 1158.5 567.5 L 1161.5 567.5 L 1163.5 569.5 L 1163.5 572.5 L 1166.5 575.5 L 1181.5 575.5 L 1184.5 572.5 L 1184.5 569.5 L 1192.5 564.5 L 1192.5 550.5 L 1188.5 546.5 L 1186.5 546.5 L 1180.5 538.5 Z",
      "bonusAnchor": {
        "x": 1174.34,
        "y": 593.65
      }
    },
    {
      "id": "jasper-nnw-tower",
      "name": "Jasper North-Northwest Tower",
      "bonus": 1,
      "color": "#E02424",
      "territoryIds": [
        "jasper-nnw-tower"
      ],
      "shape": "M 1048.5 422.5 L 1044.5 426.5 L 1044.5 428.5 L 1036.5 434.5 L 1036.5 447.5 L 1040.5 451.5 L 1042.5 451.5 L 1048.5 459.5 L 1061.5 459.5 L 1065.5 455.5 L 1065.5 453.5 L 1073.5 447.5 L 1073.5 434.5 L 1069.5 430.5 L 1067.5 430.5 L 1061.5 422.5 Z",
      "bonusAnchor": {
        "x": 1054.97,
        "y": 409.44
      }
    },
    {
      "id": "jasper-ssw-tower",
      "name": "Jasper South-Southwest Tower",
      "bonus": 1,
      "color": "#E02424",
      "territoryIds": [
        "jasper-ssw-tower"
      ],
      "shape": "M 1047.5 586.5 L 1044.5 589.5 L 1044.5 592.5 L 1036.5 597.5 L 1036.5 612.5 L 1039.5 615.5 L 1042.5 615.5 L 1047.5 623.5 L 1061.5 623.5 L 1065.5 619.5 L 1065.5 617.5 L 1073.5 611.5 L 1073.5 599.5 L 1069.5 594.5 L 1065.5 592.5 L 1061.5 586.5 Z",
      "bonusAnchor": {
        "x": 1054.3,
        "y": 640.14
      }
    },
    {
      "id": "nadir-n-tower",
      "name": "Nadir North Tower",
      "bonus": 1,
      "color": "#E02424",
      "territoryIds": [
        "nadir-n-tower"
      ],
      "shape": "M 625.5 863.5 L 620.5 867.5 L 618.5 871.5 L 612.5 875.5 L 612.5 888.5 L 615.5 892.5 L 618.5 892.5 L 623.5 900.5 L 636.5 901.5 L 641.5 897.5 L 641.5 894.5 L 643.5 892.5 L 646.5 892.5 L 649.5 889.5 L 649.5 875.5 L 645.5 871.5 L 643.5 871.5 L 638.5 864.5 Z",
      "bonusAnchor": {
        "x": 632.38,
        "y": 838.59
      }
    },
    {
      "id": "penumbra-nw-tower",
      "name": "Penumbra Northwest Tower",
      "bonus": 1,
      "color": "#E02424",
      "territoryIds": [
        "penumbra-nw-tower"
      ],
      "shape": "M 1107.5 888.5 L 1103.5 892.5 L 1103.5 894.5 L 1095.5 900.5 L 1095.5 913.5 L 1099.5 917.5 L 1101.5 917.5 L 1107.5 925.5 L 1120.5 925.5 L 1123.5 922.5 L 1123.5 918.5 L 1125.5 916.5 L 1129.5 916.5 L 1132.5 913.5 L 1132.5 900.5 L 1128.5 896.5 L 1126.5 896.5 L 1120.5 888.5 Z",
      "bonusAnchor": {
        "x": 1114.14,
        "y": 865.36
      }
    },
    {
      "id": "quartz-nne-tower",
      "name": "Quartz North-Northeast Tower",
      "bonus": 1,
      "color": "#E02424",
      "territoryIds": [
        "quartz-nne-tower"
      ],
      "shape": "M 191.5 419.5 L 187.5 422.5 L 187.5 425.5 L 179.5 430.5 L 179.5 445.5 L 180.5 447.5 L 185.5 448.5 L 187.5 450.5 L 188.5 455.5 L 190.5 456.5 L 205.5 456.5 L 207.5 454.5 L 207.5 451.5 L 210.5 448.5 L 213.5 448.5 L 216.5 444.5 L 216.5 431.5 L 210.5 427.5 L 204.5 419.5 Z",
      "bonusAnchor": {
        "x": 219.41,
        "y": 410.96
      }
    },
    {
      "id": "quartz-sse-tower",
      "name": "Quartz South-Southeast Tower",
      "bonus": 1,
      "color": "#E02424",
      "territoryIds": [
        "quartz-sse-tower"
      ],
      "shape": "M 192.5 584.5 L 188.5 588.5 L 188.5 590.5 L 180.5 596.5 L 180.5 609.5 L 184.5 613.5 L 186.5 613.5 L 192.5 621.5 L 205.5 621.5 L 209.5 617.5 L 209.5 615.5 L 217.5 609.5 L 217.5 596.5 L 213.5 592.5 L 211.5 592.5 L 205.5 584.5 Z",
      "bonusAnchor": {
        "x": 218.28,
        "y": 638.14
      }
    },
    {
      "id": "quartz-wnw-tower",
      "name": "Quartz West-Northwest Tower",
      "bonus": 1,
      "color": "#E02424",
      "territoryIds": [
        "quartz-wnw-tower"
      ],
      "shape": "M 75.5 469.5 L 69.5 473.5 L 69.5 476.5 L 67.5 478.5 L 64.5 478.5 L 61.5 481.5 L 61.5 495.5 L 65.5 499.5 L 67.5 499.5 L 72.5 506.5 L 84.5 507.5 L 90.5 503.5 L 90.5 500.5 L 92.5 498.5 L 93.5 499.5 L 98.5 495.5 L 98.5 481.5 L 95.5 478.5 L 93.5 478.5 L 87.5 470.5 Z",
      "bonusAnchor": {
        "x": 101.58,
        "y": 465.19
      }
    },
    {
      "id": "quartz-wsw-tower",
      "name": "Quartz West-Southwest Tower",
      "bonus": 1,
      "color": "#E02424",
      "territoryIds": [
        "quartz-wsw-tower"
      ],
      "shape": "M 74.5 534.5 L 69.5 538.5 L 67.5 542.5 L 61.5 546.5 L 61.5 560.5 L 67.5 564.5 L 72.5 571.5 L 85.5 572.5 L 90.5 568.5 L 90.5 566.5 L 93.5 563.5 L 95.5 563.5 L 98.5 560.5 L 98.5 546.5 L 95.5 543.5 L 92.5 543.5 L 87.5 535.5 Z",
      "bonusAnchor": {
        "x": 99.06,
        "y": 579.35
      }
    },
    {
      "id": "topaz-ene-tower",
      "name": "Topaz East-Northeast Tower",
      "bonus": 1,
      "color": "#E02424",
      "territoryIds": [
        "topaz-ene-tower"
      ],
      "shape": "M 874.5 456.5 L 870.5 462.5 L 863.5 467.5 L 862.5 481.5 L 866.5 485.5 L 869.5 485.5 L 874.5 493.5 L 887.5 493.5 L 891.5 490.5 L 891.5 487.5 L 899.5 482.5 L 899.5 467.5 L 896.5 464.5 L 894.5 464.5 L 888.5 456.5 Z",
      "bonusAnchor": {
        "x": 912.46,
        "y": 456.78
      }
    },
    {
      "id": "topaz-ese-tower",
      "name": "Topaz East-Southeast Tower",
      "bonus": 1,
      "color": "#E02424",
      "territoryIds": [
        "topaz-ese-tower"
      ],
      "shape": "M 874.5 551.5 L 871.5 554.5 L 871.5 557.5 L 869.5 559.5 L 866.5 559.5 L 862.5 564.5 L 863.5 577.5 L 866.5 580.5 L 868.5 580.5 L 874.5 588.5 L 888.5 588.5 L 892.5 582.5 L 899.5 577.5 L 900.5 563.5 L 896.5 559.5 L 893.5 559.5 L 888.5 551.5 Z",
      "bonusAnchor": {
        "x": 915.42,
        "y": 585
      }
    },
    {
      "id": "topaz-nnw-tower",
      "name": "Topaz North-Northwest Tower",
      "bonus": 1,
      "color": "#E02424",
      "territoryIds": [
        "topaz-nnw-tower"
      ],
      "shape": "M 770.5 421.5 L 766.5 425.5 L 766.5 427.5 L 758.5 433.5 L 758.5 446.5 L 762.5 450.5 L 764.5 450.5 L 770.5 458.5 L 783.5 458.5 L 787.5 454.5 L 787.5 452.5 L 795.5 446.5 L 795.5 433.5 L 791.5 429.5 L 789.5 429.5 L 783.5 421.5 Z",
      "bonusAnchor": {
        "x": 777.97,
        "y": 407.62
      }
    },
    {
      "id": "topaz-ssw-tower",
      "name": "Topaz South-Southwest Tower",
      "bonus": 1,
      "color": "#E02424",
      "territoryIds": [
        "topaz-ssw-tower"
      ],
      "shape": "M 768.5 585.5 L 765.5 588.5 L 765.5 591.5 L 757.5 596.5 L 757.5 611.5 L 760.5 614.5 L 763.5 614.5 L 768.5 622.5 L 782.5 622.5 L 786.5 618.5 L 786.5 616.5 L 794.5 610.5 L 794.5 598.5 L 790.5 593.5 L 786.5 591.5 L 782.5 585.5 Z",
      "bonusAnchor": {
        "x": 774.36,
        "y": 641.58
      }
    },
    {
      "id": "umbra-ne-tower",
      "name": "Umbra Northeast Tower",
      "bonus": 1,
      "color": "#E02424",
      "territoryIds": [
        "umbra-ne-tower"
      ],
      "shape": "M 131.5 888.5 L 127.5 892.5 L 127.5 894.5 L 119.5 900.5 L 119.5 913.5 L 122.5 916.5 L 126.5 916.5 L 128.5 918.5 L 128.5 923.5 L 130.5 925.5 L 145.5 925.5 L 148.5 922.5 L 148.5 919.5 L 156.5 913.5 L 156.5 900.5 L 152.5 896.5 L 150.5 896.5 L 144.5 888.5 Z",
      "bonusAnchor": {
        "x": 138.66,
        "y": 862.36
      }
    },
    {
      "id": "zenith-s-tower",
      "name": "Zenith South Tower",
      "bonus": 1,
      "color": "#E02424",
      "territoryIds": [
        "zenith-s-tower"
      ],
      "shape": "M 611.5 146.5 L 607.5 152.5 L 599.5 158.5 L 599.5 172.5 L 602.5 175.5 L 605.5 175.5 L 607.5 177.5 L 607.5 180.5 L 611.5 183.5 L 625.5 183.5 L 628.5 180.5 L 628.5 177.5 L 636.5 172.5 L 636.5 158.5 L 632.5 154.5 L 630.5 154.5 L 624.5 146.5 Z",
      "bonusAnchor": {
        "x": 617.8,
        "y": 203.98
      }
    }
  ],
  "territories": [
    {
      "id": "argent-basin",
      "name": "Argent Basin",
      "shape": "M 174.7 862.3 L 168.3 859.2 L 160.6 855.9 L 152.3 852.7 L 149.0 850.0 L 143.7 849.8 L 138.2 848.8 L 133.5 848.0 L 127.0 848.5 L 121.0 849.0 L 111.0 885.0 L 110.2 886.9 L 121.0 896.1 L 116.2 901.0 L 119.5 901.0 L 119.5 900.5 L 121.5 899.0 L 127.5 894.5 L 127.5 892.5 L 131.5 888.5 L 144.5 888.5 L 150.5 896.5 L 152.5 896.5 L 156.5 900.5 L 156.5 913.5 L 148.5 919.5 L 148.5 922.5 L 146.0 925.0 L 145.5 925.5 L 144.0 925.5 L 144.0 927.3 L 146.0 928.0 L 148.0 930.0 L 154.6 931.4 L 161.4 932.8 L 170.6 930.6 L 179.9 927.6 L 184.6 927.1 L 189.8 925.8 L 193.0 924.0 L 195.0 909.0 L 195.0 902.0 L 194.9 895.6 L 193.7 886.8 L 191.3 879.7 L 186.7 871.8 L 186.0 869.0 L 180.2 865.8 Z",
      "position": {
        "x": 169.1,
        "y": 883.7
      },
      "badgeAnchor": {
        "x": 169.1,
        "y": 883.7
      },
      "badgeRadius": 20.8,
      "adjacencies": [
        "chrome-ridge",
        "dust-plateau",
        "flint-hollows",
        "umbra-e-gate",
        "umbra-n-gate",
        "umbra-ne-tower",
        "vapor-expanse"
      ],
      "borderDice": {
        "umbra-ne-tower": {
          "attack": 5
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "argent-expanse",
      "name": "Argent Expanse",
      "shape": "M 449.0 624.0 L 440.1 624.1 L 430.6 626.1 L 425.5 629.0 L 420.0 632.0 L 388.0 630.0 L 388.0 628.0 L 387.1 627.9 L 386.5 630.5 L 393.5 635.5 L 402.5 638.5 L 403.5 640.5 L 400.5 643.5 L 389.5 644.5 L 386.5 647.5 L 387.5 660.5 L 384.5 663.5 L 374.5 653.5 L 364.5 665.5 L 361.5 662.5 L 361.5 649.5 L 350.5 643.5 L 359.5 635.5 L 359.4 635.2 L 344.0 640.0 L 344.6 645.4 L 345.8 650.6 L 344.0 654.0 L 282.0 654.0 L 288.0 668.0 L 286.0 675.0 L 321.0 699.0 L 326.8 698.8 L 331.3 697.3 L 336.3 693.3 L 341.0 690.0 L 382.0 689.0 L 387.3 693.2 L 389.4 698.6 L 390.7 704.3 L 395.0 710.0 L 413.0 712.0 L 413.9 717.5 L 413.0 724.0 L 419.3 727.7 L 426.4 731.1 L 431.0 732.0 L 433.8 724.3 L 434.0 717.5 L 433.0 711.0 L 433.1 703.6 L 434.3 697.8 L 436.0 692.0 L 440.3 687.3 L 445.0 684.0 L 457.0 684.0 L 461.4 680.9 L 464.0 678.0 L 468.0 640.0 L 453.0 637.0 Z",
      "position": {
        "x": 420.3,
        "y": 665.7
      },
      "badgeAnchor": {
        "x": 420.3,
        "y": 665.7
      },
      "badgeRadius": 29.4,
      "adjacencies": [
        "beryl-s-gate",
        "cobalt-waste",
        "flint-drift",
        "frost-barrens",
        "ion-dunes",
        "silica-flats",
        "umber-hollows",
        "vesper-crystal"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "argent-reach",
      "name": "Argent Reach",
      "shape": "M 203.8 214.7 L 202.0 210.0 L 171.0 212.0 L 163.8 207.2 L 156.8 201.2 L 153.9 198.1 L 153.0 195.0 L 145.5 196.0 L 137.5 197.0 L 130.4 197.9 L 122.0 197.0 L 124.0 210.0 L 43.0 210.0 L 42.6 213.6 L 40.2 220.2 L 38.2 227.2 L 38.0 236.0 L 52.0 249.0 L 54.8 257.2 L 55.0 266.0 L 49.2 273.2 L 44.2 277.2 L 38.5 281.1 L 36.0 284.0 L 47.0 289.0 L 50.0 299.0 L 57.0 300.0 L 62.5 300.0 L 67.2 299.7 L 76.8 297.3 L 86.6 295.1 L 95.9 292.9 L 105.2 290.7 L 112.5 288.0 L 119.1 285.1 L 127.5 283.0 L 133.0 283.0 L 138.4 283.1 L 144.6 284.4 L 152.4 287.6 L 159.7 290.8 L 166.7 294.3 L 174.1 297.4 L 179.6 298.9 L 184.7 299.8 L 190.2 299.2 L 195.5 298.0 L 202.0 294.0 L 207.0 277.0 L 208.9 277.8 L 209.3 276.4 L 202.8 270.2 L 197.6 265.2 L 194.7 260.5 L 192.5 256.2 L 191.3 251.3 L 192.0 242.7 L 192.9 235.0 L 206.0 223.9 L 206.0 222.8 L 204.0 223.0 Z",
      "position": {
        "x": 98.2,
        "y": 250.4
      },
      "badgeAnchor": {
        "x": 124.57,
        "y": 247.62
      },
      "badgeRadius": 40.2,
      "adjacencies": [
        "glass-waste",
        "halcyon-s-gate",
        "hollow-ridge",
        "ion-flats",
        "iron-barrens",
        "salt-dunes"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ashen-dunes",
      "name": "Ashen Dunes",
      "shape": "M 1031.0 320.0 L 1039.6 317.6 L 1044.9 314.4 L 1051.0 309.5 L 1057.1 304.6 L 1063.3 299.8 L 1069.5 294.9 L 1074.7 290.2 L 1080.0 285.0 L 1100.0 285.0 L 1104.3 278.3 L 1105.8 272.3 L 1104.8 264.2 L 1104.0 256.0 L 1118.0 243.0 L 1112.0 239.5 L 1105.9 235.6 L 1100.1 231.4 L 1096.0 226.0 L 1095.3 218.8 L 1097.4 210.4 L 1099.6 205.6 L 1101.6 200.6 L 1102.0 196.0 L 1099.2 194.3 L 1091.2 192.3 L 1083.7 189.8 L 1077.1 186.4 L 1069.4 180.1 L 1067.0 179.0 L 1063.6 186.6 L 1060.3 194.3 L 1056.4 201.9 L 1052.5 207.0 L 1048.0 211.0 L 1043.5 214.9 L 1039.0 217.4 L 1034.3 218.8 L 1029.1 218.9 L 1022.4 217.5 L 1019.0 218.0 L 1013.0 231.0 L 1010.7 231.3 L 1010.5 231.5 L 1014.7 235.1 L 1021.1 237.1 L 1027.5 239.5 L 1031.9 241.7 L 1036.7 243.7 L 1040.6 246.1 L 1043.9 249.9 L 1047.7 254.2 L 1050.0 259.4 L 1050.0 267.5 L 1049.9 276.6 L 1047.3 284.6 L 1012.5 302.0 L 1013.0 303.4 L 1015.0 303.0 L 1019.0 313.0 Z",
      "position": {
        "x": 1068.8,
        "y": 234.8
      },
      "badgeAnchor": {
        "x": 1074.59,
        "y": 243.1
      },
      "badgeRadius": 28.6,
      "adjacencies": [
        "cinder-basin",
        "ember-expanse",
        "ghost-expanse",
        "ozone-hollows",
        "quiet-drift",
        "umber-drift"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ashen-flats",
      "name": "Ashen Flats",
      "shape": "M 208.0 36.0 L 208.0 93.0 L 244.0 99.0 L 249.3 96.3 L 254.3 93.8 L 259.1 90.6 L 263.9 87.4 L 271.7 81.7 L 279.4 76.0 L 283.2 72.2 L 286.6 68.6 L 289.0 67.0 L 291.0 54.0 L 286.0 47.0 L 286.0 39.0 L 302.0 28.0 L 297.2 19.8 L 292.5 15.0 L 288.0 10.0 L 288.0 0.0 L 290.0 0.0 L 290.0 -2.0 L 108.0 -2.0 L 115.8 5.4 L 118.2 9.4 L 124.6 16.6 L 129.5 19.7 L 134.2 25.5 L 139.4 31.7 L 145.8 37.0 L 152.0 41.4 L 156.0 47.7 L 158.0 47.0 Z",
      "position": {
        "x": 247.1,
        "y": 44.4
      },
      "badgeAnchor": {
        "x": 247.1,
        "y": 44.4
      },
      "badgeRadius": 38.9,
      "adjacencies": [
        "basalt-basin",
        "halcyon-e-gate",
        "silica-fields"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ashen-reach",
      "name": "Ashen Reach",
      "shape": "M 875.0 950.0 L 894.0 937.0 L 917.0 956.0 L 928.0 947.0 L 953.0 955.0 L 956.0 937.0 L 975.0 919.0 L 968.0 900.0 L 974.2 893.7 L 980.2 887.2 L 986.5 881.0 L 992.5 875.0 L 997.8 870.8 L 1002.8 866.3 L 1004.0 864.0 L 996.0 853.0 L 972.0 856.0 L 966.0 849.0 L 954.0 847.0 L 949.5 850.0 L 944.8 854.8 L 940.3 862.3 L 936.4 869.9 L 932.6 875.1 L 928.5 880.0 L 923.6 883.1 L 919.2 884.7 L 914.6 884.9 L 909.0 884.0 L 902.5 879.0 L 897.0 871.0 L 897.0 865.0 L 897.6 859.1 L 900.6 853.6 L 904.1 848.6 L 907.0 842.0 L 906.0 831.0 L 908.0 831.4 L 907.8 829.2 L 899.1 828.1 L 892.5 827.8 L 884.0 826.0 L 875.6 824.3 L 867.3 822.8 L 856.2 819.4 L 856.0 821.6 L 858.0 822.0 L 857.7 826.2 L 855.7 832.2 L 851.4 839.9 L 846.5 846.0 L 841.0 850.5 L 835.0 855.5 L 829.0 862.0 L 826.2 869.7 L 826.0 876.5 L 826.0 884.0 L 827.8 891.8 L 829.9 900.1 L 830.0 906.5 L 829.3 913.5 L 830.0 919.0 L 835.7 924.3 L 842.0 929.5 L 848.2 934.8 L 854.1 941.9 L 855.0 945.0 Z",
      "position": {
        "x": 870.4,
        "y": 901.7
      },
      "badgeAnchor": {
        "x": 889.57,
        "y": 902.37
      },
      "badgeRadius": 39.3,
      "adjacencies": [
        "glass-plateau",
        "halo-plateau",
        "ion-ridge",
        "ozone-scarp",
        "quiet-fields"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ashen-ridge",
      "name": "Ashen Ridge",
      "shape": "M 990.3 602.7 L 996.4 603.6 L 1002.2 604.3 L 1010.3 607.2 L 1017.9 611.6 L 1023.7 616.3 L 1029.0 621.0 L 1031.1 628.4 L 1032.9 635.6 L 1035.1 642.9 L 1037.1 649.9 L 1040.4 656.6 L 1044.0 663.0 L 1063.0 649.0 L 1073.0 650.0 L 1078.5 656.0 L 1083.3 661.7 L 1088.7 665.8 L 1095.0 669.0 L 1132.0 662.0 L 1133.2 655.2 L 1134.8 648.3 L 1135.8 641.3 L 1136.0 635.5 L 1136.0 629.0 L 1134.8 619.7 L 1132.7 609.8 L 1131.0 600.0 L 1132.7 598.0 L 1132.6 597.5 L 1114.9 602.0 L 1072.6 597.9 L 1072.5 598.2 L 1073.5 599.5 L 1073.5 601.6 L 1073.5 611.5 L 1065.5 617.5 L 1065.5 619.5 L 1061.5 623.5 L 1047.5 623.5 L 1042.5 615.5 L 1039.5 615.5 L 1036.5 612.5 L 1036.5 597.5 L 1044.5 592.5 L 1044.5 589.5 L 1047.0 587.0 L 1047.5 586.5 L 1049.7 586.5 L 1021.8 566.4 L 985.9 600.2 L 987.0 602.0 L 988.0 601.0 Z",
      "position": {
        "x": 1102.8,
        "y": 633.8
      },
      "badgeAnchor": {
        "x": 1083.61,
        "y": 626.86
      },
      "badgeRadius": 32.8,
      "adjacencies": [
        "glass-barrens",
        "halo-barrens",
        "jasper-ssw-tower",
        "quiet-hollows"
      ],
      "borderDice": {
        "jasper-ssw-tower": {
          "attack": 5
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "aster-crystal",
      "name": "Aster Crystal",
      "regionId": "aster-crystal",
      "shape": "M 863.5 378.5 L 860.5 382.5 L 864.5 394.5 L 861.5 397.5 L 849.5 400.5 L 847.5 402.5 L 860.5 408.5 L 864.5 412.5 L 863.5 419.5 L 873.5 418.5 L 882.5 426.5 L 887.5 417.5 L 896.5 416.5 L 893.5 406.5 L 902.5 397.5 L 895.5 395.5 L 890.5 391.5 L 890.5 379.5 L 887.5 376.5 L 877.5 388.5 Z",
      "position": {
        "x": 877.9,
        "y": 403.8
      },
      "badgeAnchor": {
        "x": 877.9,
        "y": 403.8
      },
      "badgeRadius": 15.3,
      "badgeShrinksWithDigits": true,
      "adjacencies": [
        "sable-flats",
        "shale-hollows"
      ],
      "borderDice": {
        "sable-flats": {
          "defend": 4
        },
        "shale-hollows": {
          "defend": 4
        },
        "topaz-ene-tower": {
          "defend": 4
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "basalt-basin",
      "name": "Basalt Basin",
      "shape": "M 402.0 74.0 L 396.7 74.5 L 392.0 73.0 L 387.4 67.6 L 383.2 61.3 L 379.2 54.3 L 375.5 47.0 L 371.7 39.3 L 369.2 30.3 L 369.0 25.5 L 369.0 20.0 L 373.0 17.0 L 380.0 17.0 L 387.5 18.0 L 393.5 18.0 L 399.8 17.8 L 406.0 16.0 L 413.3 12.3 L 421.0 8.0 L 421.7 4.5 L 421.0 0.0 L 423.0 0.0 L 422.7 -2.0 L 290.0 -2.0 L 290.0 0.0 L 288.0 0.0 L 288.0 10.0 L 292.5 15.0 L 297.2 19.8 L 302.0 28.0 L 286.0 39.0 L 286.0 47.0 L 291.0 54.0 L 289.0 67.0 L 291.0 75.0 L 293.1 82.9 L 295.9 89.7 L 299.0 96.0 L 305.0 98.5 L 311.8 100.7 L 316.5 101.0 L 321.9 101.1 L 325.0 102.0 L 339.0 93.0 L 359.0 110.0 L 374.0 100.0 L 398.0 103.0 L 419.0 100.0 L 416.0 64.0 Z",
      "position": {
        "x": 333.6,
        "y": 53.1
      },
      "badgeAnchor": {
        "x": 333.6,
        "y": 53.1
      },
      "badgeRadius": 40.3,
      "adjacencies": [
        "ashen-flats",
        "dust-waste",
        "glass-shelf",
        "silica-fields",
        "static-hollows"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "basalt-shelf",
      "name": "Basalt Shelf",
      "shape": "M 656.6 753.6 L 663.6 751.1 L 672.0 746.0 L 674.5 741.0 L 677.0 735.5 L 679.4 726.4 L 681.8 716.8 L 682.9 710.4 L 683.9 703.4 L 684.3 695.8 L 684.0 688.0 L 681.4 683.1 L 678.5 680.0 L 672.3 676.2 L 668.0 675.0 L 666.5 673.5 L 662.3 675.6 L 657.6 682.9 L 653.1 687.8 L 649.3 692.1 L 646.2 693.2 L 639.4 697.1 L 632.4 700.7 L 626.0 704.7 L 619.5 707.8 L 614.1 709.0 L 609.1 709.8 L 602.3 710.0 L 596.3 710.9 L 587.5 711.0 L 579.7 711.0 L 570.9 709.6 L 566.4 708.0 L 560.4 705.6 L 559.3 706.9 L 561.0 708.0 L 556.0 714.0 L 556.0 721.0 L 558.2 722.8 L 562.5 729.0 L 565.6 735.4 L 567.7 743.8 L 567.9 749.4 L 566.1 759.1 L 566.0 768.0 L 569.5 773.0 L 574.8 778.2 L 580.0 783.0 L 588.3 780.5 L 594.0 781.0 L 600.4 781.5 L 608.6 779.6 L 613.2 777.2 L 617.8 772.8 L 622.5 768.0 L 629.0 763.0 L 636.0 758.0 L 640.7 756.2 L 650.0 756.0 Z",
      "position": {
        "x": 600.9,
        "y": 743.6
      },
      "badgeAnchor": {
        "x": 622.72,
        "y": 731.24
      },
      "badgeRadius": 32.7,
      "adjacencies": [
        "mica-flats",
        "sable-dunes",
        "silica-flats",
        "static-scarp"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "basalt-steppe",
      "name": "Basalt Steppe",
      "shape": "M 418.3 334.2 L 420.1 328.1 L 422.6 321.6 L 423.0 317.0 L 425.0 317.2 L 425.2 315.3 L 418.5 314.2 L 412.9 315.9 L 408.5 316.8 L 403.3 317.0 L 396.5 315.1 L 389.6 313.5 L 382.6 311.3 L 373.0 310.1 L 364.9 310.0 L 356.8 310.9 L 349.0 311.0 L 341.6 311.0 L 333.2 310.1 L 324.8 309.1 L 319.0 310.4 L 319.0 310.6 L 321.0 312.0 L 321.0 318.0 L 320.6 323.6 L 316.5 332.0 L 313.0 340.0 L 320.2 341.3 L 327.8 342.2 L 333.8 343.7 L 340.6 345.4 L 348.9 348.1 L 357.0 351.0 L 365.5 354.0 L 373.8 356.8 L 382.3 359.2 L 391.0 362.0 L 419.0 341.0 Z",
      "position": {
        "x": 381.2,
        "y": 334.9
      },
      "badgeAnchor": {
        "x": 368.86,
        "y": 330.56
      },
      "badgeRadius": 22.9,
      "adjacencies": [
        "cobalt-shelf",
        "dust-barrens",
        "flint-plateau",
        "silica-scarp"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "basalt-waste",
      "name": "Basalt Waste",
      "shape": "M 304.0 1030.0 L 313.3 1030.2 L 323.3 1031.2 L 328.6 1032.4 L 334.0 1034.0 L 334.8 1038.4 L 333.0 1043.0 L 330.9 1043.0 L 330.1 1045.0 L 439.9 1045.0 L 440.0 1043.0 L 438.0 1043.0 L 438.2 1038.2 L 440.0 1030.0 L 441.9 1022.4 L 442.0 1017.0 L 442.0 1012.0 L 441.0 1006.0 L 437.5 1002.0 L 433.7 998.3 L 428.0 994.5 L 422.8 991.2 L 416.1 984.5 L 412.2 977.3 L 408.6 970.0 L 405.0 963.0 L 344.0 963.0 L 306.0 987.0 L 296.0 1021.0 Z",
      "position": {
        "x": 370.8,
        "y": 1004.1
      },
      "badgeAnchor": {
        "x": 370.8,
        "y": 1004.1
      },
      "badgeRadius": 40.9,
      "adjacencies": [
        "ochre-drift",
        "silica-dunes",
        "static-flats",
        "vapor-expanse"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "beryl-core",
      "name": "Beryl Core",
      "regionId": "beryl-mesa",
      "shape": "M 294.5 537.9 L 297.7 539.0 L 301.1 539.4 L 304.5 539.2 L 307.8 538.3 L 310.3 537.1 L 312.6 535.5 L 314.6 533.6 L 316.3 531.3 L 317.6 528.9 L 318.5 526.2 L 318.9 523.4 L 318.9 520.6 L 318.4 517.9 L 317.5 515.2 L 315.9 512.2 L 313.7 509.7 L 311.0 507.6 L 308.0 506.0 L 305.3 505.2 L 302.5 504.9 L 299.7 505.0 L 296.9 505.5 L 294.2 506.5 L 291.6 508.1 L 289.2 510.2 L 287.3 512.6 L 285.8 515.3 L 284.8 518.6 L 284.4 522.0 L 284.7 525.4 L 285.7 528.7 L 287.2 531.6 L 289.2 534.1 L 291.7 536.2 Z",
      "position": {
        "x": 301.7,
        "y": 522.2
      },
      "badgeAnchor": {
        "x": 301.7,
        "y": 522.2
      },
      "badgeRadius": 17.2,
      "adjacencies": [
        "beryl-e",
        "beryl-n",
        "beryl-ne",
        "beryl-nw",
        "beryl-s",
        "beryl-se",
        "beryl-sw",
        "beryl-w"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "beryl-e",
      "name": "Beryl East",
      "regionId": "beryl-mesa",
      "shape": "M 318.9 523.4 L 318.5 526.2 L 317.6 528.9 L 366.9 550.5 L 370.0 550.5 L 373.5 550.5 L 372.0 550.0 L 372.0 494.0 L 374.0 493.5 L 374.0 492.6 L 373.6 492.5 L 368.2 492.5 L 365.9 492.5 L 317.5 515.2 L 318.4 517.9 L 318.9 520.6 Z",
      "position": {
        "x": 351.7,
        "y": 521.7
      },
      "badgeAnchor": {
        "x": 351.7,
        "y": 521.7
      },
      "badgeRadius": 20.3,
      "adjacencies": [
        "beryl-core",
        "beryl-ene-tower",
        "beryl-ese-tower",
        "beryl-ne",
        "beryl-se",
        "garnet-w"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "beryl-ene-tower",
      "name": "Beryl East-Northeast Tower",
      "regionId": "beryl-ene-tower",
      "shape": "M 365.5 455.5 L 361.5 458.5 L 358.5 464.5 L 355.5 464.5 L 353.5 466.5 L 352.5 480.5 L 355.5 484.5 L 359.5 484.5 L 361.5 486.5 L 360.5 488.5 L 363.5 492.5 L 379.5 492.5 L 381.5 490.5 L 381.5 486.5 L 389.5 482.5 L 389.5 466.5 L 385.5 464.5 L 377.5 455.5 Z",
      "position": {
        "x": 371.5,
        "y": 474.5
      },
      "badgeAnchor": {
        "x": 371.5,
        "y": 474.5
      },
      "badgeRadius": 15.6,
      "badgeShrinksWithDigits": true,
      "adjacencies": [
        "beryl-e",
        "beryl-ne",
        "garnet-nw",
        "garnet-w",
        "salt-ridge"
      ],
      "oneWayBorders": [
        "dust-barrens",
        "lumen-crystal",
        "silica-scarp"
      ],
      "borderDice": {
        "salt-ridge": {
          "defend": 7
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "beryl-ese-tower",
      "name": "Beryl East-Southeast Tower",
      "regionId": "beryl-ese-tower",
      "shape": "M 364.5 550.5 L 361.5 553.5 L 361.5 556.5 L 353.5 561.5 L 353.5 576.5 L 356.5 579.5 L 358.5 579.5 L 364.5 587.5 L 378.5 587.5 L 382.5 581.5 L 389.5 576.5 L 390.5 563.5 L 386.5 558.5 L 383.5 558.5 L 381.5 556.5 L 382.5 555.5 L 378.5 550.5 Z",
      "position": {
        "x": 371.5,
        "y": 569
      },
      "badgeAnchor": {
        "x": 371.5,
        "y": 569
      },
      "badgeRadius": 15.9,
      "badgeShrinksWithDigits": true,
      "adjacencies": [
        "beryl-e",
        "beryl-se",
        "garnet-sw",
        "garnet-w",
        "umber-hollows"
      ],
      "oneWayBorders": [
        "argent-expanse",
        "flint-drift",
        "vesper-crystal"
      ],
      "borderDice": {
        "umber-hollows": {
          "defend": 7
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "beryl-n",
      "name": "Beryl North",
      "regionId": "beryl-mesa",
      "shape": "M 294.2 506.5 L 296.9 505.5 L 299.7 505.0 L 302.5 504.9 L 305.3 505.2 L 308.0 506.0 L 328.0 458.0 L 329.7 459.1 L 330.1 458.1 L 328.4 453.0 L 327.9 453.0 L 327.0 455.0 L 276.0 455.0 L 274.8 453.0 L 272.1 453.0 L 273.4 456.5 L 275.0 455.0 Z",
      "position": {
        "x": 301.7,
        "y": 473.6
      },
      "badgeAnchor": {
        "x": 301.7,
        "y": 473.6
      },
      "badgeRadius": 18.3,
      "adjacencies": [
        "beryl-core",
        "beryl-n-gate",
        "beryl-ne",
        "beryl-nw"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "beryl-n-gate",
      "name": "Beryl North Gate",
      "shape": "M 327.0 455.0 L 327.9 453.0 L 328.4 453.0 L 329.1 455.1 L 334.4 442.7 L 333.0 441.0 L 343.0 405.0 L 345.0 391.0 L 257.0 391.0 L 269.0 443.0 L 267.1 443.6 L 267.1 443.7 L 272.5 453.0 L 274.8 453.0 L 276.0 455.0 Z",
      "position": {
        "x": 301.1,
        "y": 423.1
      },
      "badgeAnchor": {
        "x": 301.1,
        "y": 423.1
      },
      "badgeRadius": 31.9,
      "adjacencies": [
        "beryl-n",
        "salt-ridge",
        "silica-scarp"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "beryl-ne",
      "name": "Beryl Northeast",
      "regionId": "beryl-mesa",
      "shape": "M 313.7 509.7 L 315.9 512.2 L 317.5 515.2 L 365.9 492.5 L 363.5 492.5 L 360.5 488.5 L 361.5 486.5 L 359.5 484.5 L 355.5 484.5 L 352.5 480.5 L 353.1 472.6 L 329.7 456.7 L 330.1 458.1 L 329.7 459.1 L 328.0 458.0 L 308.0 506.0 L 311.0 507.6 Z",
      "position": {
        "x": 335.6,
        "y": 486.7
      },
      "badgeAnchor": {
        "x": 335.6,
        "y": 486.7
      },
      "badgeRadius": 18,
      "adjacencies": [
        "beryl-core",
        "beryl-e",
        "beryl-ene-tower",
        "beryl-n"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "beryl-nw",
      "name": "Beryl Northwest",
      "regionId": "beryl-mesa",
      "shape": "M 275.0 455.0 L 273.4 456.5 L 272.7 454.5 L 231.4 493.6 L 233.5 494.5 L 235.0 493.0 L 285.8 515.3 L 287.3 512.6 L 289.2 510.2 L 291.6 508.1 L 294.2 506.5 Z",
      "position": {
        "x": 266.7,
        "y": 486.3
      },
      "badgeAnchor": {
        "x": 266.7,
        "y": 486.3
      },
      "badgeRadius": 18.7,
      "adjacencies": [
        "beryl-core",
        "beryl-n",
        "beryl-w"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "beryl-s",
      "name": "Beryl South",
      "regionId": "beryl-mesa",
      "shape": "M 304.5 539.2 L 301.1 539.4 L 297.7 539.0 L 294.5 537.9 L 275.0 589.0 L 327.0 588.0 L 327.8 590.0 L 329.0 590.0 L 329.0 586.6 L 328.7 585.8 L 327.0 587.0 L 307.8 538.3 Z",
      "position": {
        "x": 301.3,
        "y": 570.6
      },
      "badgeAnchor": {
        "x": 301.3,
        "y": 570.6
      },
      "badgeRadius": 17.9,
      "adjacencies": [
        "beryl-core",
        "beryl-s-gate",
        "beryl-se",
        "beryl-sw"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "beryl-s-gate",
      "name": "Beryl South Gate",
      "shape": "M 275.0 589.0 L 273.0 589.0 L 272.5 591.0 L 272.1 591.1 L 272.9 588.9 L 271.3 587.4 L 268.3 600.4 L 270.0 602.0 L 258.0 642.0 L 257.0 653.0 L 282.0 654.0 L 344.0 654.0 L 345.8 650.6 L 344.6 645.4 L 344.0 640.0 L 333.0 603.0 L 327.0 588.0 Z",
      "position": {
        "x": 301.4,
        "y": 621.3
      },
      "badgeAnchor": {
        "x": 301.4,
        "y": 621.3
      },
      "badgeRadius": 32.7,
      "adjacencies": [
        "argent-expanse",
        "beryl-s",
        "ghost-basin",
        "ion-dunes",
        "umber-hollows"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "beryl-se",
      "name": "Beryl Southeast",
      "regionId": "beryl-mesa",
      "shape": "M 314.6 533.6 L 312.6 535.5 L 310.3 537.1 L 307.8 538.3 L 327.0 587.0 L 328.7 585.8 L 329.0 586.6 L 329.0 587.6 L 329.1 587.9 L 353.5 570.1 L 353.5 566.8 L 353.5 561.5 L 361.5 556.5 L 361.5 553.5 L 364.5 550.5 L 366.9 550.5 L 317.6 528.9 L 316.3 531.3 Z",
      "position": {
        "x": 335.3,
        "y": 557.3
      },
      "badgeAnchor": {
        "x": 335.3,
        "y": 557.3
      },
      "badgeRadius": 18.6,
      "adjacencies": [
        "beryl-core",
        "beryl-e",
        "beryl-ese-tower",
        "beryl-s"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "beryl-sw",
      "name": "Beryl Southwest",
      "regionId": "beryl-mesa",
      "shape": "M 294.5 537.9 L 291.7 536.2 L 289.2 534.1 L 287.2 531.6 L 285.7 528.7 L 234.0 551.0 L 233.0 551.0 L 232.1 551.9 L 270.8 589.6 L 271.3 587.4 L 272.3 588.3 L 272.9 588.9 L 273.0 589.0 L 275.0 589.0 Z",
      "position": {
        "x": 266.2,
        "y": 558.2
      },
      "badgeAnchor": {
        "x": 266.2,
        "y": 558.2
      },
      "badgeRadius": 19.2,
      "adjacencies": [
        "beryl-core",
        "beryl-s",
        "beryl-w"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "beryl-w",
      "name": "Beryl West",
      "regionId": "beryl-mesa",
      "shape": "M 233.0 550.0 L 233.0 551.0 L 234.0 551.0 L 285.7 528.7 L 284.7 525.4 L 284.4 522.0 L 284.8 518.6 L 285.8 515.3 L 235.0 493.0 L 233.5 494.5 L 231.5 493.7 L 231.3 493.9 L 233.0 495.0 Z",
      "position": {
        "x": 252.6,
        "y": 521.9
      },
      "badgeAnchor": {
        "x": 252.6,
        "y": 521.9
      },
      "badgeRadius": 19.4,
      "adjacencies": [
        "beryl-core",
        "beryl-nw",
        "beryl-sw",
        "quartz-e"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "chrome-dunes",
      "name": "Chrome Dunes",
      "shape": "M 681.0 478.0 L 689.0 478.0 L 691.0 470.0 L 693.4 462.4 L 696.7 455.7 L 700.0 449.0 L 704.8 442.8 L 711.0 437.5 L 716.7 431.7 L 718.0 428.0 L 711.3 426.2 L 704.8 425.2 L 698.2 423.8 L 689.0 420.0 L 685.5 416.0 L 682.9 411.6 L 680.9 405.6 L 680.0 400.0 L 681.3 397.4 L 675.2 399.5 L 670.8 403.9 L 667.2 408.0 L 665.6 413.3 L 663.4 418.3 L 663.2 424.1 L 662.8 429.0 L 660.6 437.6 L 657.3 442.3 L 654.2 446.8 L 647.9 452.2 L 645.9 455.8 L 639.3 454.9 L 635.3 459.0 L 634.5 462.0 L 624.6 462.0 L 622.6 454.3 L 619.8 445.1 L 614.6 437.9 L 609.9 430.7 L 605.3 423.8 L 601.1 416.6 L 596.5 409.6 L 592.4 402.5 L 589.7 399.8 L 588.3 400.1 L 589.0 402.0 L 583.1 403.1 L 577.0 404.0 L 569.5 404.0 L 561.5 404.0 L 553.5 404.0 L 545.5 404.0 L 537.1 403.1 L 532.5 404.0 L 527.2 405.2 L 518.2 408.2 L 509.0 411.0 L 512.0 416.4 L 517.8 422.2 L 523.2 427.8 L 528.7 433.3 L 531.6 438.4 L 533.2 444.8 L 534.0 450.5 L 532.3 459.8 L 531.0 469.0 L 541.0 484.0 L 573.0 477.0 L 573.0 523.0 L 585.9 523.0 L 586.1 519.6 L 586.7 516.2 L 587.5 512.9 L 588.6 509.6 L 589.9 506.5 L 591.6 503.4 L 593.5 500.6 L 595.6 497.9 L 597.9 495.4 L 600.5 493.1 L 603.2 491.0 L 606.1 489.2 L 609.2 487.7 L 612.4 486.4 L 615.7 485.3 L 619.0 484.6 L 622.4 484.2 L 625.9 484.0 L 629.3 484.2 L 632.7 484.6 L 636.0 485.3 L 639.3 486.4 L 642.5 487.6 L 645.5 489.2 L 648.5 491.0 L 651.2 493.1 L 653.8 495.4 L 656.1 497.9 L 658.2 500.6 L 660.1 503.4 L 661.8 506.4 L 663.2 509.6 L 664.3 512.8 L 665.1 516.2 L 665.6 519.5 L 665.8 523.0 L 681.0 523.0 Z",
      "position": {
        "x": 571.1,
        "y": 440.6
      },
      "badgeAnchor": {
        "x": 587.08,
        "y": 452.18
      },
      "badgeRadius": 36.4,
      "adjacencies": [
        "dust-barrens",
        "frost-waste",
        "garnet-e-gate",
        "nexus-warp",
        "pale-basin",
        "static-fields",
        "topaz-w-gate",
        "vapor-reach"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "chrome-flats",
      "name": "Chrome Flats",
      "shape": "M 422.0 183.0 L 416.3 187.8 L 410.3 192.3 L 406.2 196.2 L 402.1 200.6 L 396.4 208.4 L 391.2 216.7 L 388.0 224.0 L 385.8 224.9 L 391.1 228.6 L 399.6 230.0 L 406.6 231.6 L 413.3 234.8 L 419.8 237.2 L 427.2 241.6 L 433.2 247.6 L 435.5 251.1 L 437.0 255.5 L 441.8 263.5 L 443.4 273.8 L 446.0 272.8 L 445.0 271.0 L 449.2 269.2 L 454.4 268.9 L 460.0 268.4 L 464.3 265.8 L 469.0 263.0 L 478.9 263.1 L 487.6 264.9 L 493.4 264.4 L 499.8 261.3 L 503.8 256.3 L 508.0 251.0 L 506.3 246.2 L 503.0 240.5 L 499.6 234.9 L 497.6 229.9 L 497.0 224.0 L 497.0 219.0 L 508.0 204.0 L 507.8 194.7 L 506.5 189.0 L 505.0 184.0 L 500.4 185.4 L 495.2 186.7 L 486.5 187.9 L 480.9 187.1 L 474.6 185.9 L 469.7 183.8 L 465.6 180.4 L 462.2 176.3 L 459.3 170.2 L 456.6 163.4 L 453.8 156.7 L 449.0 149.0 L 445.0 149.0 L 437.0 159.0 L 427.0 159.0 Z",
      "position": {
        "x": 458.8,
        "y": 220.2
      },
      "badgeAnchor": {
        "x": 458.8,
        "y": 220.2
      },
      "badgeRadius": 37.5,
      "adjacencies": [
        "dust-waste",
        "flint-plateau",
        "frost-shelf",
        "static-hollows"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "chrome-ridge",
      "name": "Chrome Ridge",
      "shape": "M 232.0 733.0 L 226.3 729.7 L 220.8 728.2 L 212.4 729.9 L 206.6 734.0 L 202.2 738.2 L 197.7 742.7 L 191.4 748.0 L 184.6 753.0 L 180.9 756.4 L 177.0 760.0 L 172.2 761.7 L 166.9 762.9 L 161.8 762.7 L 156.0 762.0 L 153.2 767.2 L 151.2 772.2 L 151.0 781.0 L 151.9 786.5 L 151.0 792.0 L 145.0 798.5 L 139.8 801.8 L 138.0 804.0 L 142.7 806.8 L 147.6 809.4 L 154.9 814.6 L 160.0 821.0 L 149.0 850.0 L 152.3 852.7 L 160.6 855.9 L 168.3 859.2 L 174.7 862.3 L 180.2 865.8 L 186.0 869.0 L 188.1 866.6 L 191.7 859.7 L 195.2 852.7 L 198.5 846.0 L 202.4 839.4 L 206.2 835.2 L 210.0 831.5 L 215.0 828.0 L 231.0 829.0 L 234.6 822.6 L 236.0 815.0 L 238.1 814.7 L 238.3 813.5 L 230.2 811.5 L 224.4 809.4 L 220.1 805.3 L 212.9 802.5 L 207.1 796.7 L 204.1 791.8 L 202.3 787.0 L 201.1 781.7 L 201.0 775.0 L 201.2 768.6 L 202.8 763.5 L 207.6 757.8 L 211.4 755.3 L 220.3 752.1 L 226.0 747.8 L 231.2 745.9 L 238.7 743.1 L 238.0 741.6 L 236.0 742.0 Z",
      "position": {
        "x": 185.9,
        "y": 813.4
      },
      "badgeAnchor": {
        "x": 181.08,
        "y": 799.18
      },
      "badgeRadius": 27,
      "adjacencies": [
        "argent-basin",
        "cobalt-waste",
        "dust-plateau",
        "flint-hollows",
        "ion-dunes",
        "salt-reach"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "cinder-basin",
      "name": "Cinder Basin",
      "shape": "M 941.4 165.4 L 935.5 170.0 L 929.8 175.8 L 924.2 182.2 L 917.9 186.4 L 911.6 190.6 L 905.0 195.0 L 898.4 199.4 L 891.7 204.2 L 885.0 209.5 L 878.4 214.9 L 876.0 216.0 L 884.0 228.0 L 882.7 229.7 L 883.0 230.1 L 890.5 229.7 L 898.0 227.8 L 904.9 225.3 L 908.0 223.3 L 914.4 216.9 L 919.8 212.0 L 957.2 211.0 L 961.6 215.5 L 967.8 217.7 L 973.1 220.8 L 977.1 224.2 L 981.5 227.4 L 990.2 229.7 L 998.6 231.9 L 1007.1 233.8 L 1012.4 233.1 L 1010.5 231.5 L 1010.7 231.3 L 1013.0 231.0 L 1019.0 218.0 L 1022.4 217.5 L 1029.1 218.9 L 1034.3 218.8 L 1039.0 217.4 L 1043.5 214.9 L 1048.0 211.0 L 1052.5 207.0 L 1056.4 201.9 L 1060.3 194.3 L 1063.6 186.6 L 1067.0 179.0 L 1064.2 172.3 L 1061.3 165.2 L 1060.0 158.0 L 1059.0 150.5 L 1058.0 143.0 L 1057.0 135.0 L 1051.1 136.1 L 1045.4 137.4 L 1035.6 140.6 L 1026.7 144.2 L 1018.9 145.9 L 1013.7 145.8 L 1005.0 144.5 L 996.4 143.1 L 989.0 143.0 L 982.4 143.4 L 976.4 145.8 L 971.0 149.5 L 966.0 153.0 L 957.3 157.3 L 949.3 161.3 L 943.0 163.0 Z",
      "position": {
        "x": 994.1,
        "y": 184.7
      },
      "badgeAnchor": {
        "x": 994.1,
        "y": 184.7
      },
      "badgeRadius": 41.4,
      "adjacencies": [
        "ashen-dunes",
        "mica-fields",
        "ozone-hollows",
        "quiet-plateau"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "cinder-shelf",
      "name": "Cinder Shelf",
      "shape": "M 744.3 848.2 L 744.0 840.0 L 754.0 826.0 L 754.0 819.5 L 753.5 813.0 L 751.1 807.4 L 748.4 803.1 L 745.7 798.8 L 745.0 796.0 L 742.2 794.3 L 738.5 790.0 L 734.5 786.0 L 731.0 783.5 L 723.2 780.3 L 716.5 779.0 L 710.0 778.0 L 708.1 779.1 L 706.7 781.7 L 705.1 787.6 L 703.4 793.4 L 699.0 796.0 L 694.8 798.8 L 690.2 803.2 L 686.0 807.5 L 683.0 809.0 L 679.4 815.9 L 673.8 821.8 L 669.0 827.5 L 665.7 832.7 L 663.1 841.6 L 661.6 850.6 L 659.0 859.0 L 651.7 863.7 L 645.0 866.5 L 641.1 868.1 L 643.5 871.5 L 645.5 871.5 L 649.5 875.5 L 649.5 888.5 L 649.5 889.5 L 648.5 890.5 L 649.9 892.5 L 652.0 892.0 L 653.0 892.0 L 659.7 888.2 L 666.6 883.6 L 671.2 875.7 L 676.0 867.5 L 680.8 859.3 L 685.4 851.4 L 690.0 843.0 L 734.0 882.0 L 745.0 874.0 L 747.8 865.8 L 748.0 858.0 L 746.2 853.3 Z",
      "position": {
        "x": 716.9,
        "y": 822.8
      },
      "badgeAnchor": {
        "x": 719.08,
        "y": 825.68
      },
      "badgeRadius": 32.1,
      "adjacencies": [
        "halo-plateau",
        "mica-flats",
        "nadir-n-tower",
        "nadir-ne-gate",
        "ozone-scarp",
        "pale-steppe",
        "static-scarp"
      ],
      "borderDice": {
        "nadir-n-tower": {
          "attack": 5
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "cinder-steppe",
      "name": "Cinder Steppe",
      "shape": "M 16.0 716.5 L 23.5 714.0 L 31.1 711.1 L 39.0 708.0 L 38.0 702.5 L 37.1 697.5 L 38.3 689.8 L 40.1 684.6 L 42.0 680.0 L 47.0 674.0 L 68.0 675.0 L 78.0 665.0 L 93.0 664.0 L 95.7 655.7 L 98.1 652.1 L 104.5 646.0 L 110.8 639.8 L 117.8 633.8 L 122.0 631.0 L 126.7 628.7 L 132.0 627.5 L 137.9 625.9 L 147.0 622.0 L 149.5 614.0 L 146.3 605.2 L 146.0 599.0 L 148.0 599.1 L 147.9 597.4 L 124.1 591.2 L 98.4 560.6 L 97.0 562.0 L 95.5 563.5 L 93.5 563.5 L 90.5 566.5 L 90.5 568.5 L 85.5 572.5 L 72.5 571.5 L 67.5 564.5 L 61.5 560.5 L 61.5 546.5 L 67.5 542.5 L 69.5 538.5 L 74.5 534.5 L 83.8 535.2 L 85.0 535.0 L 83.8 535.2 L 87.5 535.5 L 88.1 536.5 L 90.9 536.0 L 91.0 534.9 L 84.3 532.7 L 86.4 521.0 L 84.1 521.0 L 84.0 523.0 L 65.9 523.0 L 65.6 526.5 L 65.0 529.9 L 63.9 533.2 L 62.5 536.4 L 60.7 539.4 L 58.6 542.2 L 56.2 544.7 L 53.5 546.9 L 50.6 548.8 L 47.5 550.4 L 44.2 551.6 L 40.8 552.4 L 37.3 552.8 L 33.9 552.8 L 30.4 552.4 L 27.0 551.6 L 23.7 550.4 L 20.6 548.8 L 17.6 546.9 L 15.0 544.7 L 12.6 542.2 L 10.4 539.4 L 8.7 536.4 L 7.2 533.2 L 6.2 529.9 L 5.5 526.5 L 5.3 523.0 L 0.0 523.0 L 0.0 521.0 L -2.0 521.0 L -2.0 722.4 L 0.0 722.0 L 0.0 720.0 L 8.0 718.5 Z",
      "position": {
        "x": 50.9,
        "y": 619.8
      },
      "badgeAnchor": {
        "x": 50.9,
        "y": 619.8
      },
      "badgeRadius": 52.7,
      "adjacencies": [
        "ghost-basin",
        "ion-dunes",
        "jade-reach",
        "ozone-fields",
        "quartz-wsw-tower",
        "salt-reach",
        "west-warp"
      ],
      "borderDice": {
        "quartz-wsw-tower": {
          "attack": 5
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "cobalt-barrens",
      "name": "Cobalt Barrens",
      "shape": "M 1073.4 929.1 L 1082.6 931.4 L 1091.7 933.6 L 1098.2 932.7 L 1105.0 931.0 L 1107.0 928.0 L 1108.9 927.3 L 1108.8 925.5 L 1107.5 925.5 L 1106.7 924.4 L 1101.5 917.5 L 1099.5 917.5 L 1095.5 913.5 L 1095.5 900.5 L 1103.5 894.5 L 1103.5 892.5 L 1107.5 888.5 L 1120.5 888.5 L 1126.5 896.5 L 1128.5 896.5 L 1131.7 899.7 L 1132.5 900.5 L 1132.5 901.8 L 1134.3 901.9 L 1135.0 900.0 L 1138.0 897.0 L 1139.5 892.0 L 1140.7 887.2 L 1140.8 883.6 L 1138.7 875.8 L 1136.5 868.0 L 1134.4 860.6 L 1132.0 853.0 L 1122.2 851.8 L 1112.9 850.1 L 1106.5 850.0 L 1100.6 849.9 L 1097.0 849.0 L 1092.0 851.5 L 1087.4 853.4 L 1081.9 857.4 L 1077.0 861.5 L 1071.2 869.7 L 1066.2 877.7 L 1062.2 885.2 L 1057.7 892.7 L 1054.0 900.0 L 1056.0 924.0 L 1064.6 926.4 Z",
      "position": {
        "x": 1075.6,
        "y": 901.9
      },
      "badgeAnchor": {
        "x": 1084.07,
        "y": 886.02
      },
      "badgeRadius": 19.9,
      "adjacencies": [
        "ghost-steppe",
        "glass-plateau",
        "ion-ridge",
        "penumbra-n-gate",
        "penumbra-nw-tower",
        "penumbra-w-gate"
      ],
      "borderDice": {
        "penumbra-nw-tower": {
          "attack": 5
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "cobalt-shelf",
      "name": "Cobalt Shelf",
      "shape": "M 243.6 300.6 L 239.2 304.2 L 236.4 307.4 L 234.0 312.0 L 233.0 319.5 L 232.1 327.4 L 233.8 336.2 L 236.0 345.0 L 245.0 345.0 L 253.8 345.2 L 258.8 346.8 L 263.6 348.4 L 271.0 352.0 L 278.4 354.6 L 285.5 355.0 L 292.0 355.0 L 303.0 342.0 L 307.7 340.2 L 313.0 340.0 L 316.5 332.0 L 320.6 323.6 L 321.0 318.0 L 321.0 312.0 L 319.0 310.6 L 319.0 310.4 L 321.4 309.9 L 317.9 307.4 L 310.9 306.9 L 305.3 305.8 L 296.0 303.1 L 287.3 300.8 L 278.3 298.2 L 269.2 296.3 L 261.8 295.1 L 254.5 294.0 L 250.9 294.5 L 247.1 296.2 L 247.0 296.3 L 248.0 298.0 Z",
      "position": {
        "x": 279.1,
        "y": 326.2
      },
      "badgeAnchor": {
        "x": 279.1,
        "y": 326.2
      },
      "badgeRadius": 26.7,
      "adjacencies": [
        "basalt-steppe",
        "ion-flats",
        "silica-scarp"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "cobalt-steppe",
      "name": "Cobalt Steppe",
      "shape": "M 919.0 8.0 L 923.0 13.0 L 929.7 14.8 L 934.5 15.0 L 939.9 15.1 L 945.6 16.4 L 952.2 19.8 L 955.0 24.0 L 1010.0 65.0 L 1017.5 66.0 L 1025.0 66.9 L 1034.5 66.0 L 1043.0 65.0 L 1044.0 35.0 L 1091.0 48.0 L 1093.5 48.8 L 1098.2 46.1 L 1104.2 40.2 L 1122.1 22.2 L 1128.5 16.5 L 1131.7 12.6 L 1135.8 8.4 L 1138.6 3.9 L 1145.3 -2.0 L 918.2 -2.0 L 918.0 0.0 L 920.0 0.0 Z",
      "position": {
        "x": 1013.4,
        "y": 28.9
      },
      "badgeAnchor": {
        "x": 1013.4,
        "y": 28.9
      },
      "badgeRadius": 30.9,
      "adjacencies": [
        "corona-w-gate",
        "ion-scarp",
        "quiet-plateau"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "cobalt-waste",
      "name": "Cobalt Waste",
      "shape": "M 236.0 742.0 L 238.0 741.6 L 238.7 743.1 L 236.6 743.9 L 245.9 742.0 L 254.6 740.2 L 262.5 739.2 L 270.3 738.1 L 278.0 738.0 L 293.0 738.0 L 300.5 737.8 L 308.2 736.9 L 315.2 735.7 L 323.4 733.9 L 330.6 732.2 L 339.8 731.0 L 348.6 730.0 L 354.3 730.0 L 359.5 730.7 L 365.6 730.0 L 370.8 730.0 L 378.3 731.2 L 387.0 733.6 L 392.3 736.3 L 398.0 738.2 L 404.9 740.4 L 405.4 739.5 L 404.0 738.0 L 413.0 724.0 L 413.9 717.5 L 413.0 712.0 L 395.0 710.0 L 390.7 704.3 L 389.4 698.6 L 387.3 693.2 L 382.0 689.0 L 341.0 690.0 L 336.3 693.3 L 331.3 697.3 L 326.8 698.8 L 321.0 699.0 L 286.0 675.0 L 281.0 679.0 L 281.0 684.0 L 281.3 689.2 L 284.3 696.7 L 286.8 704.7 L 286.0 713.0 L 232.0 733.0 Z",
      "position": {
        "x": 307.3,
        "y": 715.4
      },
      "badgeAnchor": {
        "x": 307.3,
        "y": 715.4
      },
      "badgeRadius": 21.3,
      "adjacencies": [
        "argent-expanse",
        "chrome-ridge",
        "frost-barrens",
        "ion-dunes"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "corona-core",
      "name": "Corona Core",
      "regionId": "corona-mesa",
      "shape": "M 1157.8 74.4 L 1156.8 77.2 L 1156.2 80.1 L 1156.2 83.0 L 1156.6 86.0 L 1157.5 88.8 L 1158.9 91.4 L 1160.7 93.7 L 1162.9 95.7 L 1165.4 97.2 L 1168.3 98.5 L 1171.5 99.1 L 1174.7 99.2 L 1177.8 98.6 L 1180.8 97.5 L 1183.5 95.9 L 1186.0 93.7 L 1188.0 91.2 L 1189.4 88.3 L 1190.3 85.2 L 1190.6 82.0 L 1190.3 78.8 L 1189.4 75.7 L 1188.0 72.8 L 1186.0 70.2 L 1183.6 68.1 L 1180.8 66.4 L 1177.8 65.3 L 1174.7 64.8 L 1171.5 64.8 L 1168.3 65.5 L 1165.4 66.7 L 1163.0 68.1 L 1161.0 70.0 L 1159.2 72.1 Z",
      "position": {
        "x": 1173.3,
        "y": 81.9
      },
      "badgeAnchor": {
        "x": 1173.3,
        "y": 81.9
      },
      "badgeRadius": 17.1,
      "adjacencies": [
        "corona-e",
        "corona-n",
        "corona-nw",
        "corona-s",
        "corona-sw",
        "corona-w"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "corona-crystal",
      "name": "Corona Crystal",
      "regionId": "corona-crystal",
      "shape": "M 1208.5 31.5 L 1205.5 34.5 L 1202.5 48.5 L 1191.5 54.5 L 1196.5 60.5 L 1193.5 70.5 L 1204.5 76.5 L 1205.5 88.5 L 1209.5 92.5 L 1213.5 83.5 L 1217.5 79.5 L 1226.5 85.5 L 1229.5 84.5 L 1227.5 68.5 L 1232.5 61.5 L 1225.5 54.5 L 1225.5 48.5 L 1218.5 47.5 Z",
      "position": {
        "x": 1212.3,
        "y": 62.7
      },
      "badgeAnchor": {
        "x": 1212.3,
        "y": 62.7
      },
      "badgeRadius": 15.5,
      "badgeShrinksWithDigits": true,
      "adjacencies": [
        "corona-e"
      ],
      "borderDice": {
        "corona-e": {
          "defend": 4
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "corona-e",
      "name": "Corona East",
      "regionId": "corona-mesa",
      "shape": "M 1186.0 70.2 L 1188.0 72.8 L 1189.4 75.7 L 1190.3 78.8 L 1190.6 82.0 L 1190.3 85.2 L 1189.4 88.3 L 1188.0 91.2 L 1186.0 93.7 L 1183.5 95.9 L 1180.8 97.5 L 1200.0 145.0 L 1200.0 147.0 L 1200.2 147.5 L 1244.0 108.9 L 1244.0 52.1 L 1201.3 11.5 L 1199.8 15.0 L 1202.0 15.0 L 1180.8 66.4 L 1183.6 68.1 Z M 1225.5 48.5 L 1225.5 54.5 L 1232.5 61.5 L 1227.5 68.5 L 1229.5 84.5 L 1226.5 85.5 L 1217.5 79.5 L 1213.5 83.5 L 1209.5 92.5 L 1205.5 88.5 L 1204.5 76.5 L 1193.5 70.5 L 1196.5 60.5 L 1191.5 54.5 L 1202.5 48.5 L 1205.5 34.5 L 1208.5 31.5 L 1218.5 47.5 Z",
      "position": {
        "x": 1209.1,
        "y": 112.7
      },
      "badgeAnchor": {
        "x": 1209.1,
        "y": 112.7
      },
      "badgeRadius": 20.2,
      "adjacencies": [
        "corona-core",
        "corona-crystal",
        "corona-n",
        "corona-s"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "corona-n",
      "name": "Corona North",
      "regionId": "corona-mesa",
      "shape": "M 1199.8 15.0 L 1200.7 13.0 L 1143.1 13.0 L 1144.4 16.5 L 1146.0 15.0 L 1165.4 66.7 L 1168.3 65.5 L 1171.5 64.8 L 1174.7 64.8 L 1177.8 65.3 L 1180.8 66.4 L 1202.0 15.0 Z",
      "position": {
        "x": 1173.6,
        "y": 32.8
      },
      "badgeAnchor": {
        "x": 1173.6,
        "y": 32.8
      },
      "badgeRadius": 19.5,
      "adjacencies": [
        "corona-core",
        "corona-e",
        "corona-nw"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "corona-nw",
      "name": "Corona Northwest",
      "regionId": "corona-mesa",
      "shape": "M 1146.0 15.0 L 1144.4 16.5 L 1143.7 14.5 L 1103.9 52.3 L 1106.0 53.0 L 1157.8 74.4 L 1159.2 72.1 L 1161.0 70.0 L 1163.0 68.1 L 1165.4 66.7 Z",
      "position": {
        "x": 1137.7,
        "y": 45.9
      },
      "badgeAnchor": {
        "x": 1137.7,
        "y": 45.9
      },
      "badgeRadius": 18.6,
      "adjacencies": [
        "corona-core",
        "corona-n",
        "corona-w"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "corona-s",
      "name": "Corona South",
      "regionId": "corona-mesa",
      "shape": "M 1147.0 147.0 L 1200.0 147.0 L 1200.0 145.0 L 1180.8 97.5 L 1177.8 98.6 L 1174.7 99.2 L 1171.5 99.1 L 1168.3 98.5 L 1165.4 97.2 Z",
      "position": {
        "x": 1173.6,
        "y": 128.6
      },
      "badgeAnchor": {
        "x": 1173.6,
        "y": 128.6
      },
      "badgeRadius": 18.3,
      "adjacencies": [
        "corona-core",
        "corona-e",
        "corona-s-gate",
        "corona-sw"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "corona-s-gate",
      "name": "Corona South Gate",
      "shape": "M 1147.0 147.0 L 1138.0 149.0 L 1139.6 156.4 L 1140.8 163.8 L 1137.9 173.4 L 1135.0 183.0 L 1132.4 192.4 L 1130.0 198.0 L 1128.0 211.0 L 1175.0 211.0 L 1218.0 211.0 L 1205.0 159.0 L 1207.0 158.6 L 1206.9 158.4 L 1202.0 146.6 L 1202.0 149.0 L 1200.8 149.0 L 1200.0 147.0 Z",
      "position": {
        "x": 1173.3,
        "y": 179.1
      },
      "badgeAnchor": {
        "x": 1173.3,
        "y": 179.1
      },
      "badgeRadius": 31.9,
      "adjacencies": [
        "corona-s",
        "ghost-expanse",
        "ozone-hollows",
        "umber-drift"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "corona-sw",
      "name": "Corona Southwest",
      "regionId": "corona-mesa",
      "shape": "M 1162.9 95.7 L 1160.7 93.7 L 1158.9 91.4 L 1157.5 88.8 L 1106.0 108.0 L 1104.0 116.0 L 1108.0 120.0 L 1107.7 121.5 L 1112.9 121.5 L 1120.5 121.5 L 1123.5 124.5 L 1123.5 128.4 L 1123.5 128.5 L 1125.5 130.5 L 1129.5 130.5 L 1132.5 133.5 L 1132.5 140.0 L 1132.5 145.9 L 1132.9 147.2 L 1135.0 147.0 L 1138.0 149.0 L 1147.0 147.0 L 1165.4 97.2 Z",
      "position": {
        "x": 1139.4,
        "y": 115.1
      },
      "badgeAnchor": {
        "x": 1139.4,
        "y": 115.1
      },
      "badgeRadius": 18.2,
      "adjacencies": [
        "corona-core",
        "corona-s",
        "corona-sw-tower",
        "corona-w"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "corona-sw-tower",
      "name": "Corona Southwest Tower",
      "regionId": "corona-sw-tower",
      "shape": "M 1107.5 121.5 L 1103.5 125.5 L 1103.5 127.5 L 1095.5 133.5 L 1095.5 146.5 L 1099.5 150.5 L 1101.5 150.5 L 1107.5 158.5 L 1120.5 158.5 L 1124.5 154.5 L 1124.5 152.5 L 1132.5 146.5 L 1132.5 133.5 L 1129.5 130.5 L 1125.5 130.5 L 1123.5 128.5 L 1123.5 124.5 L 1120.5 121.5 Z",
      "position": {
        "x": 1114,
        "y": 140
      },
      "badgeAnchor": {
        "x": 1114,
        "y": 140
      },
      "badgeRadius": 14.8,
      "badgeShrinksWithDigits": true,
      "adjacencies": [
        "corona-sw",
        "ozone-hollows"
      ],
      "oneWayBorders": [
        "ashen-dunes",
        "cinder-basin",
        "ghost-expanse",
        "quiet-plateau"
      ],
      "borderDice": {
        "ozone-hollows": {
          "defend": 7
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "corona-w",
      "name": "Corona West",
      "regionId": "corona-mesa",
      "shape": "M 1157.5 88.8 L 1156.6 86.0 L 1156.2 83.0 L 1156.2 80.1 L 1156.8 77.2 L 1157.8 74.4 L 1106.0 53.0 L 1106.0 108.0 Z",
      "position": {
        "x": 1124.9,
        "y": 81.1
      },
      "badgeAnchor": {
        "x": 1124.9,
        "y": 81.1
      },
      "badgeRadius": 18.6,
      "adjacencies": [
        "corona-core",
        "corona-nw",
        "corona-sw",
        "corona-w-gate"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "corona-w-gate",
      "name": "Corona West Gate",
      "shape": "M 1106.0 53.0 L 1103.9 52.3 L 1104.0 52.1 L 1104.0 50.2 L 1095.8 47.5 L 1093.5 48.8 L 1101.3 51.4 L 1091.0 48.0 L 1044.0 35.0 L 1043.0 65.0 L 1043.0 124.0 L 1057.0 123.0 L 1060.8 121.3 L 1068.7 119.2 L 1076.6 117.1 L 1084.0 115.0 L 1091.7 113.2 L 1095.2 113.3 L 1104.0 116.0 L 1106.0 108.0 Z",
      "position": {
        "x": 1074.6,
        "y": 80.6
      },
      "badgeAnchor": {
        "x": 1074.6,
        "y": 80.6
      },
      "badgeRadius": 31.4,
      "adjacencies": [
        "cobalt-steppe",
        "corona-w",
        "ozone-hollows",
        "quiet-plateau"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "dust-barrens",
      "name": "Dust Barrens",
      "shape": "M 541.0 484.0 L 531.0 469.0 L 532.3 459.8 L 534.0 450.5 L 533.2 444.8 L 531.6 438.4 L 528.7 433.3 L 523.2 427.8 L 517.8 422.2 L 512.0 416.4 L 509.0 411.0 L 505.9 410.1 L 497.2 409.8 L 491.8 408.7 L 486.7 406.8 L 479.3 401.7 L 474.0 396.5 L 469.0 391.5 L 464.0 386.5 L 459.2 382.8 L 455.0 379.0 L 452.1 379.7 L 444.2 377.8 L 439.5 376.5 L 435.0 374.0 L 433.1 365.9 L 433.0 359.5 L 433.0 353.0 L 428.2 346.8 L 423.7 343.8 L 419.0 341.0 L 391.0 362.0 L 390.6 367.4 L 392.2 371.3 L 397.6 379.4 L 398.8 383.7 L 399.0 389.0 L 396.0 397.0 L 392.7 401.7 L 390.3 405.5 L 401.5 414.5 L 398.5 417.5 L 385.5 416.5 L 385.4 416.6 L 407.0 444.0 L 405.7 445.6 L 406.0 446.0 L 460.7 447.0 L 460.8 446.4 L 459.1 444.3 L 458.5 443.5 L 458.5 431.5 L 466.5 425.5 L 466.5 423.5 L 470.5 419.5 L 484.5 419.5 L 489.5 427.5 L 492.5 427.5 L 495.5 430.5 L 495.5 445.5 L 487.5 450.5 L 487.5 453.5 L 486.0 455.0 L 484.6 456.4 L 521.2 490.0 L 523.0 489.0 Z",
      "position": {
        "x": 434.2,
        "y": 409.4
      },
      "badgeAnchor": {
        "x": 434.2,
        "y": 409.4
      },
      "badgeRadius": 32.8,
      "adjacencies": [
        "basalt-steppe",
        "chrome-dunes",
        "flint-plateau",
        "garnet-e-gate",
        "garnet-nne-tower",
        "lumen-crystal",
        "salt-ridge",
        "silica-scarp",
        "static-fields"
      ],
      "borderDice": {
        "garnet-nne-tower": {
          "attack": 5
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "dust-plateau",
      "name": "Dust Plateau",
      "shape": "M 109.0 804.0 L 93.0 834.0 L 124.0 835.0 L 121.0 849.0 L 127.0 848.5 L 133.5 848.0 L 138.2 848.8 L 143.7 849.8 L 149.0 850.0 L 160.0 821.0 L 154.9 814.6 L 147.6 809.4 L 142.7 806.8 L 138.0 804.0 L 132.4 803.1 L 123.0 803.0 L 116.2 803.2 Z",
      "position": {
        "x": 138.7,
        "y": 825.2
      },
      "badgeAnchor": {
        "x": 133.05,
        "y": 822.25
      },
      "badgeRadius": 17.7,
      "adjacencies": [
        "argent-basin",
        "chrome-ridge",
        "iron-drift",
        "salt-reach",
        "umbra-n-gate"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "dust-waste",
      "name": "Dust Waste",
      "shape": "M 391.2 216.7 L 396.4 208.4 L 402.1 200.6 L 406.2 196.2 L 410.3 192.3 L 416.3 187.8 L 422.0 183.0 L 427.0 159.0 L 424.3 152.7 L 422.2 146.8 L 422.0 141.0 L 421.9 136.1 L 420.9 129.7 L 420.0 124.0 L 398.0 103.0 L 374.0 100.0 L 359.0 110.0 L 339.0 93.0 L 325.0 102.0 L 321.9 101.1 L 316.5 101.0 L 311.8 100.7 L 305.0 98.5 L 299.0 96.0 L 297.0 112.0 L 279.0 131.0 L 286.0 147.0 L 250.0 183.0 L 251.5 187.5 L 255.0 192.0 L 262.9 192.9 L 271.2 190.2 L 277.0 190.0 L 283.2 193.8 L 288.0 201.0 L 297.0 202.0 L 301.4 198.9 L 305.2 195.2 L 310.5 188.0 L 315.4 180.9 L 319.4 173.9 L 323.4 167.4 L 328.0 162.0 L 340.0 161.0 L 344.5 164.0 L 348.6 167.4 L 352.3 173.7 L 353.9 180.6 L 353.5 189.0 L 351.1 194.7 L 348.0 199.5 L 345.4 203.9 L 344.2 209.7 L 344.0 215.0 L 342.0 215.5 L 342.0 216.5 L 350.2 218.8 L 356.9 220.0 L 363.4 222.1 L 368.0 224.7 L 373.5 228.0 L 383.7 227.8 L 387.7 226.3 L 385.8 224.9 L 388.0 224.0 Z",
      "position": {
        "x": 381.7,
        "y": 144.2
      },
      "badgeAnchor": {
        "x": 365.45,
        "y": 142.98
      },
      "badgeRadius": 40.4,
      "adjacencies": [
        "basalt-basin",
        "chrome-flats",
        "salt-dunes",
        "silica-fields",
        "static-hollows"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "east-warp",
      "name": "Eastrift Warp",
      "regionId": "east-warp",
      "shape": "M 1252.3 515.5 L 1251.3 512.2 L 1250.0 509.0 L 1248.4 506.0 L 1246.6 503.1 L 1244.4 500.5 L 1242.0 498.1 L 1239.3 495.9 L 1236.5 494.0 L 1233.5 492.4 L 1230.3 491.1 L 1227.0 490.1 L 1223.6 489.5 L 1220.2 489.1 L 1216.8 489.2 L 1213.4 489.6 L 1210.0 490.3 L 1206.8 491.3 L 1203.6 492.7 L 1200.6 494.4 L 1197.8 496.3 L 1195.2 498.5 L 1192.9 501.0 L 1190.8 503.7 L 1188.9 506.6 L 1187.4 509.7 L 1186.2 512.9 L 1185.3 516.2 L 1184.7 519.6 L 1184.5 523.0 L 1184.6 526.4 L 1185.1 529.9 L 1185.9 533.2 L 1187.0 536.5 L 1188.5 539.6 L 1190.3 542.6 L 1192.3 545.4 L 1194.7 547.9 L 1197.3 550.2 L 1200.1 552.3 L 1203.0 554.0 L 1206.2 555.5 L 1209.5 556.6 L 1212.8 557.3 L 1216.3 557.8 L 1219.7 557.9 L 1223.2 557.6 L 1226.6 557.0 L 1229.9 556.0 L 1233.1 554.8 L 1236.2 553.2 L 1239.1 551.3 L 1241.8 549.1 L 1244.2 546.6 L 1246.5 544.0 L 1248.4 541.1 L 1250.0 538.0 L 1251.3 534.8 L 1252.3 531.5 L 1252.9 528.1 L 1252.8 536.4 L 1253.2 535.5 L 1254.2 532.0 L 1254.9 528.4 L 1255.2 525.1 L 1255.2 521.9 L 1254.9 518.6 L 1254.2 515.0 L 1253.2 511.6 L 1252.9 510.8 L 1252.9 518.9 Z",
      "position": {
        "x": 1218.8,
        "y": 523.4
      },
      "badgeAnchor": {
        "x": 1218.8,
        "y": 523.4
      },
      "badgeRadius": 34.2,
      "adjacencies": [
        "glass-barrens",
        "jasper-e",
        "mica-scarp",
        "nexus-warp",
        "west-warp"
      ],
      "borderDice": {
        "glass-barrens": {
          "defend": 4
        },
        "jasper-e": {
          "defend": 4
        },
        "mica-scarp": {
          "defend": 4
        },
        "nexus-warp": {
          "attack": 5,
          "defend": 7
        },
        "west-warp": {
          "attack": 5,
          "defend": 7
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ember-basin",
      "name": "Ember Basin",
      "shape": "M 1008.8 746.8 L 1014.2 742.2 L 1019.0 735.0 L 1019.9 728.4 L 1019.9 719.6 L 1018.6 711.4 L 1017.0 704.0 L 1010.5 704.0 L 1003.6 703.9 L 998.2 702.8 L 990.3 699.7 L 982.0 696.5 L 973.4 693.6 L 966.0 690.0 L 963.0 691.5 L 957.5 697.0 L 951.9 702.4 L 947.8 704.8 L 943.0 707.0 L 938.0 707.0 L 932.7 706.8 L 924.1 704.9 L 915.0 703.0 L 916.0 712.0 L 917.0 720.0 L 916.1 727.1 L 915.0 734.0 L 912.9 734.4 L 912.7 735.7 L 924.4 737.2 L 934.1 739.5 L 939.8 739.1 L 946.8 740.3 L 953.2 741.8 L 959.8 743.6 L 966.4 745.4 L 971.5 747.1 L 976.8 749.4 L 984.1 750.1 L 993.0 752.0 L 1003.6 754.2 L 1005.0 752.9 L 1003.0 752.0 Z",
      "position": {
        "x": 976.7,
        "y": 721.9
      },
      "badgeAnchor": {
        "x": 976.7,
        "y": 721.9
      },
      "badgeRadius": 25.6,
      "adjacencies": [
        "halo-barrens",
        "quiet-hollows",
        "shale-fields"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ember-expanse",
      "name": "Ember Expanse",
      "shape": "M 837.0 325.0 L 838.0 330.0 L 842.0 336.0 L 859.0 338.0 L 861.8 342.2 L 863.3 348.2 L 865.6 353.9 L 869.1 357.4 L 873.8 359.7 L 879.6 360.9 L 885.5 361.0 L 891.3 360.8 L 896.8 359.8 L 902.0 358.5 L 908.8 356.2 L 915.4 353.4 L 921.8 351.3 L 931.3 351.2 L 937.3 352.7 L 946.0 357.0 L 953.3 362.2 L 960.6 367.4 L 968.0 372.0 L 970.8 370.2 L 973.0 365.0 L 971.7 355.8 L 969.1 347.9 L 967.2 340.4 L 967.2 337.2 L 969.0 332.0 L 974.8 329.3 L 980.8 327.3 L 988.0 326.0 L 994.5 325.0 L 1000.9 323.4 L 1007.0 320.0 L 1013.3 316.3 L 1019.0 313.0 L 1015.0 303.0 L 1013.0 303.4 L 1012.5 302.0 L 1014.4 301.1 L 1007.4 302.3 L 1001.1 303.9 L 991.9 304.3 L 984.6 306.2 L 978.6 307.9 L 969.0 308.0 L 959.5 308.0 L 950.4 308.0 L 940.3 309.2 L 932.8 310.7 L 925.4 312.3 L 918.5 313.8 L 909.3 314.5 L 903.6 316.1 L 898.8 317.0 L 894.0 316.8 L 888.6 315.3 L 879.7 316.9 L 872.6 316.9 L 867.7 314.7 L 862.5 312.8 L 858.4 312.5 L 849.9 309.5 L 846.1 310.1 L 847.0 312.0 Z",
      "position": {
        "x": 889.8,
        "y": 338.6
      },
      "badgeAnchor": {
        "x": 923.58,
        "y": 333.21
      },
      "badgeRadius": 22.1,
      "adjacencies": [
        "ashen-dunes",
        "halo-waste",
        "quiet-drift",
        "shale-hollows"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ember-reach",
      "name": "Ember Reach",
      "shape": "M 841.0 74.0 L 838.1 66.3 L 835.5 62.0 L 830.0 58.0 L 823.7 54.3 L 817.8 50.2 L 813.8 46.2 L 810.0 42.0 L 809.1 36.4 L 809.1 29.6 L 811.2 21.8 L 813.8 13.3 L 813.9 5.6 L 813.0 0.0 L 815.0 0.0 L 814.7 -2.0 L 709.8 -2.0 L 710.8 0.0 L 713.0 0.0 L 716.5 7.0 L 719.4 15.1 L 720.8 22.7 L 721.0 32.0 L 720.0 41.5 L 720.3 51.2 L 722.4 58.6 L 725.3 65.2 L 728.6 72.4 L 731.0 78.5 L 733.4 84.6 L 735.6 91.4 L 737.3 99.2 L 738.8 107.7 L 739.0 115.0 L 749.0 117.0 L 758.6 119.9 L 768.1 121.9 L 777.7 123.8 L 784.5 124.0 L 791.0 124.0 L 796.5 123.1 L 804.0 124.0 L 807.4 127.1 L 811.0 134.0 L 824.0 136.0 L 825.8 131.8 L 831.5 126.0 L 835.0 124.0 L 826.0 110.0 L 846.0 91.0 L 845.0 80.0 Z",
      "position": {
        "x": 779.4,
        "y": 76.6
      },
      "badgeAnchor": {
        "x": 769.82,
        "y": 60.77
      },
      "badgeRadius": 45.9,
      "adjacencies": [
        "ion-scarp",
        "mica-fields",
        "rust-steppe",
        "shale-drift"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ember-steppe",
      "name": "Ember Steppe",
      "shape": "M 758.2 997.2 L 755.3 1001.3 L 752.0 1005.5 L 745.9 1011.4 L 740.3 1015.3 L 734.0 1019.0 L 724.6 1019.9 L 719.8 1018.2 L 714.3 1016.2 L 708.6 1016.1 L 702.5 1017.0 L 699.0 1016.0 L 700.4 1014.3 L 698.7 1013.8 L 693.4 1017.1 L 688.4 1019.4 L 683.8 1023.8 L 679.7 1028.0 L 676.3 1033.1 L 671.0 1036.0 L 660.7 1045.0 L 830.8 1045.0 L 832.8 1043.0 L 830.0 1043.0 L 836.7 1036.2 L 844.0 1032.5 L 850.4 1030.4 L 859.5 1030.0 L 865.6 1030.9 L 874.0 1031.0 L 881.0 1029.0 L 881.0 1023.0 L 880.8 1017.7 L 878.7 1010.8 L 876.0 1004.5 L 873.2 998.3 L 870.5 992.5 L 866.0 984.0 L 861.0 976.0 L 856.2 973.3 L 848.0 973.0 L 839.0 981.0 L 834.0 986.0 L 828.4 986.9 L 823.8 986.7 L 816.8 984.7 L 810.1 981.9 L 803.6 978.9 L 796.6 976.4 L 790.9 975.1 L 782.0 975.0 L 773.8 979.8 L 767.5 985.0 L 763.4 989.9 L 760.0 992.0 Z",
      "position": {
        "x": 791.4,
        "y": 1010.9
      },
      "badgeAnchor": {
        "x": 791.4,
        "y": 1010.9
      },
      "badgeRadius": 34.1,
      "adjacencies": [
        "halo-plateau",
        "quiet-fields",
        "shale-scarp"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "flint-drift",
      "name": "Flint Drift",
      "shape": "M 425.5 629.0 L 430.6 626.1 L 440.1 624.1 L 449.0 624.0 L 453.0 637.0 L 468.0 640.0 L 474.8 638.8 L 481.6 637.1 L 488.0 636.0 L 495.0 636.5 L 501.6 637.4 L 508.0 638.0 L 518.0 625.0 L 537.0 622.0 L 543.2 616.2 L 549.2 610.2 L 553.5 603.0 L 557.1 595.6 L 559.3 590.3 L 560.8 584.8 L 561.9 577.4 L 562.0 568.0 L 527.0 558.0 L 524.7 557.3 L 485.7 588.5 L 486.9 590.4 L 489.5 594.5 L 492.5 594.5 L 495.5 597.5 L 495.5 612.5 L 487.5 617.5 L 487.5 620.5 L 484.5 623.5 L 470.5 623.5 L 464.5 615.5 L 462.5 615.5 L 458.5 611.5 L 458.5 598.5 L 459.0 598.1 L 460.8 596.8 L 460.7 595.8 L 411.6 600.9 L 399.6 591.1 L 398.7 592.3 L 400.0 594.0 L 394.5 601.5 L 393.3 607.8 L 392.0 614.5 L 390.7 621.2 L 388.0 625.0 L 387.9 625.0 L 387.1 627.9 L 388.0 628.0 L 388.0 630.0 L 420.0 632.0 Z",
      "position": {
        "x": 525.3,
        "y": 593.6
      },
      "badgeAnchor": {
        "x": 525.3,
        "y": 593.6
      },
      "badgeRadius": 28.7,
      "adjacencies": [
        "argent-expanse",
        "garnet-e-gate",
        "garnet-sse-tower",
        "silica-flats",
        "umber-hollows",
        "vapor-reach",
        "vesper-crystal"
      ],
      "borderDice": {
        "garnet-sse-tower": {
          "attack": 5
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "flint-hollows",
      "name": "Flint Hollows",
      "shape": "M 200.3 908.8 L 209.2 907.2 L 218.4 905.4 L 227.6 904.1 L 233.5 904.0 L 239.5 903.1 L 245.0 904.0 L 252.5 904.0 L 260.5 904.0 L 269.0 903.0 L 276.2 899.2 L 281.6 893.1 L 285.8 889.8 L 290.4 886.9 L 295.0 884.5 L 300.0 882.5 L 307.0 882.0 L 308.3 879.3 L 312.0 875.5 L 315.8 871.8 L 322.3 866.3 L 328.4 861.4 L 335.0 857.0 L 341.1 852.6 L 349.0 848.0 L 356.7 843.2 L 364.5 839.0 L 371.7 834.7 L 376.0 833.0 L 368.0 821.0 L 369.7 819.9 L 369.0 818.9 L 358.2 819.9 L 348.1 820.8 L 344.0 823.0 L 338.4 827.9 L 334.1 830.2 L 329.5 832.7 L 323.8 833.7 L 317.8 834.9 L 309.9 834.1 L 304.4 835.8 L 300.2 836.0 L 294.0 834.7 L 288.8 832.7 L 281.7 829.1 L 276.8 825.8 L 271.7 821.7 L 265.6 818.7 L 256.8 817.0 L 248.3 815.8 L 239.9 812.5 L 236.1 813.0 L 238.3 813.5 L 238.1 814.7 L 236.0 815.0 L 234.6 822.6 L 231.0 829.0 L 215.0 828.0 L 210.0 831.5 L 206.2 835.2 L 202.4 839.4 L 198.5 846.0 L 195.2 852.7 L 191.7 859.7 L 188.1 866.6 L 186.0 869.0 L 186.7 871.8 L 191.3 879.7 L 193.7 886.8 L 194.9 895.6 L 195.0 902.0 L 195.0 909.0 Z",
      "position": {
        "x": 254.4,
        "y": 862.4
      },
      "badgeAnchor": {
        "x": 254.4,
        "y": 862.4
      },
      "badgeRadius": 40.8,
      "adjacencies": [
        "argent-basin",
        "chrome-ridge",
        "ochre-drift",
        "vapor-expanse"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "flint-plateau",
      "name": "Flint Plateau",
      "shape": "M 422.6 321.6 L 420.1 328.1 L 418.3 334.2 L 419.0 341.0 L 423.7 343.8 L 428.2 346.8 L 433.0 353.0 L 433.0 359.5 L 433.1 365.9 L 435.0 374.0 L 439.5 376.5 L 444.2 377.8 L 452.1 379.7 L 455.0 379.0 L 457.1 376.6 L 462.1 373.6 L 466.6 370.6 L 473.0 365.5 L 479.0 359.5 L 484.2 353.2 L 490.2 347.2 L 496.1 341.6 L 501.4 338.4 L 508.5 337.0 L 515.0 335.0 L 516.9 325.5 L 515.7 318.8 L 514.2 312.3 L 514.0 303.5 L 516.0 294.0 L 519.0 289.0 L 522.3 284.3 L 526.2 280.2 L 530.0 276.5 L 535.9 271.9 L 537.0 270.0 L 535.1 268.4 L 526.4 265.6 L 520.4 262.6 L 515.5 258.0 L 511.0 252.5 L 508.0 251.0 L 503.8 256.3 L 499.8 261.3 L 493.4 264.4 L 487.6 264.9 L 478.9 263.1 L 469.0 263.0 L 464.3 265.8 L 460.0 268.4 L 454.4 268.9 L 449.2 269.2 L 445.0 271.0 L 447.8 276.2 L 446.0 272.8 L 444.1 273.5 L 446.0 277.0 L 447.8 282.6 L 447.8 287.1 L 446.2 292.6 L 447.8 296.8 L 444.9 301.3 L 439.9 304.1 L 434.3 310.9 L 429.6 313.1 L 424.7 315.1 L 423.3 315.0 L 425.2 315.3 L 425.0 317.2 L 425.0 317.2 L 423.0 317.0 Z",
      "position": {
        "x": 479.4,
        "y": 310.6
      },
      "badgeAnchor": {
        "x": 472.03,
        "y": 309.98
      },
      "badgeRadius": 34.5,
      "adjacencies": [
        "basalt-steppe",
        "chrome-flats",
        "dust-barrens",
        "frost-shelf",
        "static-fields"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "frost-barrens",
      "name": "Frost Barrens",
      "shape": "M 408.7 742.8 L 405.4 739.5 L 404.9 740.4 L 402.9 739.8 L 407.2 744.2 L 411.6 749.2 L 413.9 755.0 L 411.2 762.5 L 412.9 770.1 L 411.9 776.2 L 409.7 781.4 L 408.1 787.3 L 406.1 791.4 L 402.3 797.6 L 403.9 798.7 L 405.0 797.0 L 418.0 806.0 L 421.0 817.0 L 421.4 819.0 L 453.5 816.9 L 452.0 815.0 L 454.1 806.1 L 455.9 796.9 L 457.8 787.3 L 459.0 778.0 L 459.0 771.5 L 459.1 764.1 L 460.1 757.1 L 461.6 749.6 L 463.0 742.0 L 431.0 732.0 L 426.4 731.1 L 419.3 727.7 L 413.0 724.0 L 404.0 738.0 Z",
      "position": {
        "x": 433.7,
        "y": 785.8
      },
      "badgeAnchor": {
        "x": 433.7,
        "y": 785.8
      },
      "badgeRadius": 23.8,
      "adjacencies": [
        "argent-expanse",
        "cobalt-waste",
        "ochre-drift",
        "sable-dunes",
        "silica-flats"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "frost-shelf",
      "name": "Frost Shelf",
      "shape": "M 559.0 204.0 L 516.0 165.0 L 507.0 172.0 L 505.2 177.7 L 505.0 184.0 L 506.5 189.0 L 507.8 194.7 L 508.0 204.0 L 497.0 219.0 L 497.0 224.0 L 497.6 229.9 L 499.6 234.9 L 503.0 240.5 L 506.3 246.2 L 508.0 251.0 L 511.0 252.5 L 515.5 258.0 L 520.4 262.6 L 526.4 265.6 L 535.1 268.4 L 537.0 270.0 L 545.0 267.0 L 548.0 254.0 L 561.0 249.0 L 569.0 237.0 L 570.0 233.0 L 574.4 226.4 L 581.0 219.4 L 586.3 211.8 L 587.8 206.8 L 588.7 201.2 L 589.3 194.8 L 591.2 190.7 L 594.8 185.8 L 598.5 182.0 L 602.9 178.4 L 604.7 175.5 L 602.5 175.5 L 599.5 172.5 L 599.5 158.5 L 600.0 158.1 L 601.8 156.7 L 601.7 155.7 L 587.3 157.9 L 587.0 160.0 Z",
      "position": {
        "x": 533.1,
        "y": 225.2
      },
      "badgeAnchor": {
        "x": 533.1,
        "y": 225.2
      },
      "badgeRadius": 32.4,
      "adjacencies": [
        "chrome-flats",
        "flint-plateau",
        "static-fields",
        "static-hollows",
        "vapor-ridge",
        "zenith-s-tower",
        "zenith-sw-gate"
      ],
      "borderDice": {
        "zenith-s-tower": {
          "attack": 5
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "frost-waste",
      "name": "Frost Waste",
      "shape": "M 711.0 437.5 L 704.8 442.8 L 700.0 449.0 L 696.7 455.7 L 693.4 462.4 L 691.0 470.0 L 689.0 478.0 L 734.0 490.0 L 736.3 490.6 L 771.0 458.9 L 771.0 458.5 L 770.5 458.5 L 769.0 456.5 L 764.5 450.5 L 762.5 450.5 L 758.5 446.5 L 758.5 433.5 L 766.5 427.5 L 766.5 425.5 L 770.5 421.5 L 783.5 421.5 L 789.5 429.5 L 791.5 429.5 L 795.5 433.5 L 795.5 446.5 L 794.9 446.9 L 793.3 448.1 L 794.0 449.0 L 847.3 447.0 L 854.2 452.8 L 855.1 451.8 L 854.0 450.0 L 859.3 443.8 L 860.0 439.0 L 853.0 415.0 L 844.0 415.0 L 835.8 415.3 L 831.5 416.5 L 823.0 421.5 L 816.0 424.5 L 809.5 425.0 L 803.0 425.0 L 800.3 421.7 L 800.9 415.5 L 800.0 412.0 L 783.0 411.0 L 743.0 413.0 L 737.0 418.5 L 730.8 424.3 L 724.8 426.3 L 718.0 428.0 L 716.7 431.7 Z",
      "position": {
        "x": 730.4,
        "y": 457.8
      },
      "badgeAnchor": {
        "x": 737.38,
        "y": 451.32
      },
      "badgeRadius": 28.1,
      "adjacencies": [
        "chrome-dunes",
        "pale-basin",
        "sable-flats",
        "shale-hollows",
        "topaz-nnw-tower",
        "topaz-w-gate"
      ],
      "borderDice": {
        "topaz-nnw-tower": {
          "attack": 5
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "garnet-core",
      "name": "Garnet Core",
      "regionId": "garnet-mesa",
      "shape": "M 448.9 537.9 L 451.8 536.3 L 454.3 534.3 L 456.4 531.8 L 458.0 529.0 L 458.9 526.3 L 459.4 523.4 L 459.4 520.6 L 458.9 517.7 L 458.0 515.0 L 456.4 512.2 L 454.3 509.8 L 451.8 507.8 L 448.9 506.2 L 446.2 505.4 L 443.4 505.0 L 440.6 505.1 L 437.9 505.6 L 435.2 506.5 L 432.5 508.1 L 430.1 510.1 L 428.2 512.5 L 426.7 515.3 L 425.6 518.6 L 425.3 522.0 L 425.6 525.4 L 426.6 528.7 L 428.1 531.5 L 430.1 534.0 L 432.5 536.0 L 435.2 537.6 L 437.9 538.5 L 440.6 539.1 L 443.4 539.1 L 446.2 538.7 Z",
      "position": {
        "x": 442.4,
        "y": 522.1
      },
      "badgeAnchor": {
        "x": 442.4,
        "y": 522.1
      },
      "badgeRadius": 17,
      "adjacencies": [
        "garnet-e",
        "garnet-n",
        "garnet-ne",
        "garnet-nw",
        "garnet-s",
        "garnet-se",
        "garnet-sw",
        "garnet-w"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "garnet-e",
      "name": "Garnet East",
      "regionId": "garnet-mesa",
      "shape": "M 458.0 515.0 L 458.9 517.7 L 459.4 520.6 L 459.4 523.4 L 458.9 526.3 L 458.0 529.0 L 510.0 550.0 L 510.0 495.0 Z",
      "position": {
        "x": 491.2,
        "y": 522.3
      },
      "badgeAnchor": {
        "x": 491.2,
        "y": 522.3
      },
      "badgeRadius": 18.6,
      "adjacencies": [
        "garnet-core",
        "garnet-e-gate",
        "garnet-ne",
        "garnet-se"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "garnet-e-gate",
      "name": "Garnet East Gate",
      "shape": "M 562.0 568.0 L 573.0 569.0 L 573.0 523.0 L 573.0 477.0 L 541.0 484.0 L 523.0 489.0 L 521.2 490.0 L 519.6 488.6 L 515.6 490.9 L 508.0 489.6 L 508.0 489.8 L 510.0 492.0 L 510.0 495.0 L 510.0 550.0 L 511.0 553.0 L 509.4 554.6 L 522.8 558.8 L 524.7 557.3 L 527.0 558.0 Z",
      "position": {
        "x": 541.6,
        "y": 523.1
      },
      "badgeAnchor": {
        "x": 541.6,
        "y": 523.1
      },
      "badgeRadius": 31.4,
      "adjacencies": [
        "chrome-dunes",
        "dust-barrens",
        "flint-drift",
        "garnet-e",
        "nexus-warp",
        "vapor-reach"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "garnet-n",
      "name": "Garnet North",
      "regionId": "garnet-mesa",
      "shape": "M 435.2 506.5 L 437.9 505.6 L 440.6 505.1 L 443.4 505.0 L 446.2 505.4 L 448.9 506.2 L 469.6 455.1 L 467.9 452.6 L 466.5 450.5 L 465.7 450.1 L 413.2 455.3 L 414.1 457.7 L 416.0 457.0 Z",
      "position": {
        "x": 442.3,
        "y": 471.8
      },
      "badgeAnchor": {
        "x": 442.3,
        "y": 471.8
      },
      "badgeRadius": 19,
      "adjacencies": [
        "garnet-core",
        "garnet-ne",
        "garnet-nne-tower",
        "garnet-nw"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "garnet-ne",
      "name": "Garnet Northeast",
      "regionId": "garnet-mesa",
      "shape": "M 454.3 509.8 L 456.4 512.2 L 458.0 515.0 L 510.0 495.0 L 510.0 492.0 L 508.0 489.8 L 508.0 489.6 L 511.0 490.1 L 480.3 456.5 L 476.7 456.5 L 470.5 456.5 L 469.6 455.1 L 448.9 506.2 L 451.8 507.8 Z",
      "position": {
        "x": 479.1,
        "y": 485.3
      },
      "badgeAnchor": {
        "x": 479.1,
        "y": 485.3
      },
      "badgeRadius": 20.1,
      "adjacencies": [
        "garnet-core",
        "garnet-e",
        "garnet-n",
        "garnet-nne-tower"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "garnet-nne-tower",
      "name": "Garnet North-Northeast Tower",
      "regionId": "garnet-nne-tower",
      "shape": "M 470.5 419.5 L 466.5 423.5 L 466.5 425.5 L 458.5 431.5 L 458.5 443.5 L 462.5 448.5 L 466.5 450.5 L 470.5 456.5 L 484.5 456.5 L 487.5 453.5 L 487.5 450.5 L 495.5 445.5 L 495.5 430.5 L 492.5 427.5 L 489.5 427.5 L 484.5 419.5 Z",
      "position": {
        "x": 477.5,
        "y": 438
      },
      "badgeAnchor": {
        "x": 477.5,
        "y": 438
      },
      "badgeRadius": 15.9,
      "badgeShrinksWithDigits": true,
      "adjacencies": [
        "dust-barrens",
        "garnet-n",
        "garnet-ne"
      ],
      "oneWayBorders": [
        "basalt-steppe",
        "chrome-dunes",
        "flint-plateau",
        "lumen-crystal",
        "salt-ridge",
        "silica-scarp",
        "static-fields"
      ],
      "borderDice": {
        "dust-barrens": {
          "defend": 7
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "garnet-nw",
      "name": "Garnet Northwest",
      "regionId": "garnet-mesa",
      "shape": "M 389.5 482.5 L 381.5 486.5 L 381.5 490.5 L 379.5 492.5 L 376.3 492.5 L 374.0 492.5 L 373.9 492.6 L 374.0 492.6 L 374.0 493.5 L 376.0 493.0 L 426.7 515.3 L 428.2 512.5 L 430.1 510.1 L 432.5 508.1 L 435.2 506.5 L 416.0 457.0 L 414.1 457.7 L 413.4 455.9 L 404.8 459.3 L 391.7 475.9 L 390.6 472.5 L 389.5 474.1 L 389.5 477.8 Z",
      "position": {
        "x": 407.7,
        "y": 486.4
      },
      "badgeAnchor": {
        "x": 407.7,
        "y": 486.4
      },
      "badgeRadius": 18.4,
      "adjacencies": [
        "beryl-ene-tower",
        "garnet-core",
        "garnet-n",
        "garnet-w"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "garnet-s",
      "name": "Garnet South",
      "regionId": "garnet-mesa",
      "shape": "M 468.9 588.8 L 448.9 537.9 L 446.2 538.7 L 443.4 539.1 L 440.6 539.1 L 437.9 538.5 L 435.2 537.6 L 416.0 587.0 L 414.0 586.7 L 413.2 588.8 L 465.9 592.9 L 466.5 592.5 L 468.5 589.5 Z",
      "position": {
        "x": 442.1,
        "y": 571.9
      },
      "badgeAnchor": {
        "x": 442.1,
        "y": 571.9
      },
      "badgeRadius": 18.8,
      "adjacencies": [
        "garnet-core",
        "garnet-se",
        "garnet-sse-tower",
        "garnet-sw"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "garnet-se",
      "name": "Garnet Southeast",
      "regionId": "garnet-mesa",
      "shape": "M 454.3 534.3 L 451.8 536.3 L 448.9 537.9 L 468.9 588.8 L 470.5 586.5 L 477.3 586.5 L 481.3 586.5 L 511.6 555.3 L 509.4 554.6 L 511.0 553.0 L 510.0 550.0 L 458.0 529.0 L 456.4 531.8 Z",
      "position": {
        "x": 479.2,
        "y": 559.4
      },
      "badgeAnchor": {
        "x": 479.2,
        "y": 559.4
      },
      "badgeRadius": 20.2,
      "adjacencies": [
        "garnet-core",
        "garnet-e",
        "garnet-s",
        "garnet-sse-tower"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "garnet-sse-tower",
      "name": "Garnet South-Southeast Tower",
      "regionId": "garnet-sse-tower",
      "shape": "M 470.5 586.5 L 466.5 592.5 L 458.5 598.5 L 458.5 611.5 L 462.5 615.5 L 464.5 615.5 L 470.5 623.5 L 484.5 623.5 L 487.5 620.5 L 487.5 617.5 L 495.5 612.5 L 495.5 597.5 L 492.5 594.5 L 489.5 594.5 L 484.5 586.5 Z",
      "position": {
        "x": 477.5,
        "y": 605
      },
      "badgeAnchor": {
        "x": 477.5,
        "y": 605
      },
      "badgeRadius": 15.9,
      "badgeShrinksWithDigits": true,
      "adjacencies": [
        "flint-drift",
        "garnet-s",
        "garnet-se"
      ],
      "oneWayBorders": [
        "argent-expanse",
        "silica-flats",
        "umber-hollows",
        "vapor-reach",
        "vesper-crystal"
      ],
      "borderDice": {
        "flint-drift": {
          "defend": 7
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "garnet-sw",
      "name": "Garnet Southwest",
      "regionId": "garnet-mesa",
      "shape": "M 416.0 587.0 L 435.2 537.6 L 432.5 536.0 L 430.1 534.0 L 428.1 531.5 L 426.6 528.7 L 376.2 550.5 L 378.5 550.5 L 382.5 555.5 L 381.5 556.5 L 383.5 558.5 L 386.5 558.5 L 390.5 563.5 L 390.0 570.0 L 389.8 572.5 L 408.1 587.9 L 413.2 588.6 L 414.0 586.7 Z",
      "position": {
        "x": 407.9,
        "y": 557.1
      },
      "badgeAnchor": {
        "x": 407.9,
        "y": 557.1
      },
      "badgeRadius": 18.4,
      "adjacencies": [
        "beryl-ese-tower",
        "garnet-core",
        "garnet-s",
        "garnet-w"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "garnet-w",
      "name": "Garnet West",
      "regionId": "garnet-mesa",
      "shape": "M 372.0 494.0 L 372.0 550.0 L 373.5 550.5 L 376.2 550.5 L 426.6 528.7 L 425.6 525.4 L 425.3 522.0 L 425.6 518.6 L 426.7 515.3 L 376.0 493.0 Z",
      "position": {
        "x": 392.2,
        "y": 521.9
      },
      "badgeAnchor": {
        "x": 392.2,
        "y": 521.9
      },
      "badgeRadius": 19.9,
      "adjacencies": [
        "beryl-e",
        "beryl-ene-tower",
        "beryl-ese-tower",
        "garnet-core",
        "garnet-nw",
        "garnet-sw"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ghost-basin",
      "name": "Ghost Basin",
      "shape": "M 177.0 673.0 L 182.3 670.8 L 188.3 665.8 L 194.5 661.5 L 201.1 660.1 L 209.8 659.8 L 215.3 657.3 L 222.2 652.2 L 229.1 646.6 L 236.0 642.0 L 241.6 641.1 L 247.0 641.0 L 252.9 641.1 L 258.0 642.0 L 270.0 602.0 L 268.3 600.4 L 268.8 598.2 L 234.2 566.5 L 206.0 584.9 L 206.0 585.2 L 208.0 587.8 L 211.5 592.5 L 213.5 592.5 L 217.5 596.5 L 217.5 609.5 L 209.5 615.5 L 209.5 617.5 L 205.5 621.5 L 192.5 621.5 L 186.5 613.5 L 184.5 613.5 L 180.5 609.5 L 180.5 597.0 L 180.5 596.5 L 182.5 595.0 L 182.5 591.3 L 181.3 591.0 L 177.8 598.0 L 146.3 597.0 L 147.9 597.4 L 148.0 599.1 L 146.0 599.0 L 146.3 605.2 L 149.5 614.0 L 147.0 622.0 L 167.0 634.0 Z",
      "position": {
        "x": 242.2,
        "y": 608.6
      },
      "badgeAnchor": {
        "x": 242.2,
        "y": 608.6
      },
      "badgeRadius": 24.7,
      "adjacencies": [
        "beryl-s-gate",
        "cinder-steppe",
        "ion-dunes",
        "ozone-fields",
        "quartz-sse-tower"
      ],
      "borderDice": {
        "quartz-sse-tower": {
          "attack": 5
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ghost-expanse",
      "name": "Ghost Expanse",
      "shape": "M 1175.0 211.0 L 1128.0 211.0 L 1130.0 198.0 L 1102.0 196.0 L 1101.6 200.6 L 1099.6 205.6 L 1097.4 210.4 L 1095.3 218.8 L 1096.0 226.0 L 1100.1 231.4 L 1105.9 235.6 L 1112.0 239.5 L 1118.0 243.0 L 1123.2 244.2 L 1129.1 245.9 L 1136.0 246.0 L 1143.5 246.0 L 1150.6 244.6 L 1158.3 241.8 L 1166.0 235.5 L 1170.2 229.7 L 1172.7 223.2 L 1174.2 217.2 Z",
      "position": {
        "x": 1136.2,
        "y": 228.2
      },
      "badgeAnchor": {
        "x": 1136.2,
        "y": 228.2
      },
      "badgeRadius": 17.2,
      "adjacencies": [
        "ashen-dunes",
        "corona-s-gate",
        "ozone-hollows",
        "umber-drift"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ghost-steppe",
      "name": "Ghost Steppe",
      "shape": "M 1128.0 834.0 L 1211.0 833.0 L 1211.9 829.4 L 1216.9 820.9 L 1218.0 813.0 L 1212.2 805.8 L 1206.5 799.0 L 1201.0 792.0 L 1199.2 787.3 L 1199.0 779.0 L 1203.5 773.0 L 1208.3 768.8 L 1212.9 764.9 L 1214.0 763.0 L 1213.1 761.4 L 1209.3 758.7 L 1205.4 754.6 L 1202.9 749.1 L 1201.0 744.0 L 1191.5 743.1 L 1182.0 744.0 L 1172.8 745.3 L 1164.3 747.8 L 1156.0 750.5 L 1148.0 753.5 L 1139.8 756.3 L 1133.7 759.2 L 1127.9 761.9 L 1121.5 763.0 L 1113.1 762.9 L 1107.8 761.7 L 1100.5 758.0 L 1093.3 754.2 L 1085.9 751.1 L 1078.4 748.6 L 1071.2 746.3 L 1065.3 745.2 L 1060.0 745.0 L 1054.3 749.3 L 1050.4 754.4 L 1047.4 760.4 L 1046.0 766.0 L 1044.1 766.8 L 1061.9 788.6 L 1060.1 809.1 L 1046.9 823.3 L 1047.0 824.5 L 1049.0 824.0 L 1049.6 830.4 L 1053.0 837.0 L 1077.0 834.0 L 1097.0 849.0 L 1100.6 849.9 L 1106.5 850.0 L 1112.9 850.1 L 1122.2 851.8 L 1132.0 853.0 Z",
      "position": {
        "x": 1154.4,
        "y": 793.7
      },
      "badgeAnchor": {
        "x": 1135.14,
        "y": 801.45
      },
      "badgeRadius": 40,
      "adjacencies": [
        "cobalt-barrens",
        "hollow-expanse",
        "ion-ridge",
        "penumbra-n-gate",
        "quiet-hollows",
        "umber-fields"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "glass-barrens",
      "name": "Glass Barrens",
      "shape": "M 1132.7 609.8 L 1134.8 619.7 L 1136.0 629.0 L 1136.0 635.5 L 1135.8 641.3 L 1134.8 648.3 L 1133.2 655.2 L 1132.0 662.0 L 1136.8 663.7 L 1143.4 664.8 L 1150.7 663.2 L 1157.9 660.9 L 1165.2 659.2 L 1172.0 659.0 L 1179.0 658.0 L 1182.0 656.5 L 1186.0 652.5 L 1190.2 648.2 L 1194.2 641.7 L 1198.0 635.0 L 1202.4 628.4 L 1208.0 622.0 L 1223.0 623.0 L 1242.0 594.0 L 1252.0 600.0 L 1252.9 528.1 L 1252.3 531.5 L 1251.3 534.8 L 1250.0 538.0 L 1248.4 541.1 L 1246.5 544.0 L 1244.2 546.6 L 1241.8 549.1 L 1239.1 551.3 L 1236.2 553.2 L 1233.1 554.8 L 1229.9 556.0 L 1226.6 557.0 L 1223.2 557.6 L 1219.7 557.9 L 1216.3 557.8 L 1212.8 557.3 L 1209.5 556.6 L 1206.2 555.5 L 1203.0 554.0 L 1200.1 552.3 L 1197.3 550.2 L 1194.7 547.9 L 1192.3 545.4 L 1190.3 542.6 L 1188.5 539.6 L 1187.0 536.5 L 1185.9 533.2 L 1185.1 529.9 L 1184.6 526.4 L 1184.5 523.0 L 1173.0 523.0 L 1168.0 538.9 L 1168.5 538.5 L 1180.5 538.5 L 1186.5 546.5 L 1188.5 546.5 L 1192.5 550.5 L 1192.5 564.5 L 1184.5 569.5 L 1184.5 572.5 L 1181.5 575.5 L 1166.5 575.5 L 1163.5 572.5 L 1163.5 569.5 L 1161.5 567.5 L 1158.6 567.5 L 1131.0 600.0 Z",
      "position": {
        "x": 1170.2,
        "y": 611.8
      },
      "badgeAnchor": {
        "x": 1170.2,
        "y": 611.8
      },
      "badgeRadius": 36,
      "adjacencies": [
        "ashen-ridge",
        "east-warp",
        "hollow-expanse",
        "jasper-ese-tower",
        "mica-scarp",
        "quiet-hollows"
      ],
      "borderDice": {
        "jasper-ese-tower": {
          "attack": 5
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "glass-plateau",
      "name": "Glass Plateau",
      "shape": "M 1004.0 864.0 L 1002.8 866.3 L 997.8 870.8 L 992.5 875.0 L 986.5 881.0 L 980.2 887.2 L 974.2 893.7 L 968.0 900.0 L 975.0 919.0 L 956.0 937.0 L 953.0 955.0 L 954.3 964.2 L 956.3 973.2 L 958.5 978.0 L 961.0 982.0 L 964.0 981.0 L 969.5 976.0 L 974.8 970.8 L 981.0 966.0 L 987.1 961.6 L 993.4 957.4 L 1001.0 953.5 L 1006.8 951.3 L 1012.0 949.5 L 1017.5 949.0 L 1022.2 949.3 L 1031.3 953.2 L 1039.7 957.3 L 1043.0 958.0 L 1043.0 923.0 L 1046.9 922.1 L 1056.0 924.0 L 1054.0 900.0 L 1050.3 898.7 L 1043.8 893.2 L 1037.2 887.8 L 1031.0 882.0 L 1024.5 876.0 L 1019.7 872.3 L 1014.9 868.6 L 1010.8 866.2 Z",
      "position": {
        "x": 1009.6,
        "y": 910.9
      },
      "badgeAnchor": {
        "x": 1009.6,
        "y": 910.9
      },
      "badgeRadius": 35.5,
      "adjacencies": [
        "ashen-reach",
        "cobalt-barrens",
        "hollow-basin",
        "ion-ridge",
        "penumbra-w-gate",
        "quiet-fields"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "glass-shelf",
      "name": "Glass Shelf",
      "shape": "M 421.7 4.5 L 421.0 8.0 L 413.3 12.3 L 406.0 16.0 L 399.8 17.8 L 393.5 18.0 L 387.5 18.0 L 380.0 17.0 L 373.0 17.0 L 369.0 20.0 L 369.0 25.5 L 369.2 30.3 L 371.7 39.3 L 375.5 47.0 L 379.2 54.3 L 383.2 61.3 L 387.4 67.6 L 392.0 73.0 L 396.7 74.5 L 402.0 74.0 L 416.0 64.0 L 421.2 61.2 L 431.0 61.0 L 439.7 65.3 L 448.7 69.3 L 455.0 71.5 L 461.1 72.9 L 470.0 73.0 L 474.3 70.8 L 478.9 68.4 L 484.2 63.2 L 490.0 57.5 L 493.0 56.0 L 495.0 51.0 L 499.0 45.5 L 505.6 39.0 L 512.5 33.0 L 516.5 30.1 L 521.0 27.0 L 527.1 26.4 L 535.1 30.9 L 540.6 30.6 L 546.5 30.0 L 552.0 31.0 L 550.5 32.8 L 552.3 33.1 L 558.3 29.8 L 564.2 25.0 L 570.1 20.2 L 576.2 14.2 L 582.4 7.9 L 591.6 -2.0 L 422.7 -2.0 L 423.0 0.0 L 421.0 0.0 Z",
      "position": {
        "x": 460.6,
        "y": 34.4
      },
      "badgeAnchor": {
        "x": 460.6,
        "y": 34.4
      },
      "badgeRadius": 36.4,
      "adjacencies": [
        "basalt-basin",
        "pale-expanse",
        "static-hollows"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "glass-waste",
      "name": "Glass Waste",
      "shape": "M 13.0 456.0 L 20.0 455.0 L 37.0 425.0 L 45.3 424.8 L 51.0 423.0 L 54.8 418.8 L 58.4 413.9 L 63.0 406.0 L 67.6 398.1 L 74.7 391.7 L 76.0 389.0 L 74.5 382.0 L 72.9 375.1 L 69.8 369.7 L 66.8 364.6 L 64.3 356.2 L 64.0 350.5 L 64.0 345.5 L 65.0 337.0 L 64.0 329.0 L 51.0 319.0 L 50.0 299.0 L 47.0 289.0 L 36.0 284.0 L 19.0 285.0 L 11.0 269.0 L 0.0 264.0 L 0.0 261.8 L -2.0 260.9 L -2.0 443.8 L 0.0 445.8 L 0.0 443.0 Z",
      "position": {
        "x": 34.4,
        "y": 381.9
      },
      "badgeAnchor": {
        "x": 27.03,
        "y": 359.5
      },
      "badgeRadius": 36.4,
      "adjacencies": [
        "argent-reach",
        "hollow-ridge",
        "ion-flats",
        "jade-reach"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "halcyon-core",
      "name": "Halcyon Core",
      "regionId": "halcyon-mesa",
      "shape": "M 72.8 97.4 L 75.5 98.5 L 78.3 99.0 L 81.2 99.1 L 84.1 98.7 L 86.9 97.8 L 89.8 96.2 L 92.4 94.1 L 94.5 91.5 L 96.1 88.6 L 97.0 85.8 L 97.5 82.8 L 97.4 79.8 L 96.8 76.9 L 95.7 74.2 L 94.0 71.4 L 91.8 69.1 L 89.3 67.1 L 86.4 65.7 L 83.3 64.8 L 80.1 64.6 L 76.9 64.9 L 73.8 65.8 L 71.0 67.2 L 68.5 69.2 L 66.3 71.6 L 64.7 74.3 L 63.6 77.1 L 63.0 80.0 L 63.0 83.0 L 63.4 86.0 L 64.4 88.8 L 65.9 91.5 L 67.8 93.9 L 70.1 95.9 Z",
      "position": {
        "x": 80.2,
        "y": 81.8
      },
      "badgeAnchor": {
        "x": 80.2,
        "y": 81.8
      },
      "badgeRadius": 17.2,
      "adjacencies": [
        "halcyon-e",
        "halcyon-n",
        "halcyon-s",
        "halcyon-se",
        "halcyon-sw",
        "halcyon-w"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "halcyon-crystal",
      "name": "Halcyon Crystal",
      "regionId": "halcyon-crystal",
      "shape": "M 55.5 20.5 L 52.5 26.5 L 43.5 32.5 L 43.5 38.5 L 28.5 50.5 L 30.5 52.5 L 45.5 53.5 L 50.5 61.5 L 57.5 59.5 L 67.5 62.5 L 68.5 57.5 L 72.5 52.5 L 81.5 50.5 L 85.5 47.5 L 73.5 38.5 L 80.5 27.5 L 77.5 24.5 L 64.5 28.5 Z",
      "position": {
        "x": 58.6,
        "y": 43.6
      },
      "badgeAnchor": {
        "x": 58.6,
        "y": 43.6
      },
      "badgeRadius": 15.7,
      "badgeShrinksWithDigits": true,
      "adjacencies": [
        "halcyon-n"
      ],
      "borderDice": {
        "halcyon-n": {
          "defend": 4
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "halcyon-e",
      "name": "Halcyon East",
      "regionId": "halcyon-mesa",
      "shape": "M 146.0 108.0 L 146.0 54.0 L 95.7 74.2 L 96.8 76.9 L 97.4 79.8 L 97.5 82.8 L 97.0 85.8 L 96.1 88.6 Z",
      "position": {
        "x": 127.6,
        "y": 81.2
      },
      "badgeAnchor": {
        "x": 127.6,
        "y": 81.2
      },
      "badgeRadius": 18.3,
      "adjacencies": [
        "halcyon-core",
        "halcyon-e-gate",
        "halcyon-n",
        "halcyon-se"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "halcyon-e-gate",
      "name": "Halcyon East Gate",
      "shape": "M 146.0 108.0 L 147.0 117.0 L 153.2 115.2 L 160.8 114.3 L 168.3 116.2 L 176.2 118.3 L 184.2 120.3 L 192.2 122.3 L 196.0 124.0 L 208.0 125.0 L 208.0 93.0 L 208.0 36.0 L 158.0 47.0 L 156.0 47.7 L 154.9 45.9 L 144.3 49.5 L 146.0 51.0 L 146.0 54.0 Z",
      "position": {
        "x": 177.1,
        "y": 80.6
      },
      "badgeAnchor": {
        "x": 177.1,
        "y": 80.6
      },
      "badgeRadius": 30.9,
      "adjacencies": [
        "ashen-flats",
        "halcyon-e",
        "iron-barrens",
        "silica-fields"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "halcyon-n",
      "name": "Halcyon North",
      "regionId": "halcyon-mesa",
      "shape": "M 146.0 51.0 L 144.3 49.5 L 146.5 48.7 L 104.8 11.0 L 54.2 10.0 L 8.4 54.7 L 12.0 56.2 L 12.0 54.0 L 64.7 74.3 L 66.3 71.6 L 68.5 69.2 L 71.0 67.2 L 73.8 65.8 L 76.9 64.9 L 80.1 64.6 L 83.3 64.8 L 86.4 65.7 L 89.3 67.1 L 91.8 69.1 L 94.0 71.4 L 95.7 74.2 L 146.0 54.0 Z M 50.5 61.5 L 45.5 53.5 L 30.5 52.5 L 28.5 50.5 L 43.5 38.5 L 43.5 32.5 L 52.5 26.5 L 55.5 20.5 L 64.5 28.5 L 77.5 24.5 L 80.5 27.5 L 73.5 38.5 L 85.5 47.5 L 81.5 50.5 L 72.5 52.5 L 68.5 57.5 L 67.5 62.5 L 59.3 60.0 L 57.5 59.5 L 56.8 59.7 Z",
      "position": {
        "x": 108.1,
        "y": 44.6
      },
      "badgeAnchor": {
        "x": 108.1,
        "y": 44.6
      },
      "badgeRadius": 22.7,
      "adjacencies": [
        "halcyon-core",
        "halcyon-crystal",
        "halcyon-e",
        "halcyon-w"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "halcyon-s",
      "name": "Halcyon South",
      "regionId": "halcyon-mesa",
      "shape": "M 84.1 98.7 L 81.2 99.1 L 78.3 99.0 L 75.5 98.5 L 72.8 97.4 L 54.0 145.0 L 52.4 143.6 L 51.8 145.1 L 53.8 149.0 L 53.8 149.0 L 55.0 147.0 L 107.0 147.0 L 86.9 97.8 Z",
      "position": {
        "x": 79.9,
        "y": 128.8
      },
      "badgeAnchor": {
        "x": 79.9,
        "y": 128.8
      },
      "badgeRadius": 18.2,
      "adjacencies": [
        "halcyon-core",
        "halcyon-s-gate",
        "halcyon-se",
        "halcyon-sw"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "halcyon-s-gate",
      "name": "Halcyon South Gate",
      "shape": "M 124.0 210.0 L 122.0 197.0 L 118.5 189.0 L 116.1 179.9 L 113.5 171.0 L 111.3 162.2 L 112.8 155.8 L 114.0 150.0 L 107.0 147.0 L 55.0 147.0 L 53.8 149.0 L 53.8 149.0 L 52.7 146.9 L 46.5 157.6 L 48.0 159.0 L 35.0 210.0 L 43.0 210.0 Z",
      "position": {
        "x": 79.3,
        "y": 178.6
      },
      "badgeAnchor": {
        "x": 79.3,
        "y": 178.6
      },
      "badgeRadius": 31.4,
      "adjacencies": [
        "argent-reach",
        "halcyon-s",
        "hollow-ridge",
        "iron-barrens"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "halcyon-se",
      "name": "Halcyon Southeast",
      "regionId": "halcyon-mesa",
      "shape": "M 92.4 94.1 L 89.8 96.2 L 86.9 97.8 L 107.0 147.0 L 114.0 150.0 L 117.0 147.0 L 119.1 147.2 L 120.5 143.5 L 120.5 137.9 L 120.5 132.5 L 122.5 130.5 L 127.5 130.5 L 129.5 128.5 L 128.5 124.5 L 131.5 121.5 L 138.5 121.5 L 144.1 121.5 L 145.3 121.0 L 145.0 119.0 L 147.0 117.0 L 146.0 108.0 L 96.1 88.6 L 94.5 91.5 Z",
      "position": {
        "x": 113.3,
        "y": 114.7
      },
      "badgeAnchor": {
        "x": 113.3,
        "y": 114.7
      },
      "badgeRadius": 18,
      "adjacencies": [
        "halcyon-core",
        "halcyon-e",
        "halcyon-s",
        "halcyon-se-tower"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "halcyon-se-tower",
      "name": "Halcyon Southeast Tower",
      "regionId": "halcyon-se-tower",
      "shape": "M 131.5 121.5 L 128.5 124.5 L 129.5 128.5 L 127.5 130.5 L 122.5 130.5 L 120.5 132.5 L 120.5 147.5 L 127.5 152.5 L 130.5 158.5 L 145.5 158.5 L 148.5 156.5 L 148.5 152.5 L 155.5 148.5 L 156.5 132.5 L 153.5 129.5 L 150.5 129.5 L 148.5 127.5 L 148.5 124.5 L 144.5 121.5 Z",
      "position": {
        "x": 138.5,
        "y": 140.3
      },
      "badgeAnchor": {
        "x": 138.5,
        "y": 140.3
      },
      "badgeRadius": 14.7,
      "badgeShrinksWithDigits": true,
      "adjacencies": [
        "halcyon-se",
        "iron-barrens"
      ],
      "oneWayBorders": [
        "argent-reach",
        "salt-dunes",
        "silica-fields"
      ],
      "borderDice": {
        "iron-barrens": {
          "defend": 7
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "halcyon-sw",
      "name": "Halcyon Southwest",
      "regionId": "halcyon-mesa",
      "shape": "M 70.1 95.9 L 67.8 93.9 L 65.9 91.5 L 64.4 88.8 L 13.0 109.0 L 13.0 106.9 L 9.2 108.3 L 52.4 146.2 L 51.8 145.1 L 52.4 143.6 L 54.0 145.0 L 72.8 97.4 Z",
      "position": {
        "x": 45.8,
        "y": 115.8
      },
      "badgeAnchor": {
        "x": 45.8,
        "y": 115.8
      },
      "badgeRadius": 18.3,
      "adjacencies": [
        "halcyon-core",
        "halcyon-s",
        "halcyon-w"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "halcyon-w",
      "name": "Halcyon West",
      "regionId": "halcyon-mesa",
      "shape": "M 63.4 86.0 L 63.0 83.0 L 63.0 80.0 L 63.6 77.1 L 64.7 74.3 L 12.0 54.0 L 12.0 56.2 L 10.0 55.4 L 11.0 107.6 L 13.0 106.9 L 13.0 109.0 L 64.4 88.8 Z",
      "position": {
        "x": 29.9,
        "y": 81.7
      },
      "badgeAnchor": {
        "x": 29.9,
        "y": 81.7
      },
      "badgeRadius": 19.2,
      "adjacencies": [
        "halcyon-core",
        "halcyon-n",
        "halcyon-sw"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "halo-barrens",
      "name": "Halo Barrens",
      "shape": "M 998.0 654.0 L 909.0 654.0 L 912.0 634.0 L 902.1 631.0 L 894.5 637.5 L 901.5 649.5 L 890.5 650.5 L 887.5 653.5 L 886.5 667.5 L 883.5 670.5 L 876.5 656.5 L 872.5 652.5 L 865.5 657.5 L 861.5 653.5 L 867.5 643.5 L 864.5 640.5 L 863.7 640.3 L 849.0 659.0 L 860.0 676.0 L 859.0 682.0 L 915.0 703.0 L 924.1 704.9 L 932.7 706.8 L 938.0 707.0 L 943.0 707.0 L 947.8 704.8 L 951.9 702.4 L 957.5 697.0 L 963.0 691.5 L 966.0 690.0 L 973.4 693.6 L 982.0 696.5 L 990.3 699.7 L 998.2 702.8 L 1003.6 703.9 L 1010.5 704.0 L 1017.0 704.0 L 1032.0 696.0 L 1032.9 687.9 L 1033.5 679.5 L 1037.7 673.7 L 1042.6 667.6 L 1044.0 663.0 L 1040.4 656.6 L 1037.1 649.9 L 1035.1 642.9 L 1032.9 635.6 L 1031.1 628.4 L 1029.0 621.0 L 1023.7 616.3 L 1017.9 611.6 L 1010.3 607.2 L 1002.2 604.3 L 996.4 603.6 L 990.3 602.7 L 988.0 601.0 L 987.0 602.0 Z",
      "position": {
        "x": 935.7,
        "y": 680.3
      },
      "badgeAnchor": {
        "x": 937.67,
        "y": 675.08
      },
      "badgeRadius": 26.3,
      "adjacencies": [
        "ashen-ridge",
        "ember-basin",
        "nova-crystal",
        "ochre-plateau",
        "opal-s-gate",
        "quiet-hollows",
        "shale-fields",
        "slate-ridge"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "halo-plateau",
      "name": "Halo Plateau",
      "shape": "M 855.0 945.0 L 854.1 941.9 L 848.2 934.8 L 842.0 929.5 L 835.7 924.3 L 830.0 919.0 L 829.3 913.5 L 830.0 906.5 L 829.9 900.1 L 827.8 891.8 L 826.0 884.0 L 817.0 884.0 L 807.0 894.0 L 781.0 859.0 L 773.4 856.6 L 765.5 855.1 L 756.8 856.3 L 748.0 858.0 L 747.8 865.8 L 745.0 874.0 L 734.0 882.0 L 751.0 905.0 L 728.0 923.0 L 730.0 940.0 L 742.0 951.0 L 743.0 971.0 L 749.0 977.0 L 755.0 982.5 L 757.6 987.4 L 760.0 992.0 L 763.4 989.9 L 767.5 985.0 L 773.8 979.8 L 782.0 975.0 L 790.9 975.1 L 796.6 976.4 L 803.6 978.9 L 810.1 981.9 L 816.8 984.7 L 823.8 986.7 L 828.4 986.9 L 834.0 986.0 L 839.0 981.0 L 835.0 976.0 L 835.0 948.0 Z",
      "position": {
        "x": 785.8,
        "y": 931.8
      },
      "badgeAnchor": {
        "x": 785.8,
        "y": 931.8
      },
      "badgeRadius": 43.2,
      "adjacencies": [
        "ashen-reach",
        "cinder-shelf",
        "ember-steppe",
        "nadir-ne-gate",
        "ozone-scarp",
        "quiet-fields",
        "shale-scarp"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "halo-waste",
      "name": "Halo Waste",
      "shape": "M 794.2 239.2 L 793.0 246.5 L 792.1 253.1 L 792.0 260.0 L 792.0 266.0 L 792.9 272.5 L 791.8 281.8 L 790.5 287.0 L 789.1 292.1 L 789.1 299.4 L 790.0 305.0 L 792.4 306.1 L 797.4 310.6 L 801.8 312.7 L 805.7 313.8 L 813.9 314.1 L 817.0 315.0 L 820.9 315.6 L 828.7 319.3 L 832.9 321.6 L 837.0 325.0 L 847.0 312.0 L 845.7 309.3 L 846.1 310.1 L 848.2 309.8 L 847.4 308.1 L 843.4 304.1 L 840.2 300.7 L 836.1 293.7 L 836.7 291.7 L 836.1 283.7 L 837.3 276.0 L 840.2 269.6 L 840.6 265.8 L 843.1 261.2 L 845.3 256.7 L 848.3 247.3 L 847.5 246.6 L 846.0 248.0 L 841.3 244.2 L 836.8 240.2 L 834.2 235.8 L 833.0 231.0 L 833.0 229.0 L 796.7 229.0 L 796.3 229.9 L 798.0 231.0 Z",
      "position": {
        "x": 817.2,
        "y": 256.8
      },
      "badgeAnchor": {
        "x": 818.53,
        "y": 272.66
      },
      "badgeRadius": 25.1,
      "adjacencies": [
        "ember-expanse",
        "mica-fields",
        "pale-basin",
        "shale-hollows",
        "slate-dunes"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hollow-basin",
      "name": "Hollow Basin",
      "shape": "M 961.0 988.0 L 961.2 994.8 L 963.0 999.5 L 965.4 1004.1 L 966.0 1008.0 L 962.8 1012.3 L 957.7 1014.2 L 952.6 1016.1 L 950.0 1020.0 L 953.7 1025.3 L 957.0 1031.5 L 964.0 1037.0 L 964.0 1043.0 L 962.0 1043.0 L 962.0 1045.0 L 1141.9 1045.0 L 1094.1 998.2 L 1092.0 999.0 L 1044.0 1013.0 L 1043.0 958.0 L 1039.7 957.3 L 1031.3 953.2 L 1022.2 949.3 L 1017.5 949.0 L 1012.0 949.5 L 1006.8 951.3 L 1001.0 953.5 L 993.4 957.4 L 987.1 961.6 L 981.0 966.0 L 974.8 970.8 L 969.5 976.0 L 964.0 981.0 L 961.0 982.0 Z",
      "position": {
        "x": 1004.7,
        "y": 1000.9
      },
      "badgeAnchor": {
        "x": 1004.7,
        "y": 1000.9
      },
      "badgeRadius": 39.1,
      "adjacencies": [
        "glass-plateau",
        "penumbra-w-gate",
        "quiet-fields"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hollow-expanse",
      "name": "Hollow Expanse",
      "shape": "M 1202.9 749.1 L 1205.4 754.6 L 1209.3 758.7 L 1213.1 761.4 L 1214.0 763.0 L 1234.0 763.0 L 1252.0 780.0 L 1252.0 782.8 L 1254.0 784.6 L 1254.0 600.0 L 1254.0 603.5 L 1252.0 602.3 L 1252.0 600.0 L 1242.0 594.0 L 1223.0 623.0 L 1208.0 622.0 L 1202.4 628.4 L 1198.0 635.0 L 1194.2 641.7 L 1190.2 648.2 L 1186.0 652.5 L 1182.0 656.5 L 1179.0 658.0 L 1179.2 667.3 L 1181.0 673.5 L 1183.8 679.2 L 1187.5 685.0 L 1191.0 693.0 L 1188.0 716.0 L 1200.0 727.0 L 1201.0 744.0 Z",
      "position": {
        "x": 1218.9,
        "y": 669.1
      },
      "badgeAnchor": {
        "x": 1225.04,
        "y": 686.62
      },
      "badgeRadius": 35.1,
      "adjacencies": [
        "ghost-steppe",
        "glass-barrens",
        "quiet-hollows",
        "umber-fields"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hollow-reach",
      "name": "Hollow Reach",
      "shape": "M 1162.0 380.0 L 1155.0 376.5 L 1147.7 373.3 L 1140.3 370.1 L 1133.0 366.5 L 1125.7 362.9 L 1119.7 360.8 L 1112.7 358.8 L 1105.2 356.8 L 1097.8 355.2 L 1091.0 355.0 L 1084.0 355.0 L 1072.0 372.0 L 1076.2 375.8 L 1079.2 381.3 L 1080.8 387.7 L 1081.0 393.0 L 1081.2 397.8 L 1084.0 407.0 L 1106.0 420.0 L 1112.4 417.4 L 1120.0 415.5 L 1127.2 413.8 L 1134.9 410.4 L 1141.7 404.7 L 1147.7 398.7 L 1152.0 393.5 L 1156.8 388.3 L 1160.9 383.4 Z",
      "position": {
        "x": 1110.2,
        "y": 388.2
      },
      "badgeAnchor": {
        "x": 1110.2,
        "y": 388.2
      },
      "badgeRadius": 28.9,
      "adjacencies": [
        "mica-scarp",
        "quiet-drift",
        "rust-shelf"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "hollow-ridge",
      "name": "Hollow Ridge",
      "shape": "M 38.5 281.1 L 44.2 277.2 L 49.2 273.2 L 55.0 266.0 L 54.8 257.2 L 52.0 249.0 L 38.0 236.0 L 38.2 227.2 L 40.2 220.2 L 42.6 213.6 L 43.0 210.0 L 35.0 210.0 L 48.0 159.0 L 46.5 157.6 L 47.5 155.8 L -2.0 109.4 L -2.0 260.9 L 0.0 261.8 L 0.0 264.0 L 11.0 269.0 L 19.0 285.0 L 36.0 284.0 Z",
      "position": {
        "x": 21.8,
        "y": 165.6
      },
      "badgeAnchor": {
        "x": 21.8,
        "y": 165.6
      },
      "badgeRadius": 23.8,
      "adjacencies": [
        "argent-reach",
        "glass-waste",
        "halcyon-s-gate"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ion-dunes",
      "name": "Ion Dunes",
      "shape": "M 258.0 642.0 L 252.9 641.1 L 247.0 641.0 L 241.6 641.1 L 236.0 642.0 L 229.1 646.6 L 222.2 652.2 L 215.3 657.3 L 209.8 659.8 L 201.1 660.1 L 194.5 661.5 L 188.3 665.8 L 182.3 670.8 L 177.0 673.0 L 176.8 676.8 L 175.3 681.3 L 170.0 689.0 L 165.9 689.9 L 160.1 689.9 L 151.2 688.3 L 142.5 686.0 L 132.8 682.8 L 123.7 679.3 L 116.0 675.5 L 108.0 672.0 L 100.3 668.1 L 93.0 664.0 L 78.0 665.0 L 68.0 675.0 L 47.0 674.0 L 42.0 680.0 L 40.1 684.6 L 38.3 689.8 L 37.1 697.5 L 38.0 702.5 L 39.0 708.0 L 43.3 711.2 L 46.7 716.3 L 49.3 722.7 L 51.6 729.4 L 53.4 735.6 L 55.7 741.3 L 58.2 746.3 L 61.8 751.2 L 67.0 755.0 L 74.3 754.8 L 79.6 753.6 L 84.6 752.6 L 92.1 750.1 L 99.2 747.7 L 108.3 744.3 L 116.9 740.9 L 125.4 737.4 L 135.0 736.0 L 141.0 752.0 L 156.0 762.0 L 161.8 762.7 L 166.9 762.9 L 172.2 761.7 L 177.0 760.0 L 180.9 756.4 L 184.6 753.0 L 191.4 748.0 L 197.7 742.7 L 202.2 738.2 L 206.6 734.0 L 212.4 729.9 L 220.8 728.2 L 226.3 729.7 L 232.0 733.0 L 286.0 713.0 L 286.8 704.7 L 284.3 696.7 L 281.3 689.2 L 281.0 684.0 L 281.0 679.0 L 286.0 675.0 L 288.0 668.0 L 282.0 654.0 L 257.0 653.0 Z",
      "position": {
        "x": 92.7,
        "y": 708.2
      },
      "badgeAnchor": {
        "x": 171.01,
        "y": 717.74
      },
      "badgeRadius": 39.3,
      "adjacencies": [
        "argent-expanse",
        "beryl-s-gate",
        "chrome-ridge",
        "cinder-steppe",
        "cobalt-waste",
        "ghost-basin",
        "ozone-fields",
        "salt-reach"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ion-flats",
      "name": "Ion Flats",
      "shape": "M 84.0 388.0 L 92.8 386.8 L 99.8 385.3 L 106.8 383.2 L 113.8 381.3 L 122.0 380.0 L 128.0 379.0 L 137.0 379.0 L 145.0 379.0 L 151.0 380.0 L 156.3 380.2 L 164.0 382.0 L 184.0 401.0 L 191.1 399.1 L 195.0 397.0 L 200.2 392.2 L 204.3 387.3 L 207.0 386.0 L 207.7 382.7 L 210.5 377.0 L 214.2 371.7 L 217.4 365.9 L 218.2 359.2 L 220.0 352.0 L 224.7 348.7 L 230.2 347.2 L 236.0 345.0 L 233.8 336.2 L 232.1 327.4 L 233.0 319.5 L 234.0 312.0 L 236.4 307.4 L 239.2 304.2 L 243.6 300.6 L 248.0 298.0 L 247.0 296.3 L 247.1 296.2 L 248.8 295.4 L 246.4 291.4 L 208.1 275.3 L 209.3 276.4 L 208.9 277.8 L 207.0 277.0 L 202.0 294.0 L 195.5 298.0 L 190.2 299.2 L 184.7 299.8 L 179.6 298.9 L 174.1 297.4 L 166.7 294.3 L 159.7 290.8 L 152.4 287.6 L 144.6 284.4 L 138.4 283.1 L 133.0 283.0 L 127.5 283.0 L 119.1 285.1 L 112.5 288.0 L 105.2 290.7 L 95.9 292.9 L 86.6 295.1 L 76.8 297.3 L 67.2 299.7 L 62.5 300.0 L 57.0 300.0 L 50.0 299.0 L 51.0 319.0 L 64.0 329.0 L 65.0 337.0 L 64.0 345.5 L 64.0 350.5 L 64.3 356.2 L 66.8 364.6 L 69.8 369.7 L 72.9 375.1 L 74.5 382.0 L 76.0 389.0 Z",
      "position": {
        "x": 132.9,
        "y": 331.6
      },
      "badgeAnchor": {
        "x": 171.07,
        "y": 336.67
      },
      "badgeRadius": 47.4,
      "adjacencies": [
        "argent-reach",
        "cobalt-shelf",
        "glass-waste",
        "iron-plateau",
        "jade-reach",
        "silica-scarp"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ion-ridge",
      "name": "Ion Ridge",
      "shape": "M 1077.0 834.0 L 1053.0 837.0 L 1049.6 830.4 L 1049.0 824.0 L 1047.0 824.5 L 1046.9 823.3 L 1047.9 822.2 L 1041.3 824.0 L 1035.0 825.9 L 1025.4 826.3 L 1019.4 828.7 L 1011.9 828.2 L 1004.4 830.8 L 997.8 831.0 L 991.8 832.0 L 975.9 832.0 L 968.9 833.0 L 959.5 833.0 L 950.5 833.0 L 941.7 833.0 L 936.2 832.1 L 931.0 831.3 L 924.0 831.8 L 915.4 830.9 L 907.9 829.3 L 908.0 831.4 L 915.1 832.9 L 906.0 831.0 L 907.0 842.0 L 904.1 848.6 L 900.6 853.6 L 897.6 859.1 L 897.0 865.0 L 897.0 871.0 L 902.5 879.0 L 909.0 884.0 L 914.6 884.9 L 919.2 884.7 L 923.6 883.1 L 928.5 880.0 L 932.6 875.1 L 936.4 869.9 L 940.3 862.3 L 944.8 854.8 L 949.5 850.0 L 954.0 847.0 L 966.0 849.0 L 972.0 856.0 L 996.0 853.0 L 1004.0 864.0 L 1010.8 866.2 L 1014.9 868.6 L 1019.7 872.3 L 1024.5 876.0 L 1031.0 882.0 L 1037.2 887.8 L 1043.8 893.2 L 1050.3 898.7 L 1054.0 900.0 L 1057.7 892.7 L 1062.2 885.2 L 1066.2 877.7 L 1071.2 869.7 L 1077.0 861.5 L 1081.9 857.4 L 1087.4 853.4 L 1092.0 851.5 L 1097.0 849.0 Z",
      "position": {
        "x": 1045.8,
        "y": 861.3
      },
      "badgeAnchor": {
        "x": 1032.42,
        "y": 853.31
      },
      "badgeRadius": 25.3,
      "adjacencies": [
        "ashen-reach",
        "cobalt-barrens",
        "ghost-steppe",
        "glass-plateau"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ion-scarp",
      "name": "Ion Scarp",
      "shape": "M 848.6 80.4 L 857.8 83.7 L 865.6 84.9 L 874.0 85.0 L 882.5 85.0 L 891.5 85.0 L 900.0 85.0 L 909.0 85.0 L 915.0 77.5 L 921.4 72.4 L 928.8 68.3 L 936.0 65.0 L 943.0 61.0 L 945.4 55.4 L 946.9 49.9 L 946.6 42.4 L 946.0 35.0 L 949.0 29.6 L 955.0 24.0 L 952.2 19.8 L 945.6 16.4 L 939.9 15.1 L 934.5 15.0 L 929.7 14.8 L 923.0 13.0 L 919.0 8.0 L 920.0 0.0 L 918.0 0.0 L 918.2 -2.0 L 814.7 -2.0 L 815.0 0.0 L 813.0 0.0 L 813.9 5.6 L 813.8 13.3 L 811.2 21.8 L 809.1 29.6 L 809.1 36.4 L 810.0 42.0 L 813.8 46.2 L 817.8 50.2 L 823.7 54.3 L 830.0 58.0 L 835.5 62.0 L 838.1 66.3 L 841.0 74.0 L 845.0 80.0 Z",
      "position": {
        "x": 882.1,
        "y": 41.6
      },
      "badgeAnchor": {
        "x": 882.1,
        "y": 41.6
      },
      "badgeRadius": 43.4,
      "adjacencies": [
        "cobalt-steppe",
        "ember-reach",
        "mica-fields",
        "quiet-plateau"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "iron-barrens",
      "name": "Iron Barrens",
      "shape": "M 137.5 197.0 L 145.5 196.0 L 153.0 195.0 L 161.8 192.8 L 170.3 189.8 L 177.9 185.4 L 184.0 180.0 L 187.3 173.3 L 190.0 166.5 L 191.9 159.4 L 193.2 152.7 L 195.0 146.0 L 196.0 124.0 L 192.2 122.3 L 184.2 120.3 L 176.2 118.3 L 168.3 116.2 L 160.8 114.3 L 153.2 115.2 L 147.0 117.0 L 145.0 119.0 L 145.3 121.0 L 144.1 121.5 L 144.5 121.5 L 145.5 122.3 L 145.5 122.3 L 148.5 124.5 L 148.5 127.5 L 150.5 129.5 L 153.5 129.5 L 156.5 132.5 L 155.5 148.5 L 148.5 152.5 L 148.5 156.5 L 145.5 158.5 L 130.5 158.5 L 127.5 152.5 L 120.5 147.5 L 120.5 147.3 L 120.5 145.3 L 119.8 145.2 L 119.1 147.2 L 117.0 147.0 L 114.0 150.0 L 112.8 155.8 L 111.3 162.2 L 113.5 171.0 L 116.1 179.9 L 118.5 189.0 L 122.0 197.0 L 130.4 197.9 Z",
      "position": {
        "x": 166.9,
        "y": 166.8
      },
      "badgeAnchor": {
        "x": 166.9,
        "y": 166.8
      },
      "badgeRadius": 21.1,
      "adjacencies": [
        "argent-reach",
        "halcyon-e-gate",
        "halcyon-s-gate",
        "halcyon-se-tower",
        "salt-dunes",
        "silica-fields"
      ],
      "borderDice": {
        "halcyon-se-tower": {
          "attack": 5
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "iron-drift",
      "name": "Iron Drift",
      "shape": "M 109.0 804.0 L 106.6 802.4 L 98.0 799.5 L 92.4 798.1 L 87.0 797.2 L 78.5 799.0 L 70.4 801.4 L 62.4 802.9 L 54.5 803.0 L 47.0 803.0 L 41.5 802.0 L 35.9 801.1 L 26.7 801.2 L 20.7 802.7 L 16.0 805.5 L 12.2 810.7 L 8.0 819.0 L 0.0 821.0 L 0.0 818.9 L -2.0 819.4 L -2.0 938.7 L 49.9 888.9 L 49.0 887.0 L 36.0 836.0 L 93.0 834.0 Z",
      "position": {
        "x": 22.2,
        "y": 880.6
      },
      "badgeAnchor": {
        "x": 20.42,
        "y": 856.28
      },
      "badgeRadius": 24.2,
      "adjacencies": [
        "dust-plateau",
        "salt-reach",
        "umbra-n-gate"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "iron-plateau",
      "name": "Iron Plateau",
      "shape": "M 200.2 392.2 L 195.0 397.0 L 191.1 399.1 L 184.0 401.0 L 164.0 382.0 L 156.3 380.2 L 151.0 380.0 L 145.0 379.0 L 137.0 379.0 L 128.0 379.0 L 122.0 380.0 L 121.8 383.8 L 119.0 393.0 L 117.1 402.1 L 117.0 412.5 L 117.0 422.0 L 118.1 428.9 L 119.5 435.0 L 122.0 442.0 L 125.0 448.0 L 123.6 449.6 L 124.4 451.2 L 132.7 444.0 L 179.8 446.0 L 179.5 445.5 L 179.5 441.8 L 179.5 430.5 L 187.5 425.5 L 187.5 422.5 L 191.5 419.5 L 204.5 419.5 L 210.5 427.5 L 216.5 431.5 L 216.5 444.5 L 213.5 448.5 L 210.5 448.5 L 207.5 451.5 L 207.5 454.4 L 207.5 454.5 L 206.1 455.9 L 235.3 476.7 L 263.8 444.7 L 260.0 446.0 L 254.6 445.4 L 249.8 444.7 L 240.4 441.6 L 233.0 438.0 L 226.0 434.0 L 222.0 431.0 L 220.8 423.2 L 219.4 415.6 L 217.6 408.4 L 214.3 400.7 L 210.7 393.3 L 207.0 386.0 L 204.3 387.3 Z",
      "position": {
        "x": 149.4,
        "y": 412.4
      },
      "badgeAnchor": {
        "x": 162.69,
        "y": 415.3
      },
      "badgeRadius": 32.1,
      "adjacencies": [
        "ion-flats",
        "jade-reach",
        "quartz-nne-tower",
        "silica-scarp"
      ],
      "borderDice": {
        "quartz-nne-tower": {
          "attack": 5
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jade-reach",
      "name": "Jade Reach",
      "shape": "M 106.8 383.2 L 99.8 385.3 L 92.8 386.8 L 84.0 388.0 L 76.0 389.0 L 74.7 391.7 L 67.6 398.1 L 63.0 406.0 L 58.4 413.9 L 54.8 418.8 L 51.0 423.0 L 45.3 424.8 L 37.0 425.0 L 20.0 455.0 L 13.0 456.0 L 0.0 443.0 L 0.0 445.8 L -2.0 443.8 L -2.0 521.0 L 0.0 521.0 L 0.0 523.0 L 5.3 523.0 L 5.4 519.6 L 5.9 516.2 L 6.8 512.9 L 8.1 509.7 L 9.7 506.6 L 11.7 503.8 L 13.9 501.2 L 16.5 498.9 L 19.3 496.9 L 22.3 495.2 L 25.4 493.9 L 28.8 493.0 L 32.1 492.4 L 35.6 492.2 L 39.0 492.4 L 42.4 492.9 L 45.7 493.9 L 48.9 495.2 L 51.9 496.9 L 54.6 498.9 L 57.2 501.2 L 59.5 503.8 L 61.4 506.6 L 63.0 509.6 L 64.3 512.8 L 65.2 516.1 L 65.8 519.5 L 65.9 523.0 L 84.0 523.0 L 85.0 507.2 L 84.5 507.5 L 72.5 506.5 L 67.5 499.5 L 65.5 499.5 L 61.5 495.5 L 61.5 481.5 L 64.5 478.5 L 67.5 478.5 L 69.5 476.5 L 69.5 473.5 L 75.5 469.5 L 87.5 470.5 L 93.5 478.5 L 95.5 478.5 L 97.0 480.0 L 98.4 481.4 L 126.4 449.4 L 124.4 451.2 L 123.6 449.6 L 125.0 448.0 L 122.0 442.0 L 119.5 435.0 L 118.1 428.9 L 117.0 422.0 L 117.0 412.5 L 117.1 402.1 L 119.0 393.0 L 121.8 383.8 L 122.0 380.0 L 113.8 381.3 Z",
      "position": {
        "x": 84.6,
        "y": 435.9
      },
      "badgeAnchor": {
        "x": 61.24,
        "y": 446.98
      },
      "badgeRadius": 34.2,
      "adjacencies": [
        "cinder-steppe",
        "glass-waste",
        "ion-flats",
        "iron-plateau",
        "quartz-wnw-tower",
        "west-warp"
      ],
      "borderDice": {
        "quartz-wnw-tower": {
          "attack": 5
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jasper-core",
      "name": "Jasper Core",
      "regionId": "jasper-mesa",
      "shape": "M 1084.3 507.6 L 1081.5 509.1 L 1079.1 511.1 L 1077.1 513.5 L 1075.6 516.2 L 1074.6 518.9 L 1074.1 521.6 L 1074.1 524.4 L 1074.5 527.2 L 1075.3 529.9 L 1076.9 532.8 L 1078.9 535.4 L 1081.5 537.5 L 1084.4 539.1 L 1087.1 540.0 L 1090.0 540.5 L 1092.9 540.5 L 1095.8 539.9 L 1098.5 538.9 L 1101.2 537.3 L 1103.6 535.3 L 1105.6 532.8 L 1107.1 530.0 L 1108.0 527.3 L 1108.4 524.5 L 1108.3 521.6 L 1107.8 518.8 L 1106.8 516.1 L 1105.2 513.3 L 1103.1 510.9 L 1100.6 509.0 L 1097.8 507.5 L 1094.5 506.5 L 1091.0 506.2 L 1087.6 506.6 Z",
      "position": {
        "x": 1091.2,
        "y": 523.3
      },
      "badgeAnchor": {
        "x": 1091.2,
        "y": 523.3
      },
      "badgeRadius": 17,
      "adjacencies": [
        "jasper-e",
        "jasper-n",
        "jasper-ne",
        "jasper-nw",
        "jasper-s",
        "jasper-se",
        "jasper-sw",
        "jasper-w"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jasper-e",
      "name": "Jasper East",
      "regionId": "jasper-mesa",
      "shape": "M 1108.3 521.6 L 1108.4 524.5 L 1108.0 527.3 L 1107.1 530.0 L 1156.6 549.4 L 1159.5 546.5 L 1161.5 546.5 L 1162.0 545.5 L 1163.5 542.5 L 1164.0 542.1 L 1164.0 502.5 L 1162.0 499.3 L 1161.5 498.5 L 1158.5 498.5 L 1155.9 495.9 L 1106.8 516.1 L 1107.8 518.8 Z",
      "position": {
        "x": 1143.8,
        "y": 522.7
      },
      "badgeAnchor": {
        "x": 1143.8,
        "y": 522.7
      },
      "badgeRadius": 20.2,
      "adjacencies": [
        "east-warp",
        "jasper-core",
        "jasper-ene-tower",
        "jasper-ese-tower",
        "jasper-ne",
        "jasper-se"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jasper-ene-tower",
      "name": "Jasper East-Northeast Tower",
      "regionId": "jasper-ene-tower",
      "shape": "M 1167.5 469.5 L 1163.5 473.5 L 1163.5 475.5 L 1155.5 481.5 L 1155.5 495.5 L 1158.5 498.5 L 1161.5 498.5 L 1166.5 506.5 L 1181.5 506.5 L 1184.5 503.5 L 1184.5 500.5 L 1192.5 495.5 L 1192.5 481.5 L 1188.5 477.5 L 1186.5 477.5 L 1180.5 469.5 Z",
      "position": {
        "x": 1174,
        "y": 488.5
      },
      "badgeAnchor": {
        "x": 1174,
        "y": 488.5
      },
      "badgeRadius": 15.9,
      "badgeShrinksWithDigits": true,
      "adjacencies": [
        "jasper-e",
        "jasper-ne",
        "mica-scarp"
      ],
      "oneWayBorders": [
        "glass-barrens",
        "hollow-reach",
        "quiet-drift",
        "rust-shelf",
        "umber-drift"
      ],
      "borderDice": {
        "mica-scarp": {
          "defend": 7
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jasper-ese-tower",
      "name": "Jasper East-Southeast Tower",
      "regionId": "jasper-ese-tower",
      "shape": "M 1168.5 538.5 L 1163.5 542.5 L 1161.5 546.5 L 1159.5 546.5 L 1155.5 550.5 L 1155.5 563.5 L 1158.5 567.5 L 1161.5 567.5 L 1163.5 569.5 L 1163.5 572.5 L 1166.5 575.5 L 1181.5 575.5 L 1184.5 572.5 L 1184.5 569.5 L 1192.5 564.5 L 1192.5 550.5 L 1188.5 546.5 L 1186.5 546.5 L 1180.5 538.5 Z",
      "position": {
        "x": 1174,
        "y": 557.5
      },
      "badgeAnchor": {
        "x": 1174,
        "y": 557.5
      },
      "badgeRadius": 15.9,
      "badgeShrinksWithDigits": true,
      "adjacencies": [
        "glass-barrens",
        "jasper-e",
        "jasper-se"
      ],
      "oneWayBorders": [
        "ashen-ridge",
        "hollow-expanse",
        "mica-scarp",
        "quiet-hollows"
      ],
      "borderDice": {
        "glass-barrens": {
          "defend": 7
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jasper-n",
      "name": "Jasper North",
      "regionId": "jasper-mesa",
      "shape": "M 1084.3 507.6 L 1087.6 506.6 L 1091.0 506.2 L 1094.5 506.5 L 1097.8 507.5 L 1119.0 459.0 L 1120.6 460.3 L 1122.0 457.1 L 1065.0 456.0 L 1065.0 456.0 L 1065.0 458.0 Z",
      "position": {
        "x": 1091.7,
        "y": 475.3
      },
      "badgeAnchor": {
        "x": 1091.7,
        "y": 475.3
      },
      "badgeRadius": 18.5,
      "adjacencies": [
        "jasper-core",
        "jasper-ne",
        "jasper-nnw-tower",
        "jasper-nw"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jasper-ne",
      "name": "Jasper Northeast",
      "regionId": "jasper-mesa",
      "shape": "M 1119.0 459.0 L 1097.8 507.5 L 1100.6 509.0 L 1103.1 510.9 L 1105.2 513.3 L 1106.8 516.1 L 1155.9 495.9 L 1155.5 495.5 L 1155.5 488.3 L 1155.5 484.9 L 1121.5 458.4 L 1120.6 460.3 Z",
      "position": {
        "x": 1127.4,
        "y": 487.2
      },
      "badgeAnchor": {
        "x": 1127.4,
        "y": 487.2
      },
      "badgeRadius": 18.9,
      "adjacencies": [
        "jasper-core",
        "jasper-e",
        "jasper-ene-tower",
        "jasper-n"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jasper-nnw-tower",
      "name": "Jasper North-Northwest Tower",
      "regionId": "jasper-nnw-tower",
      "shape": "M 1048.5 422.5 L 1044.5 426.5 L 1044.5 428.5 L 1036.5 434.5 L 1036.5 447.5 L 1040.5 451.5 L 1042.5 451.5 L 1048.5 459.5 L 1061.5 459.5 L 1065.5 455.5 L 1065.5 453.5 L 1073.5 447.5 L 1073.5 434.5 L 1069.5 430.5 L 1067.5 430.5 L 1061.5 422.5 Z",
      "position": {
        "x": 1055,
        "y": 441
      },
      "badgeAnchor": {
        "x": 1055,
        "y": 441
      },
      "badgeRadius": 16.3,
      "badgeShrinksWithDigits": true,
      "adjacencies": [
        "jasper-n",
        "jasper-nw",
        "rust-shelf"
      ],
      "oneWayBorders": [
        "hollow-reach",
        "mica-scarp",
        "quiet-drift"
      ],
      "borderDice": {
        "rust-shelf": {
          "defend": 7
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jasper-nw",
      "name": "Jasper Northwest",
      "regionId": "jasper-mesa",
      "shape": "M 1065.0 456.0 L 1061.5 459.5 L 1056.2 459.5 L 1052.8 459.5 L 1021.7 495.8 L 1023.0 496.3 L 1025.0 495.0 L 1075.6 516.2 L 1077.1 513.5 L 1079.1 511.1 L 1081.5 509.1 L 1084.3 507.6 L 1065.0 458.0 Z",
      "position": {
        "x": 1055.3,
        "y": 486.7
      },
      "badgeAnchor": {
        "x": 1055.3,
        "y": 486.7
      },
      "badgeRadius": 19.4,
      "adjacencies": [
        "jasper-core",
        "jasper-n",
        "jasper-nnw-tower",
        "jasper-w"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jasper-s",
      "name": "Jasper South",
      "regionId": "jasper-mesa",
      "shape": "M 1065.0 589.0 L 1063.5 589.5 L 1064.5 591.0 L 1120.9 589.9 L 1119.7 586.7 L 1118.0 588.0 L 1098.5 538.9 L 1095.8 539.9 L 1092.9 540.5 L 1090.0 540.5 L 1087.1 540.0 L 1084.4 539.1 Z",
      "position": {
        "x": 1091.7,
        "y": 571.8
      },
      "badgeAnchor": {
        "x": 1091.7,
        "y": 571.8
      },
      "badgeRadius": 18.5,
      "adjacencies": [
        "jasper-core",
        "jasper-se",
        "jasper-ssw-tower",
        "jasper-sw"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jasper-se",
      "name": "Jasper Southeast",
      "regionId": "jasper-mesa",
      "shape": "M 1155.5 550.5 L 1156.6 549.4 L 1107.1 530.0 L 1105.6 532.8 L 1103.6 535.3 L 1101.2 537.3 L 1098.5 538.9 L 1118.0 588.0 L 1119.7 586.7 L 1120.4 588.7 L 1155.5 562.1 L 1155.5 558.3 Z",
      "position": {
        "x": 1127.4,
        "y": 558.9
      },
      "badgeAnchor": {
        "x": 1127.4,
        "y": 558.9
      },
      "badgeRadius": 19.5,
      "adjacencies": [
        "jasper-core",
        "jasper-e",
        "jasper-ese-tower",
        "jasper-s"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jasper-ssw-tower",
      "name": "Jasper South-Southwest Tower",
      "regionId": "jasper-ssw-tower",
      "shape": "M 1047.5 586.5 L 1044.5 589.5 L 1044.5 592.5 L 1036.5 597.5 L 1036.5 612.5 L 1039.5 615.5 L 1042.5 615.5 L 1047.5 623.5 L 1061.5 623.5 L 1065.5 619.5 L 1065.5 617.5 L 1073.5 611.5 L 1073.5 599.5 L 1069.5 594.5 L 1065.5 592.5 L 1061.5 586.5 Z",
      "position": {
        "x": 1054.5,
        "y": 605
      },
      "badgeAnchor": {
        "x": 1054.5,
        "y": 605
      },
      "badgeRadius": 15.9,
      "badgeShrinksWithDigits": true,
      "adjacencies": [
        "ashen-ridge",
        "jasper-s",
        "jasper-sw"
      ],
      "oneWayBorders": [
        "glass-barrens",
        "halo-barrens",
        "quiet-hollows"
      ],
      "borderDice": {
        "ashen-ridge": {
          "defend": 7
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jasper-sw",
      "name": "Jasper Southwest",
      "regionId": "jasper-mesa",
      "shape": "M 1081.5 537.5 L 1078.9 535.4 L 1076.9 532.8 L 1075.3 529.9 L 1027.0 549.0 L 1024.1 548.4 L 1051.9 586.5 L 1055.0 586.5 L 1061.5 586.5 L 1063.5 589.5 L 1065.0 589.0 L 1084.4 539.1 Z",
      "position": {
        "x": 1055.9,
        "y": 558.7
      },
      "badgeAnchor": {
        "x": 1055.9,
        "y": 558.7
      },
      "badgeRadius": 19.5,
      "adjacencies": [
        "jasper-core",
        "jasper-s",
        "jasper-ssw-tower",
        "jasper-w"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "jasper-w",
      "name": "Jasper West",
      "regionId": "jasper-mesa",
      "shape": "M 1022.0 548.0 L 1020.0 548.8 L 1020.0 549.6 L 1025.8 550.8 L 1024.1 548.4 L 1027.0 549.0 L 1075.3 529.9 L 1074.5 527.2 L 1074.1 524.4 L 1074.1 521.6 L 1074.6 518.9 L 1075.6 516.2 L 1025.0 495.0 L 1023.0 496.3 L 1021.7 495.8 L 1023.7 493.5 L 1020.0 495.9 L 1020.0 496.5 L 1022.0 497.0 Z",
      "position": {
        "x": 1041.3,
        "y": 522.7
      },
      "badgeAnchor": {
        "x": 1041.3,
        "y": 522.7
      },
      "badgeRadius": 19.2,
      "adjacencies": [
        "jasper-core",
        "jasper-nw",
        "jasper-sw",
        "opal-e"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "lumen-crystal",
      "name": "Lumen Crystal",
      "regionId": "lumen-crystal",
      "shape": "M 380.5 373.5 L 370.5 386.5 L 356.5 377.5 L 353.5 380.5 L 359.5 395.5 L 349.5 404.5 L 361.5 411.5 L 361.5 420.5 L 370.5 418.5 L 379.5 423.5 L 385.5 416.5 L 398.5 417.5 L 401.5 414.5 L 386.5 402.5 L 391.5 394.5 L 384.5 389.5 L 383.5 376.5 Z",
      "position": {
        "x": 372.4,
        "y": 401.8
      },
      "badgeAnchor": {
        "x": 372.4,
        "y": 401.8
      },
      "badgeRadius": 14.1,
      "badgeShrinksWithDigits": true,
      "adjacencies": [
        "dust-barrens",
        "salt-ridge",
        "silica-scarp"
      ],
      "borderDice": {
        "beryl-ene-tower": {
          "defend": 4
        },
        "dust-barrens": {
          "defend": 4
        },
        "garnet-nne-tower": {
          "defend": 4
        },
        "salt-ridge": {
          "defend": 4
        },
        "silica-scarp": {
          "defend": 4
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "mica-fields",
      "name": "Mica Fields",
      "shape": "M 900.0 85.0 L 891.5 85.0 L 882.5 85.0 L 874.0 85.0 L 865.6 84.9 L 857.8 83.7 L 848.6 80.4 L 845.0 80.0 L 846.0 91.0 L 826.0 110.0 L 835.0 124.0 L 831.5 126.0 L 825.8 131.8 L 824.0 136.0 L 827.6 137.9 L 830.0 141.0 L 827.0 160.0 L 835.0 172.0 L 832.7 171.9 L 832.6 172.0 L 833.6 173.5 L 844.4 179.4 L 845.8 183.7 L 838.9 194.6 L 840.9 203.7 L 838.9 207.5 L 835.3 212.0 L 832.4 218.1 L 831.2 222.3 L 831.0 229.0 L 833.0 229.0 L 833.0 231.0 L 834.2 235.8 L 836.8 240.2 L 841.3 244.2 L 846.0 248.0 L 847.5 246.6 L 848.3 247.3 L 847.7 249.1 L 862.9 234.9 L 867.8 233.9 L 873.1 233.1 L 881.9 234.1 L 885.0 229.9 L 883.0 230.1 L 882.7 229.7 L 881.0 232.0 L 884.0 228.0 L 876.0 216.0 L 878.4 214.9 L 885.0 209.5 L 891.7 204.2 L 898.4 199.4 L 905.0 195.0 L 911.6 190.6 L 917.9 186.4 L 924.2 182.2 L 929.8 175.8 L 935.5 170.0 L 941.4 165.4 L 943.0 163.0 L 938.5 160.0 L 933.6 153.9 L 929.7 146.3 L 925.7 138.3 L 921.7 130.3 L 918.7 122.8 L 915.7 115.3 L 913.0 107.5 L 910.4 99.6 L 909.1 92.9 L 909.0 85.0 Z",
      "position": {
        "x": 877.6,
        "y": 146.2
      },
      "badgeAnchor": {
        "x": 877.6,
        "y": 146.2
      },
      "badgeRadius": 46.9,
      "adjacencies": [
        "cinder-basin",
        "ember-reach",
        "halo-waste",
        "ion-scarp",
        "quiet-plateau",
        "rust-steppe"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "mica-flats",
      "name": "Mica Flats",
      "shape": "M 640.7 756.2 L 636.0 758.0 L 629.0 763.0 L 622.5 768.0 L 617.8 772.8 L 613.2 777.2 L 608.6 779.6 L 600.4 781.5 L 594.0 781.0 L 588.3 780.5 L 580.0 783.0 L 566.0 797.0 L 571.9 800.6 L 577.5 804.0 L 583.0 807.5 L 592.2 810.8 L 601.7 812.8 L 610.9 814.6 L 618.3 818.2 L 623.1 821.9 L 627.7 828.8 L 629.7 836.8 L 631.5 844.0 L 634.4 851.6 L 636.8 859.2 L 637.7 863.5 L 637.4 864.4 L 638.5 864.5 L 641.1 868.1 L 645.0 866.5 L 651.7 863.7 L 659.0 859.0 L 661.6 850.6 L 663.1 841.6 L 665.7 832.7 L 669.0 827.5 L 673.8 821.8 L 679.4 815.9 L 683.0 809.0 L 681.1 805.9 L 678.8 798.8 L 676.2 791.2 L 673.6 783.4 L 669.6 775.4 L 666.5 771.0 L 662.0 766.5 L 657.0 761.5 L 650.0 756.0 Z",
      "position": {
        "x": 642.7,
        "y": 795.4
      },
      "badgeAnchor": {
        "x": 642.7,
        "y": 795.4
      },
      "badgeRadius": 33,
      "adjacencies": [
        "basalt-shelf",
        "cinder-shelf",
        "rust-waste",
        "sable-dunes",
        "static-scarp"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "mica-scarp",
      "name": "Mica Scarp",
      "shape": "M 1163.5 475.5 L 1163.5 473.5 L 1167.5 469.5 L 1180.5 469.5 L 1186.5 477.5 L 1188.5 477.5 L 1192.5 481.5 L 1192.5 495.5 L 1184.5 500.5 L 1184.5 503.5 L 1181.5 506.5 L 1171.8 506.5 L 1166.5 506.5 L 1165.9 505.5 L 1164.0 505.9 L 1164.0 507.4 L 1170.1 509.5 L 1171.0 522.8 L 1171.5 521.0 L 1172.9 521.0 L 1173.0 523.0 L 1184.5 523.0 L 1184.7 519.6 L 1185.3 516.2 L 1186.2 512.9 L 1187.4 509.7 L 1188.9 506.6 L 1190.8 503.7 L 1192.9 501.0 L 1195.2 498.5 L 1197.8 496.3 L 1200.6 494.4 L 1203.6 492.7 L 1206.8 491.3 L 1210.0 490.3 L 1213.4 489.6 L 1216.8 489.2 L 1220.2 489.1 L 1223.6 489.5 L 1227.0 490.1 L 1230.3 491.1 L 1233.5 492.4 L 1236.5 494.0 L 1239.3 495.9 L 1242.0 498.1 L 1244.4 500.5 L 1246.6 503.1 L 1248.4 506.0 L 1250.0 509.0 L 1251.3 512.2 L 1252.3 515.5 L 1252.9 518.9 L 1252.0 231.0 L 1246.7 233.7 L 1241.7 236.2 L 1237.3 239.3 L 1233.0 242.5 L 1226.4 250.4 L 1220.5 258.0 L 1213.5 265.0 L 1206.5 272.0 L 1199.5 279.0 L 1193.0 286.0 L 1196.1 294.9 L 1199.4 303.6 L 1202.4 312.6 L 1205.4 321.6 L 1207.6 326.4 L 1209.7 331.3 L 1212.8 336.6 L 1216.0 342.0 L 1217.7 347.8 L 1216.8 354.8 L 1215.2 359.6 L 1211.4 366.9 L 1207.0 371.0 L 1189.0 369.0 L 1172.0 381.0 L 1162.0 380.0 L 1160.9 383.4 L 1156.8 388.3 L 1152.0 393.5 L 1147.7 398.7 L 1141.7 404.7 L 1134.9 410.4 L 1127.2 413.8 L 1120.0 415.5 L 1112.4 417.4 L 1106.0 420.0 L 1106.0 442.0 L 1104.0 442.1 L 1104.0 443.9 L 1123.4 445.0 L 1129.7 448.6 L 1152.8 475.7 L 1157.0 477.5 L 1151.4 481.7 L 1151.8 482.0 L 1155.5 482.0 L 1155.5 481.5 L 1157.5 480.0 Z",
      "position": {
        "x": 1201.6,
        "y": 422.8
      },
      "badgeAnchor": {
        "x": 1201.6,
        "y": 422.8
      },
      "badgeRadius": 51,
      "adjacencies": [
        "east-warp",
        "glass-barrens",
        "hollow-reach",
        "jasper-ene-tower",
        "quiet-drift",
        "rust-shelf",
        "umber-drift"
      ],
      "borderDice": {
        "jasper-ene-tower": {
          "attack": 5
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "nadir-core",
      "name": "Nadir Core",
      "regionId": "nadir-mesa",
      "shape": "M 616.0 959.0 L 614.9 962.3 L 614.5 965.8 L 614.7 969.2 L 615.6 972.6 L 617.2 975.7 L 619.4 978.4 L 622.1 980.7 L 625.1 982.3 L 628.5 983.4 L 631.9 983.7 L 635.4 983.3 L 638.7 982.3 L 641.5 980.8 L 643.9 978.9 L 646.0 976.5 L 647.6 973.8 L 648.6 971.0 L 649.2 968.0 L 649.2 965.0 L 648.8 962.0 L 647.8 959.1 L 646.2 956.3 L 644.1 953.9 L 641.7 951.9 L 638.9 950.3 L 636.0 949.4 L 633.0 948.9 L 630.0 949.0 L 627.1 949.5 L 624.3 950.6 L 621.7 952.1 L 619.4 954.1 L 617.5 956.4 Z",
      "position": {
        "x": 631.9,
        "y": 966.3
      },
      "badgeAnchor": {
        "x": 631.9,
        "y": 966.3
      },
      "badgeRadius": 17.3,
      "adjacencies": [
        "nadir-e",
        "nadir-n",
        "nadir-ne",
        "nadir-nw",
        "nadir-se",
        "nadir-sw"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "nadir-crystal",
      "name": "Nadir Crystal",
      "regionId": "nadir-crystal",
      "shape": "M 583.5 1000.5 L 598.5 1009.5 L 597.5 1017.5 L 608.5 1019.5 L 613.5 1024.5 L 620.5 1018.5 L 635.5 1019.5 L 637.5 1017.5 L 629.5 1006.5 L 638.5 998.5 L 636.5 996.5 L 626.5 995.5 L 621.5 988.5 L 612.5 988.5 L 599.5 979.5 L 597.5 981.5 L 599.5 993.5 L 596.5 996.5 L 586.5 997.5 Z",
      "position": {
        "x": 613.4,
        "y": 1004.4
      },
      "badgeAnchor": {
        "x": 613.4,
        "y": 1004.4
      },
      "badgeRadius": 15.7,
      "badgeShrinksWithDigits": true,
      "adjacencies": [
        "nadir-sw"
      ],
      "borderDice": {
        "nadir-sw": {
          "defend": 4
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "nadir-e",
      "name": "Nadir East",
      "regionId": "nadir-mesa",
      "shape": "M 697.0 994.0 L 696.1 995.8 L 698.8 996.9 L 702.1 937.9 L 700.0 939.0 L 699.0 939.0 L 647.8 959.1 L 648.8 962.0 L 649.2 965.0 L 649.2 968.0 L 648.6 971.0 L 647.6 973.8 Z",
      "position": {
        "x": 681.1,
        "y": 966.7
      },
      "badgeAnchor": {
        "x": 681.1,
        "y": 966.7
      },
      "badgeRadius": 19.2,
      "adjacencies": [
        "nadir-core",
        "nadir-ne",
        "nadir-se"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "nadir-n",
      "name": "Nadir North",
      "regionId": "nadir-mesa",
      "shape": "M 641.5 897.5 L 636.5 901.5 L 623.5 900.5 L 619.9 894.7 L 618.5 892.5 L 615.5 892.5 L 614.5 891.2 L 611.2 890.3 L 610.0 892.0 L 609.0 892.0 L 605.0 898.0 L 624.3 950.6 L 627.1 949.5 L 630.0 949.0 L 633.0 948.9 L 636.0 949.4 L 638.9 950.3 L 659.0 900.0 L 653.0 892.0 L 652.0 892.0 L 649.9 892.5 L 648.7 890.8 L 648.1 890.9 L 646.5 892.5 L 643.5 892.5 L 641.5 894.5 L 641.5 895.8 Z",
      "position": {
        "x": 631.9,
        "y": 919.3
      },
      "badgeAnchor": {
        "x": 631.9,
        "y": 919.3
      },
      "badgeRadius": 17.9,
      "adjacencies": [
        "nadir-core",
        "nadir-n-tower",
        "nadir-ne",
        "nadir-nw"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "nadir-n-tower",
      "name": "Nadir North Tower",
      "regionId": "nadir-n-tower",
      "shape": "M 625.5 863.5 L 620.5 867.5 L 618.5 871.5 L 612.5 875.5 L 612.5 888.5 L 615.5 892.5 L 618.5 892.5 L 623.5 900.5 L 636.5 901.5 L 641.5 897.5 L 641.5 894.5 L 643.5 892.5 L 646.5 892.5 L 649.5 889.5 L 649.5 875.5 L 645.5 871.5 L 643.5 871.5 L 638.5 864.5 Z",
      "position": {
        "x": 631,
        "y": 882.5
      },
      "badgeAnchor": {
        "x": 631,
        "y": 882.5
      },
      "badgeRadius": 15.9,
      "badgeShrinksWithDigits": true,
      "adjacencies": [
        "cinder-shelf",
        "nadir-n",
        "rust-waste"
      ],
      "oneWayBorders": [
        "halo-plateau",
        "mica-flats",
        "ozone-scarp",
        "pale-steppe",
        "sable-dunes",
        "slate-reach",
        "static-scarp"
      ],
      "borderDice": {
        "cinder-shelf": {
          "defend": 7
        },
        "rust-waste": {
          "defend": 7
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "nadir-ne",
      "name": "Nadir Northeast",
      "regionId": "nadir-mesa",
      "shape": "M 638.9 950.3 L 641.7 951.9 L 644.1 953.9 L 646.2 956.3 L 647.8 959.1 L 699.0 939.0 L 659.0 900.0 Z",
      "position": {
        "x": 665.8,
        "y": 932.4
      },
      "badgeAnchor": {
        "x": 665.8,
        "y": 932.4
      },
      "badgeRadius": 18.3,
      "adjacencies": [
        "nadir-core",
        "nadir-e",
        "nadir-n",
        "nadir-ne-gate"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "nadir-ne-gate",
      "name": "Nadir Northeast Gate",
      "shape": "M 702.1 937.9 L 702.0 939.1 L 702.6 939.7 L 701.9 940.0 L 701.9 940.2 L 711.0 935.3 L 711.0 933.0 L 728.0 923.0 L 751.0 905.0 L 734.0 882.0 L 690.0 843.0 L 685.4 851.4 L 680.8 859.3 L 676.0 867.5 L 671.2 875.7 L 666.6 883.6 L 659.7 888.2 L 653.0 892.0 L 659.0 900.0 L 699.0 939.0 L 700.0 939.0 Z",
      "position": {
        "x": 701.8,
        "y": 896.6
      },
      "badgeAnchor": {
        "x": 701.8,
        "y": 896.6
      },
      "badgeRadius": 32.3,
      "adjacencies": [
        "cinder-shelf",
        "halo-plateau",
        "nadir-ne",
        "shale-scarp"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "nadir-nw",
      "name": "Nadir Northwest",
      "regionId": "nadir-mesa",
      "shape": "M 605.0 898.0 L 565.0 938.0 L 616.0 959.0 L 617.5 956.4 L 619.4 954.1 L 621.7 952.1 L 624.3 950.6 Z",
      "position": {
        "x": 597.7,
        "y": 931.6
      },
      "badgeAnchor": {
        "x": 597.7,
        "y": 931.6
      },
      "badgeRadius": 18.4,
      "adjacencies": [
        "nadir-core",
        "nadir-n",
        "nadir-nw-gate",
        "nadir-sw"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "nadir-nw-gate",
      "name": "Nadir Northwest Gate",
      "shape": "M 564.0 939.0 L 565.0 938.0 L 605.0 898.0 L 609.0 892.0 L 603.2 887.8 L 598.0 884.0 L 593.2 875.3 L 588.3 866.7 L 583.5 858.0 L 578.7 849.3 L 574.0 841.0 L 528.0 883.0 L 512.0 901.0 L 526.0 916.0 L 551.0 932.0 Z",
      "position": {
        "x": 561.9,
        "y": 895.7
      },
      "badgeAnchor": {
        "x": 561.9,
        "y": 895.7
      },
      "badgeRadius": 32.1,
      "adjacencies": [
        "nadir-nw",
        "pale-shelf",
        "rust-waste",
        "slate-reach"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "nadir-se",
      "name": "Nadir Southeast",
      "regionId": "nadir-mesa",
      "shape": "M 647.6 973.8 L 646.0 976.5 L 643.9 978.9 L 641.5 980.8 L 638.7 982.3 L 659.0 1030.0 L 656.8 1030.0 L 658.2 1033.2 L 693.6 1005.3 L 698.0 996.6 L 696.1 995.8 L 697.0 994.0 Z",
      "position": {
        "x": 667.3,
        "y": 1002.1
      },
      "badgeAnchor": {
        "x": 667.3,
        "y": 1002.1
      },
      "badgeRadius": 18.6,
      "adjacencies": [
        "nadir-core",
        "nadir-e",
        "nadir-sw"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "nadir-sw",
      "name": "Nadir Southwest",
      "regionId": "nadir-mesa",
      "shape": "M 631.9 983.7 L 628.5 983.4 L 625.1 982.3 L 622.1 980.7 L 619.4 978.4 L 617.2 975.7 L 615.6 972.6 L 614.7 969.2 L 614.5 965.8 L 614.9 962.3 L 616.0 959.0 L 565.0 938.0 L 564.0 939.0 L 564.0 939.7 L 563.9 941.2 L 562.0 940.2 L 560.0 994.8 L 596.2 1032.0 L 657.7 1032.0 L 656.8 1030.0 L 659.0 1030.0 L 638.7 982.3 L 635.4 983.3 Z M 596.5 996.5 L 599.5 993.5 L 597.5 981.5 L 599.5 979.5 L 612.5 988.5 L 621.5 988.5 L 626.5 995.5 L 636.5 996.5 L 638.5 998.5 L 629.5 1006.5 L 637.5 1017.5 L 635.5 1019.5 L 620.5 1018.5 L 613.5 1024.5 L 608.5 1019.5 L 597.5 1017.5 L 598.5 1009.5 L 583.5 1000.5 L 586.5 997.5 Z",
      "position": {
        "x": 581.8,
        "y": 967.9
      },
      "badgeAnchor": {
        "x": 581.8,
        "y": 967.9
      },
      "badgeRadius": 20.8,
      "adjacencies": [
        "nadir-core",
        "nadir-crystal",
        "nadir-nw",
        "nadir-se"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "nexus-warp",
      "name": "Nexus Warp",
      "regionId": "nexus-warp",
      "shape": "M 665.8 523.0 L 665.6 519.5 L 665.1 516.2 L 664.3 512.8 L 663.2 509.6 L 661.8 506.4 L 660.1 503.4 L 658.2 500.6 L 656.1 497.9 L 653.8 495.4 L 651.2 493.1 L 648.5 491.0 L 645.5 489.2 L 642.5 487.6 L 639.3 486.4 L 636.0 485.3 L 632.7 484.6 L 629.3 484.2 L 625.9 484.0 L 622.4 484.2 L 619.0 484.6 L 615.7 485.3 L 612.4 486.4 L 609.2 487.7 L 606.1 489.2 L 603.2 491.0 L 600.5 493.1 L 597.9 495.4 L 595.6 497.9 L 593.5 500.6 L 591.6 503.4 L 589.9 506.5 L 588.6 509.6 L 587.5 512.9 L 586.7 516.2 L 586.1 519.6 L 585.9 523.0 L 586.0 526.5 L 586.3 529.9 L 587.0 533.3 L 587.9 536.6 L 589.1 539.8 L 590.6 542.9 L 592.4 545.9 L 594.4 548.7 L 596.7 551.3 L 599.1 553.7 L 601.8 555.9 L 604.6 557.9 L 607.6 559.6 L 610.8 561.0 L 614.0 562.2 L 617.3 563.1 L 620.7 563.6 L 624.2 563.9 L 627.6 563.9 L 631.0 563.6 L 634.5 563.0 L 637.8 562.2 L 641.0 561.0 L 644.1 559.5 L 647.1 557.9 L 650.0 555.9 L 652.6 553.7 L 655.1 551.3 L 657.3 548.6 L 659.4 545.9 L 661.1 542.9 L 662.6 539.8 L 663.8 536.6 L 664.8 533.2 L 665.4 529.9 L 665.8 526.4 Z",
      "position": {
        "x": 625.9,
        "y": 523.9
      },
      "badgeAnchor": {
        "x": 625.9,
        "y": 523.9
      },
      "badgeRadius": 39.8,
      "adjacencies": [
        "chrome-dunes",
        "east-warp",
        "garnet-e-gate",
        "topaz-w-gate",
        "vapor-reach",
        "west-warp"
      ],
      "borderDice": {
        "chrome-dunes": {
          "defend": 4
        },
        "east-warp": {
          "attack": 5,
          "defend": 7
        },
        "garnet-e-gate": {
          "defend": 4
        },
        "topaz-w-gate": {
          "defend": 4
        },
        "vapor-reach": {
          "defend": 4
        },
        "west-warp": {
          "attack": 5,
          "defend": 7
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "nova-crystal",
      "name": "Nova Crystal",
      "regionId": "nova-crystal",
      "shape": "M 884.5 616.5 L 876.5 622.5 L 866.5 619.5 L 865.5 626.5 L 861.5 630.5 L 858.5 629.5 L 854.5 631.5 L 851.5 629.5 L 846.5 634.5 L 849.5 637.5 L 864.5 640.5 L 867.5 643.5 L 861.5 653.5 L 865.5 657.5 L 872.5 652.5 L 876.5 656.5 L 883.5 670.5 L 886.5 667.5 L 887.5 653.5 L 890.5 650.5 L 901.5 649.5 L 894.5 637.5 L 907.5 626.5 L 904.5 623.5 L 889.5 625.5 Z",
      "position": {
        "x": 880.2,
        "y": 636.9
      },
      "badgeAnchor": {
        "x": 880.2,
        "y": 636.9
      },
      "badgeRadius": 14.3,
      "badgeShrinksWithDigits": true,
      "adjacencies": [
        "halo-barrens",
        "ochre-plateau",
        "slate-ridge"
      ],
      "borderDice": {
        "halo-barrens": {
          "defend": 4
        },
        "ochre-plateau": {
          "defend": 4
        },
        "slate-ridge": {
          "defend": 4
        },
        "topaz-ese-tower": {
          "defend": 4
        },
        "topaz-ssw-tower": {
          "defend": 4
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ochre-barrens",
      "name": "Ochre Barrens",
      "shape": "M 698.0 324.0 L 694.8 322.2 L 691.8 319.2 L 687.0 312.0 L 683.0 305.0 L 685.0 274.0 L 680.0 265.6 L 675.8 262.2 L 672.0 259.0 L 665.7 262.7 L 660.6 264.6 L 654.5 265.0 L 647.7 265.2 L 642.4 266.9 L 637.3 270.3 L 631.2 276.2 L 625.2 282.2 L 620.6 285.1 L 616.0 288.0 L 600.0 289.0 L 597.8 290.8 L 588.7 294.2 L 584.3 297.3 L 580.2 300.7 L 575.4 306.4 L 571.7 313.7 L 569.2 321.2 L 567.5 329.0 L 566.1 336.6 L 566.0 343.0 L 566.2 349.3 L 567.6 354.4 L 569.0 359.0 L 572.8 363.2 L 576.8 367.2 L 581.7 370.3 L 586.0 372.0 L 585.5 373.9 L 586.9 374.5 L 591.4 366.1 L 596.5 361.8 L 599.6 356.8 L 604.4 352.2 L 611.9 347.3 L 620.2 344.1 L 628.3 339.1 L 633.8 336.3 L 640.1 333.9 L 646.9 332.2 L 652.7 332.0 L 658.6 331.1 L 664.2 331.6 L 670.6 332.1 L 678.0 334.0 L 682.8 337.1 L 692.0 340.5 L 692.6 339.3 L 691.0 338.0 Z",
      "position": {
        "x": 651.7,
        "y": 300.2
      },
      "badgeAnchor": {
        "x": 626.9,
        "y": 311.67
      },
      "badgeRadius": 31.4,
      "adjacencies": [
        "pale-basin",
        "slate-dunes",
        "static-fields",
        "vapor-ridge"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ochre-drift",
      "name": "Ochre Drift",
      "shape": "M 405.0 959.0 L 427.0 937.0 L 418.0 924.0 L 428.0 912.0 L 422.0 905.0 L 424.0 885.0 L 417.0 877.0 L 418.1 875.3 L 417.7 874.8 L 408.0 876.8 L 405.3 872.4 L 404.3 866.3 L 403.2 861.6 L 409.2 855.6 L 408.6 852.7 L 410.0 847.1 L 409.1 840.6 L 422.9 823.9 L 423.6 820.0 L 423.4 818.9 L 421.4 819.0 L 421.0 817.0 L 418.0 806.0 L 405.0 797.0 L 403.9 798.7 L 402.3 797.6 L 403.3 795.9 L 400.7 800.0 L 396.9 803.6 L 392.8 806.2 L 390.1 809.7 L 383.4 812.3 L 376.5 814.9 L 369.5 817.6 L 367.3 819.1 L 369.0 818.9 L 369.7 819.9 L 368.0 821.0 L 376.0 833.0 L 371.7 834.7 L 364.5 839.0 L 356.7 843.2 L 349.0 848.0 L 341.1 852.6 L 335.0 857.0 L 328.4 861.4 L 322.3 866.3 L 315.8 871.8 L 312.0 875.5 L 308.3 879.3 L 307.0 882.0 L 311.6 885.4 L 316.2 889.8 L 319.8 895.7 L 323.1 902.4 L 326.6 911.4 L 330.0 920.5 L 333.6 930.0 L 336.9 937.6 L 340.7 945.3 L 344.4 953.1 L 344.9 957.0 L 344.0 963.0 L 405.0 963.0 Z",
      "position": {
        "x": 374.2,
        "y": 907.9
      },
      "badgeAnchor": {
        "x": 374.2,
        "y": 907.9
      },
      "badgeRadius": 45.8,
      "adjacencies": [
        "basalt-waste",
        "flint-hollows",
        "frost-barrens",
        "slate-reach",
        "static-flats",
        "vapor-expanse"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ochre-plateau",
      "name": "Ochre Plateau",
      "shape": "M 711.5 568.0 L 717.0 576.0 L 718.8 580.2 L 718.9 587.9 L 717.1 597.5 L 718.0 605.0 L 746.0 634.0 L 746.0 638.0 L 754.2 638.3 L 759.7 639.8 L 765.0 642.0 L 770.6 646.4 L 775.8 651.2 L 781.9 655.6 L 787.5 660.0 L 793.5 664.0 L 797.0 668.0 L 805.2 669.3 L 811.0 672.0 L 814.9 681.1 L 816.4 687.6 L 818.4 694.6 L 821.2 698.3 L 826.4 702.6 L 832.0 707.0 L 859.0 682.0 L 860.0 676.0 L 849.0 659.0 L 863.7 640.3 L 849.5 637.5 L 846.5 634.5 L 851.5 629.5 L 854.5 631.5 L 854.8 631.3 L 846.0 602.0 L 847.5 600.1 L 847.5 600.1 L 792.4 595.9 L 794.1 598.0 L 794.5 598.5 L 794.5 610.5 L 786.5 616.5 L 786.5 618.5 L 782.5 622.5 L 768.5 622.5 L 763.5 614.5 L 760.5 614.5 L 757.5 611.5 L 757.5 596.5 L 765.5 591.5 L 765.5 588.5 L 767.0 587.0 L 768.4 585.6 L 735.2 556.3 L 733.0 557.0 L 710.0 563.0 Z",
      "position": {
        "x": 813.7,
        "y": 637.4
      },
      "badgeAnchor": {
        "x": 813.7,
        "y": 637.4
      },
      "badgeRadius": 32.9,
      "adjacencies": [
        "halo-barrens",
        "nova-crystal",
        "pale-steppe",
        "shale-fields",
        "slate-ridge",
        "static-scarp",
        "topaz-ssw-tower",
        "topaz-w-gate",
        "vapor-reach"
      ],
      "borderDice": {
        "topaz-ssw-tower": {
          "attack": 5
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "opal-core",
      "name": "Opal Core",
      "regionId": "opal-mesa",
      "shape": "M 959.8 507.4 L 956.5 506.4 L 953.0 506.1 L 949.6 506.5 L 946.2 507.6 L 943.5 509.1 L 941.1 511.1 L 939.1 513.5 L 937.5 516.2 L 936.6 518.9 L 936.1 521.6 L 936.0 524.4 L 936.4 527.2 L 937.3 529.9 L 938.8 532.8 L 940.9 535.4 L 943.5 537.5 L 946.4 539.1 L 949.6 540.2 L 953.0 540.6 L 956.4 540.3 L 959.7 539.3 L 962.7 537.7 L 965.3 535.6 L 967.5 533.0 L 969.1 530.0 L 970.0 527.3 L 970.5 524.5 L 970.4 521.6 L 969.9 518.8 L 968.9 516.1 L 967.3 513.3 L 965.2 510.9 L 962.7 508.9 Z",
      "position": {
        "x": 953.2,
        "y": 523.3
      },
      "badgeAnchor": {
        "x": 953.2,
        "y": 523.3
      },
      "badgeRadius": 17.1,
      "adjacencies": [
        "opal-e",
        "opal-n",
        "opal-ne",
        "opal-nw",
        "opal-s",
        "opal-se",
        "opal-sw",
        "opal-w"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "opal-e",
      "name": "Opal East",
      "regionId": "opal-mesa",
      "shape": "M 1022.0 497.0 L 1020.0 496.5 L 1020.0 495.9 L 1021.6 494.8 L 1017.8 493.9 L 1016.6 494.4 L 1018.0 496.0 L 968.9 516.1 L 969.9 518.8 L 970.4 521.6 L 970.5 524.5 L 970.0 527.3 L 969.1 530.0 L 1017.0 550.0 L 1015.5 551.5 L 1017.0 552.2 L 1022.2 550.1 L 1020.0 549.6 L 1020.0 548.8 L 1022.0 548.0 Z",
      "position": {
        "x": 1002.7,
        "y": 523.2
      },
      "badgeAnchor": {
        "x": 1002.7,
        "y": 523.2
      },
      "badgeRadius": 19.2,
      "adjacencies": [
        "jasper-w",
        "opal-core",
        "opal-ne",
        "opal-se"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "opal-n",
      "name": "Opal North",
      "regionId": "opal-mesa",
      "shape": "M 946.2 507.6 L 949.6 506.5 L 953.0 506.1 L 956.5 506.4 L 959.8 507.4 L 981.0 457.0 L 927.0 457.0 Z",
      "position": {
        "x": 953.6,
        "y": 475.4
      },
      "badgeAnchor": {
        "x": 953.6,
        "y": 475.4
      },
      "badgeRadius": 18.1,
      "adjacencies": [
        "opal-core",
        "opal-n-gate",
        "opal-ne",
        "opal-nw"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "opal-n-gate",
      "name": "Opal North Gate",
      "shape": "M 921.0 444.0 L 919.4 445.7 L 922.3 457.5 L 924.0 456.0 L 927.0 457.0 L 981.0 457.0 L 983.0 457.0 L 983.3 455.0 L 984.0 455.0 L 983.1 457.1 L 984.7 458.9 L 986.8 445.6 L 985.0 444.0 L 997.0 402.0 L 998.0 393.0 L 971.0 393.0 L 911.0 393.0 L 909.1 396.6 L 910.0 405.0 Z",
      "position": {
        "x": 953.1,
        "y": 425.1
      },
      "badgeAnchor": {
        "x": 953.1,
        "y": 425.1
      },
      "badgeRadius": 31.9,
      "adjacencies": [
        "opal-n",
        "quiet-drift",
        "rust-shelf",
        "sable-flats",
        "shale-hollows"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "opal-ne",
      "name": "Opal Northeast",
      "regionId": "opal-mesa",
      "shape": "M 962.7 508.9 L 965.2 510.9 L 967.3 513.3 L 968.9 516.1 L 1018.0 496.0 L 1016.6 494.4 L 1017.8 493.9 L 1019.1 494.2 L 985.1 456.4 L 984.7 458.9 L 983.0 457.0 L 981.0 457.0 L 959.8 507.4 Z",
      "position": {
        "x": 988.2,
        "y": 488.1
      },
      "badgeAnchor": {
        "x": 988.2,
        "y": 488.1
      },
      "badgeRadius": 18.6,
      "adjacencies": [
        "opal-core",
        "opal-e",
        "opal-n"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "opal-nw",
      "name": "Opal Northwest",
      "regionId": "opal-mesa",
      "shape": "M 941.1 511.1 L 943.5 509.1 L 946.2 507.6 L 927.0 457.0 L 924.0 456.0 L 922.3 457.5 L 921.8 455.3 L 899.5 475.7 L 899.5 478.8 L 899.5 482.5 L 891.5 487.5 L 891.5 490.5 L 887.7 493.3 L 937.5 516.2 L 939.1 513.5 Z",
      "position": {
        "x": 918.1,
        "y": 486.2
      },
      "badgeAnchor": {
        "x": 918.1,
        "y": 486.2
      },
      "badgeRadius": 18.7,
      "adjacencies": [
        "opal-core",
        "opal-n",
        "opal-w",
        "topaz-ene-tower"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "opal-s",
      "name": "Opal South",
      "regionId": "opal-mesa",
      "shape": "M 956.4 540.3 L 953.0 540.6 L 949.6 540.2 L 946.4 539.1 L 927.0 588.0 L 925.4 586.6 L 924.7 588.5 L 927.0 590.8 L 928.0 589.0 L 979.0 589.0 L 980.2 591.0 L 980.2 591.0 L 982.2 587.1 L 981.5 585.5 L 980.0 587.0 L 959.7 539.3 Z",
      "position": {
        "x": 953.4,
        "y": 570.8
      },
      "badgeAnchor": {
        "x": 953.4,
        "y": 570.8
      },
      "badgeRadius": 18.1,
      "adjacencies": [
        "opal-core",
        "opal-s-gate",
        "opal-se",
        "opal-sw"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "opal-s-gate",
      "name": "Opal South Gate",
      "shape": "M 909.0 654.0 L 998.0 654.0 L 987.0 602.0 L 985.9 600.2 L 986.6 599.6 L 987.4 598.8 L 981.3 588.9 L 980.2 591.0 L 980.2 591.0 L 979.0 589.0 L 928.0 589.0 L 927.0 590.8 L 925.5 589.4 L 919.6 600.4 L 921.0 602.0 L 912.0 634.0 Z",
      "position": {
        "x": 953.7,
        "y": 621.6
      },
      "badgeAnchor": {
        "x": 953.7,
        "y": 621.6
      },
      "badgeRadius": 32.4,
      "adjacencies": [
        "halo-barrens",
        "opal-s",
        "slate-ridge"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "opal-se",
      "name": "Opal Southeast",
      "regionId": "opal-mesa",
      "shape": "M 967.5 533.0 L 965.3 535.6 L 962.7 537.7 L 959.7 539.3 L 980.0 587.0 L 981.5 585.5 L 982.2 587.1 L 981.6 588.2 L 1018.1 551.7 L 1017.0 552.2 L 1015.5 551.5 L 1017.0 550.0 L 969.1 530.0 Z",
      "position": {
        "x": 986.9,
        "y": 557.1
      },
      "badgeAnchor": {
        "x": 986.9,
        "y": 557.1
      },
      "badgeRadius": 18.1,
      "adjacencies": [
        "opal-core",
        "opal-e",
        "opal-s"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "opal-sw",
      "name": "Opal Southwest",
      "regionId": "opal-mesa",
      "shape": "M 946.4 539.1 L 943.5 537.5 L 940.9 535.4 L 938.8 532.8 L 937.3 529.9 L 886.2 551.5 L 888.5 551.5 L 893.5 559.5 L 896.5 559.5 L 900.5 563.5 L 900.0 570.0 L 899.9 572.0 L 907.1 572.9 L 925.5 589.4 L 925.5 589.4 L 924.7 588.5 L 925.4 586.6 L 927.0 588.0 Z",
      "position": {
        "x": 918.8,
        "y": 558.1
      },
      "badgeAnchor": {
        "x": 918.8,
        "y": 558.1
      },
      "badgeRadius": 18.6,
      "adjacencies": [
        "opal-core",
        "opal-s",
        "opal-w",
        "topaz-ese-tower"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "opal-w",
      "name": "Opal West",
      "regionId": "opal-mesa",
      "shape": "M 885.0 493.5 L 883.9 493.8 L 883.8 493.7 L 884.2 493.5 L 881.0 493.5 L 881.0 493.6 L 883.0 494.0 L 882.0 551.0 L 880.5 551.5 L 881.0 551.5 L 882.1 551.0 L 883.5 551.5 L 886.2 551.5 L 937.3 529.9 L 936.4 527.2 L 936.0 524.4 L 936.1 521.6 L 936.6 518.9 L 937.5 516.2 L 887.7 493.3 L 887.5 493.5 Z",
      "position": {
        "x": 902.8,
        "y": 522.6
      },
      "badgeAnchor": {
        "x": 902.8,
        "y": 522.6
      },
      "badgeRadius": 20.1,
      "adjacencies": [
        "opal-core",
        "opal-nw",
        "opal-sw",
        "topaz-e",
        "topaz-ene-tower",
        "topaz-ese-tower"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ozone-fields",
      "name": "Ozone Fields",
      "shape": "M 177.0 673.0 L 167.0 634.0 L 147.0 622.0 L 137.9 625.9 L 132.0 627.5 L 126.7 628.7 L 122.0 631.0 L 117.8 633.8 L 110.8 639.8 L 104.5 646.0 L 98.1 652.1 L 95.7 655.7 L 93.0 664.0 L 100.3 668.1 L 108.0 672.0 L 116.0 675.5 L 123.7 679.3 L 132.8 682.8 L 142.5 686.0 L 151.2 688.3 L 160.1 689.9 L 165.9 689.9 L 170.0 689.0 L 175.3 681.3 L 176.8 676.8 Z",
      "position": {
        "x": 141.9,
        "y": 655.1
      },
      "badgeAnchor": {
        "x": 141.9,
        "y": 655.1
      },
      "badgeRadius": 29.1,
      "adjacencies": [
        "cinder-steppe",
        "ghost-basin",
        "ion-dunes"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ozone-hollows",
      "name": "Ozone Hollows",
      "shape": "M 1135.0 183.0 L 1137.9 173.4 L 1140.8 163.8 L 1139.6 156.4 L 1138.0 149.0 L 1135.0 147.0 L 1131.4 147.3 L 1124.5 152.5 L 1124.5 154.5 L 1120.5 158.5 L 1107.5 158.5 L 1101.5 150.5 L 1099.5 150.5 L 1095.5 146.5 L 1095.5 133.5 L 1103.5 127.5 L 1103.5 125.5 L 1107.5 121.5 L 1107.7 121.5 L 1108.0 120.0 L 1104.0 116.0 L 1095.2 113.3 L 1091.7 113.2 L 1084.0 115.0 L 1076.6 117.1 L 1068.7 119.2 L 1060.8 121.3 L 1057.0 123.0 L 1058.0 129.0 L 1057.0 135.0 L 1058.0 143.0 L 1059.0 150.5 L 1060.0 158.0 L 1061.3 165.2 L 1064.2 172.3 L 1067.0 179.0 L 1069.4 180.1 L 1077.1 186.4 L 1083.7 189.8 L 1091.2 192.3 L 1099.2 194.3 L 1102.0 196.0 L 1130.0 198.0 L 1132.4 192.4 Z",
      "position": {
        "x": 1086.3,
        "y": 166.7
      },
      "badgeAnchor": {
        "x": 1086.3,
        "y": 166.7
      },
      "badgeRadius": 20.9,
      "adjacencies": [
        "ashen-dunes",
        "cinder-basin",
        "corona-s-gate",
        "corona-sw-tower",
        "corona-w-gate",
        "ghost-expanse",
        "quiet-plateau"
      ],
      "borderDice": {
        "corona-sw-tower": {
          "attack": 5
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "ozone-scarp",
      "name": "Ozone Scarp",
      "shape": "M 745.7 798.8 L 748.4 803.1 L 751.1 807.4 L 753.5 813.0 L 754.0 819.5 L 754.0 826.0 L 744.0 840.0 L 744.3 848.2 L 746.2 853.3 L 748.0 858.0 L 756.8 856.3 L 765.5 855.1 L 773.4 856.6 L 781.0 859.0 L 807.0 894.0 L 817.0 884.0 L 826.0 884.0 L 826.0 876.5 L 826.2 869.7 L 829.0 862.0 L 835.0 855.5 L 841.0 850.5 L 846.5 846.0 L 851.4 839.9 L 855.7 832.2 L 857.7 826.2 L 858.0 822.0 L 856.0 821.6 L 856.2 819.6 L 849.9 818.4 L 841.1 816.7 L 836.0 813.9 L 833.2 813.2 L 828.8 810.4 L 822.0 810.0 L 814.1 800.5 L 815.1 795.5 L 810.6 789.6 L 808.7 785.0 L 806.6 778.6 L 800.5 775.5 L 799.0 777.0 L 791.4 778.4 L 785.3 781.3 L 778.4 783.8 L 775.2 783.8 L 770.0 782.5 L 764.4 781.2 L 759.0 782.0 L 745.0 796.0 Z",
      "position": {
        "x": 789.2,
        "y": 824.8
      },
      "badgeAnchor": {
        "x": 794.79,
        "y": 830.66
      },
      "badgeRadius": 34.7,
      "adjacencies": [
        "ashen-reach",
        "cinder-shelf",
        "halo-plateau",
        "pale-steppe"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "pale-basin",
      "name": "Pale Basin",
      "shape": "M 680.9 405.6 L 682.9 411.6 L 685.5 416.0 L 689.0 420.0 L 698.2 423.8 L 704.8 425.2 L 711.3 426.2 L 718.0 428.0 L 724.8 426.3 L 730.8 424.3 L 737.0 418.5 L 743.0 413.0 L 783.0 411.0 L 783.0 401.5 L 783.1 391.6 L 784.4 383.4 L 786.0 375.0 L 793.0 367.0 L 805.0 365.0 L 811.0 359.0 L 813.3 349.8 L 814.9 339.9 L 814.4 332.6 L 814.2 324.7 L 815.5 320.0 L 817.0 315.0 L 813.9 314.1 L 805.7 313.8 L 801.8 312.7 L 797.4 310.6 L 792.4 306.1 L 790.0 305.0 L 783.2 312.2 L 777.0 315.0 L 769.3 314.2 L 761.4 313.1 L 756.5 313.0 L 751.1 313.1 L 743.4 314.4 L 735.2 316.2 L 727.2 318.2 L 722.0 320.4 L 716.2 322.7 L 709.2 324.7 L 702.6 324.9 L 698.0 324.0 L 691.0 338.0 L 692.6 339.3 L 692.0 340.5 L 690.0 339.8 L 696.5 345.1 L 698.6 349.5 L 701.3 354.1 L 702.7 359.1 L 702.8 365.3 L 699.6 371.5 L 699.7 376.4 L 698.3 379.8 L 692.7 384.8 L 687.6 388.1 L 681.8 391.9 L 678.6 398.4 L 681.3 397.4 L 683.3 393.3 L 680.0 400.0 Z",
      "position": {
        "x": 745.9,
        "y": 359.2
      },
      "badgeAnchor": {
        "x": 745.9,
        "y": 359.2
      },
      "badgeRadius": 43.1,
      "adjacencies": [
        "chrome-dunes",
        "frost-waste",
        "halo-waste",
        "ochre-barrens",
        "shale-hollows",
        "slate-dunes"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "pale-expanse",
      "name": "Pale Expanse",
      "shape": "M 525.9 123.4 L 531.0 121.0 L 536.6 117.6 L 539.0 115.0 L 541.0 113.7 L 540.0 48.7 L 553.3 32.6 L 552.3 33.1 L 550.5 32.8 L 538.0 48.0 L 552.0 31.0 L 546.5 30.0 L 540.6 30.6 L 535.1 30.9 L 527.1 26.4 L 521.0 27.0 L 516.5 30.1 L 512.5 33.0 L 505.6 39.0 L 499.0 45.5 L 495.0 51.0 L 493.0 56.0 L 496.2 65.3 L 499.8 69.2 L 503.9 73.5 L 506.4 78.0 L 507.8 82.7 L 508.2 91.8 L 510.0 98.0 L 521.0 109.0 L 523.0 124.0 Z",
      "position": {
        "x": 518.6,
        "y": 57.1
      },
      "badgeAnchor": {
        "x": 518.35,
        "y": 64.2
      },
      "badgeRadius": 21.4,
      "adjacencies": [
        "glass-shelf",
        "static-hollows",
        "zenith-sw-gate"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "pale-shelf",
      "name": "Pale Shelf",
      "shape": "M 526.0 916.0 L 520.3 920.3 L 516.6 924.1 L 514.0 929.5 L 512.0 935.0 L 512.3 942.2 L 513.5 950.0 L 516.0 957.5 L 518.9 965.6 L 521.9 973.1 L 524.9 981.1 L 526.9 987.1 L 528.7 993.8 L 530.0 1001.0 L 530.0 1009.0 L 530.0 1017.0 L 530.2 1025.3 L 532.9 1034.1 L 536.0 1043.0 L 533.9 1043.0 L 534.6 1045.0 L 600.1 1045.0 L 553.0 1001.1 L 553.0 935.3 L 551.0 934.3 L 551.0 932.0 Z",
      "position": {
        "x": 533.1,
        "y": 945.3
      },
      "badgeAnchor": {
        "x": 533.1,
        "y": 945.3
      },
      "badgeRadius": 19.9,
      "adjacencies": [
        "nadir-nw-gate",
        "slate-reach",
        "static-flats"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "pale-steppe",
      "name": "Pale Steppe",
      "shape": "M 716.5 779.0 L 723.2 780.3 L 731.0 783.5 L 734.5 786.0 L 738.5 790.0 L 742.2 794.3 L 745.0 796.0 L 759.0 782.0 L 764.4 781.2 L 770.0 782.5 L 775.2 783.8 L 778.4 783.8 L 785.3 781.3 L 791.4 778.4 L 799.0 777.0 L 800.5 775.5 L 802.4 776.5 L 806.6 772.3 L 802.0 765.4 L 803.0 747.7 L 806.0 743.9 L 809.6 740.7 L 813.3 737.3 L 820.2 733.5 L 828.7 729.4 L 829.1 728.0 L 827.0 728.0 L 828.1 723.1 L 830.5 718.0 L 832.5 712.0 L 832.0 707.0 L 826.4 702.6 L 821.2 698.3 L 818.4 694.6 L 816.4 687.6 L 814.9 681.1 L 811.0 672.0 L 805.2 669.3 L 797.0 668.0 L 790.4 673.4 L 783.8 678.8 L 777.0 684.5 L 771.0 690.5 L 765.0 696.5 L 759.0 702.5 L 753.0 709.0 L 735.0 711.0 L 733.2 717.2 L 733.0 723.0 L 735.3 730.7 L 737.8 738.7 L 737.9 745.9 L 736.7 750.2 L 734.3 755.3 L 731.0 760.5 L 726.9 764.4 L 721.0 768.0 L 714.5 772.0 L 711.1 775.6 L 710.0 778.0 Z",
      "position": {
        "x": 771.2,
        "y": 738.1
      },
      "badgeAnchor": {
        "x": 771.2,
        "y": 738.1
      },
      "badgeRadius": 33.2,
      "adjacencies": [
        "cinder-shelf",
        "ochre-plateau",
        "ozone-scarp",
        "shale-fields",
        "static-scarp"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "penumbra-core",
      "name": "Penumbra Core",
      "regionId": "penumbra-mesa",
      "shape": "M 1157.8 958.4 L 1156.6 961.3 L 1156.0 964.5 L 1155.9 967.6 L 1156.5 970.8 L 1157.5 973.7 L 1159.3 976.7 L 1161.7 979.3 L 1164.5 981.4 L 1167.7 982.8 L 1171.0 983.6 L 1174.5 983.7 L 1178.0 983.2 L 1181.2 981.9 L 1184.1 980.1 L 1186.7 977.7 L 1188.7 974.8 L 1190.0 971.8 L 1190.7 968.6 L 1190.8 965.3 L 1190.3 962.0 L 1189.2 958.9 L 1187.7 956.3 L 1185.7 953.9 L 1183.4 952.0 L 1180.8 950.5 L 1177.8 949.4 L 1174.6 948.9 L 1171.5 948.9 L 1168.3 949.6 L 1165.4 950.8 L 1163.0 952.2 L 1161.0 954.0 L 1159.2 956.1 Z",
      "position": {
        "x": 1173.3,
        "y": 966.3
      },
      "badgeAnchor": {
        "x": 1173.3,
        "y": 966.3
      },
      "badgeRadius": 17.3,
      "adjacencies": [
        "penumbra-e",
        "penumbra-n",
        "penumbra-ne",
        "penumbra-nw",
        "penumbra-s",
        "penumbra-w"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "penumbra-crystal",
      "name": "Penumbra Crystal",
      "regionId": "penumbra-crystal",
      "shape": "M 1217.5 993.5 L 1215.5 991.5 L 1204.5 992.5 L 1197.5 984.5 L 1190.5 989.5 L 1181.5 988.5 L 1180.5 994.5 L 1177.5 997.5 L 1167.5 1000.5 L 1164.5 1003.5 L 1174.5 1007.5 L 1178.5 1011.5 L 1175.5 1020.5 L 1177.5 1024.5 L 1190.5 1019.5 L 1198.5 1024.5 L 1206.5 1014.5 L 1211.5 1013.5 L 1208.5 1003.5 Z",
      "position": {
        "x": 1192.9,
        "y": 1004.6
      },
      "badgeAnchor": {
        "x": 1192.9,
        "y": 1004.6
      },
      "badgeRadius": 15.1,
      "badgeShrinksWithDigits": true,
      "adjacencies": [
        "penumbra-s"
      ],
      "borderDice": {
        "penumbra-s": {
          "defend": 4
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "penumbra-e",
      "name": "Penumbra East",
      "regionId": "penumbra-mesa",
      "shape": "M 1189.2 958.9 L 1190.3 962.0 L 1190.8 965.3 L 1190.7 968.6 L 1190.0 971.8 L 1188.7 974.8 L 1240.0 993.0 L 1238.5 994.6 L 1241.9 995.8 L 1243.1 936.1 L 1239.3 937.5 L 1241.0 939.0 Z",
      "position": {
        "x": 1223.1,
        "y": 966.6
      },
      "badgeAnchor": {
        "x": 1223.1,
        "y": 966.6
      },
      "badgeRadius": 19.2,
      "adjacencies": [
        "penumbra-core",
        "penumbra-ne",
        "penumbra-s"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "penumbra-n",
      "name": "Penumbra North",
      "regionId": "penumbra-mesa",
      "shape": "M 1168.3 949.6 L 1171.5 948.9 L 1174.6 948.9 L 1177.8 949.4 L 1180.8 950.5 L 1199.0 902.0 L 1200.6 903.4 L 1201.2 901.7 L 1198.2 897.2 L 1197.0 899.0 L 1146.0 900.0 L 1165.4 950.8 Z",
      "position": {
        "x": 1172.9,
        "y": 918.3
      },
      "badgeAnchor": {
        "x": 1172.9,
        "y": 918.3
      },
      "badgeRadius": 18.6,
      "adjacencies": [
        "penumbra-core",
        "penumbra-n-gate",
        "penumbra-ne",
        "penumbra-nw"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "penumbra-n-gate",
      "name": "Penumbra North Gate",
      "shape": "M 1128.0 834.0 L 1132.0 853.0 L 1134.4 860.6 L 1136.5 868.0 L 1138.7 875.8 L 1140.8 883.6 L 1140.7 887.2 L 1139.5 892.0 L 1138.0 897.0 L 1146.0 900.0 L 1197.0 899.0 L 1198.2 897.2 L 1199.4 899.0 L 1205.9 888.8 L 1206.0 888.4 L 1204.0 888.0 L 1218.0 834.0 L 1211.0 833.0 Z",
      "position": {
        "x": 1172.9,
        "y": 866.6
      },
      "badgeAnchor": {
        "x": 1172.9,
        "y": 866.6
      },
      "badgeRadius": 32.9,
      "adjacencies": [
        "cobalt-barrens",
        "ghost-steppe",
        "penumbra-n",
        "umber-fields"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "penumbra-ne",
      "name": "Penumbra Northeast",
      "regionId": "penumbra-mesa",
      "shape": "M 1241.0 939.0 L 1239.3 937.5 L 1241.4 936.7 L 1200.5 900.7 L 1201.2 901.7 L 1200.6 903.4 L 1199.0 902.0 L 1180.8 950.5 L 1183.4 952.0 L 1185.7 953.9 L 1187.7 956.3 L 1189.2 958.9 Z",
      "position": {
        "x": 1207.7,
        "y": 931.9
      },
      "badgeAnchor": {
        "x": 1207.7,
        "y": 931.9
      },
      "badgeRadius": 18.6,
      "adjacencies": [
        "penumbra-core",
        "penumbra-e",
        "penumbra-n"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "penumbra-nw",
      "name": "Penumbra Northwest",
      "regionId": "penumbra-mesa",
      "shape": "M 1161.0 954.0 L 1163.0 952.2 L 1165.4 950.8 L 1146.0 900.0 L 1138.0 897.0 L 1135.0 900.0 L 1132.5 907.0 L 1132.5 913.5 L 1129.5 916.5 L 1125.6 916.5 L 1125.5 916.5 L 1125.3 916.7 L 1125.3 916.7 L 1123.5 918.5 L 1123.5 922.5 L 1120.5 925.5 L 1114.0 925.5 L 1108.8 925.5 L 1108.9 927.3 L 1107.0 928.0 L 1105.0 931.0 L 1106.0 938.0 L 1157.8 958.4 L 1159.2 956.1 Z",
      "position": {
        "x": 1139.1,
        "y": 931.8
      },
      "badgeAnchor": {
        "x": 1139.1,
        "y": 931.8
      },
      "badgeRadius": 17.8,
      "adjacencies": [
        "penumbra-core",
        "penumbra-n",
        "penumbra-nw-tower",
        "penumbra-w"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "penumbra-nw-tower",
      "name": "Penumbra Northwest Tower",
      "regionId": "penumbra-nw-tower",
      "shape": "M 1107.5 888.5 L 1103.5 892.5 L 1103.5 894.5 L 1095.5 900.5 L 1095.5 913.5 L 1099.5 917.5 L 1101.5 917.5 L 1107.5 925.5 L 1120.5 925.5 L 1123.5 922.5 L 1123.5 918.5 L 1125.5 916.5 L 1129.5 916.5 L 1132.5 913.5 L 1132.5 900.5 L 1128.5 896.5 L 1126.5 896.5 L 1120.5 888.5 Z",
      "position": {
        "x": 1114,
        "y": 907
      },
      "badgeAnchor": {
        "x": 1114,
        "y": 907
      },
      "badgeRadius": 14.8,
      "badgeShrinksWithDigits": true,
      "adjacencies": [
        "cobalt-barrens",
        "penumbra-nw"
      ],
      "oneWayBorders": [
        "ghost-steppe",
        "glass-plateau",
        "ion-ridge"
      ],
      "borderDice": {
        "cobalt-barrens": {
          "defend": 7
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "penumbra-s",
      "name": "Penumbra South",
      "regionId": "penumbra-mesa",
      "shape": "M 1184.1 980.1 L 1181.2 981.9 L 1178.0 983.2 L 1174.5 983.7 L 1171.0 983.6 L 1167.7 982.8 L 1164.5 981.4 L 1161.7 979.3 L 1159.3 976.7 L 1157.5 973.7 L 1105.0 994.0 L 1102.9 994.8 L 1143.2 1033.0 L 1186.2 1035.0 L 1209.1 1029.8 L 1240.6 995.3 L 1238.5 994.6 L 1240.0 993.0 L 1188.7 974.8 L 1186.7 977.7 Z M 1211.5 1013.5 L 1206.5 1014.5 L 1198.5 1024.5 L 1190.5 1019.5 L 1177.5 1024.5 L 1175.5 1020.5 L 1178.5 1011.5 L 1174.5 1007.5 L 1164.5 1003.5 L 1167.5 1000.5 L 1177.5 997.5 L 1180.5 994.5 L 1181.5 988.5 L 1190.5 989.5 L 1197.5 984.5 L 1204.5 992.5 L 1215.5 991.5 L 1217.5 993.5 L 1208.5 1003.5 Z",
      "position": {
        "x": 1143.1,
        "y": 1002.8
      },
      "badgeAnchor": {
        "x": 1143.1,
        "y": 1002.8
      },
      "badgeRadius": 21.4,
      "adjacencies": [
        "penumbra-core",
        "penumbra-crystal",
        "penumbra-e",
        "penumbra-w"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "penumbra-w",
      "name": "Penumbra West",
      "regionId": "penumbra-mesa",
      "shape": "M 1157.5 973.7 L 1156.5 970.8 L 1155.9 967.6 L 1156.0 964.5 L 1156.6 961.3 L 1157.8 958.4 L 1106.0 938.0 L 1105.0 994.0 Z",
      "position": {
        "x": 1124.8,
        "y": 965.9
      },
      "badgeAnchor": {
        "x": 1124.8,
        "y": 965.9
      },
      "badgeRadius": 19.1,
      "adjacencies": [
        "penumbra-core",
        "penumbra-nw",
        "penumbra-s",
        "penumbra-w-gate"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "penumbra-w-gate",
      "name": "Penumbra West Gate",
      "shape": "M 1098.2 932.7 L 1091.7 933.6 L 1082.6 931.4 L 1073.4 929.1 L 1064.6 926.4 L 1056.0 924.0 L 1046.9 922.1 L 1043.0 923.0 L 1043.0 958.0 L 1044.0 1013.0 L 1092.0 999.0 L 1105.0 994.0 L 1106.0 938.0 L 1105.0 931.0 Z",
      "position": {
        "x": 1074.4,
        "y": 966.3
      },
      "badgeAnchor": {
        "x": 1074.4,
        "y": 966.3
      },
      "badgeRadius": 31.1,
      "adjacencies": [
        "cobalt-barrens",
        "glass-plateau",
        "hollow-basin",
        "penumbra-w"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "quartz-core",
      "name": "Quartz Core",
      "regionId": "quartz-mesa",
      "shape": "M 179.8 514.1 L 178.2 511.4 L 176.1 508.9 L 173.6 507.0 L 170.8 505.5 L 167.5 504.6 L 164.1 504.3 L 160.6 504.7 L 157.4 505.8 L 154.7 507.3 L 152.3 509.3 L 150.4 511.7 L 148.9 514.4 L 147.8 517.6 L 147.4 521.0 L 147.7 524.4 L 148.7 527.7 L 150.2 530.6 L 152.2 533.1 L 154.7 535.2 L 157.6 536.8 L 160.8 537.8 L 164.2 538.2 L 167.7 537.9 L 170.9 536.9 L 173.8 535.4 L 176.3 533.3 L 178.4 530.8 L 180.0 528.0 L 180.9 525.3 L 181.3 522.5 L 181.3 519.6 L 180.8 516.8 Z",
      "position": {
        "x": 164.4,
        "y": 521.3
      },
      "badgeAnchor": {
        "x": 164.4,
        "y": 521.3
      },
      "badgeRadius": 16.8,
      "adjacencies": [
        "quartz-e",
        "quartz-n",
        "quartz-ne",
        "quartz-nw",
        "quartz-s",
        "quartz-se",
        "quartz-sw",
        "quartz-w"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "quartz-e",
      "name": "Quartz East",
      "regionId": "quartz-mesa",
      "shape": "M 233.0 495.0 L 231.3 493.9 L 231.5 493.7 L 231.4 493.6 L 232.7 492.4 L 230.2 490.7 L 228.4 491.5 L 230.0 493.0 L 179.8 514.1 L 180.8 516.8 L 181.3 519.6 L 181.3 522.5 L 180.9 525.3 L 180.0 528.0 L 233.0 550.0 Z",
      "position": {
        "x": 213.6,
        "y": 520.9
      },
      "badgeAnchor": {
        "x": 213.6,
        "y": 520.9
      },
      "badgeRadius": 19.4,
      "adjacencies": [
        "beryl-w",
        "quartz-core",
        "quartz-ne",
        "quartz-se"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "quartz-n",
      "name": "Quartz North",
      "regionId": "quartz-mesa",
      "shape": "M 164.1 504.3 L 167.5 504.6 L 170.8 505.5 L 190.0 457.0 L 191.6 458.4 L 195.5 456.5 L 191.0 456.5 L 190.5 456.5 L 188.5 455.5 L 188.0 453.0 L 187.6 451.0 L 134.1 455.2 L 135.4 458.3 L 137.0 457.0 L 157.4 505.8 L 160.6 504.7 Z",
      "position": {
        "x": 163.8,
        "y": 472.1
      },
      "badgeAnchor": {
        "x": 163.8,
        "y": 472.1
      },
      "badgeRadius": 18.8,
      "adjacencies": [
        "quartz-core",
        "quartz-ne",
        "quartz-nne-tower",
        "quartz-nw"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "quartz-ne",
      "name": "Quartz Northeast",
      "regionId": "quartz-mesa",
      "shape": "M 173.6 507.0 L 176.1 508.9 L 178.2 511.4 L 179.8 514.1 L 230.0 493.0 L 228.4 491.5 L 230.2 490.7 L 231.2 491.4 L 193.5 457.5 L 191.6 458.4 L 190.0 457.0 L 170.8 505.5 Z",
      "position": {
        "x": 198.2,
        "y": 486.6
      },
      "badgeAnchor": {
        "x": 198.2,
        "y": 486.6
      },
      "badgeRadius": 18.2,
      "adjacencies": [
        "quartz-core",
        "quartz-e",
        "quartz-n",
        "quartz-nne-tower"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "quartz-nne-tower",
      "name": "Quartz North-Northeast Tower",
      "regionId": "quartz-nne-tower",
      "shape": "M 191.5 419.5 L 187.5 422.5 L 187.5 425.5 L 179.5 430.5 L 179.5 445.5 L 180.5 447.5 L 185.5 448.5 L 187.5 450.5 L 188.5 455.5 L 190.5 456.5 L 205.5 456.5 L 207.5 454.5 L 207.5 451.5 L 210.5 448.5 L 213.5 448.5 L 216.5 444.5 L 216.5 431.5 L 210.5 427.5 L 204.5 419.5 Z",
      "position": {
        "x": 197.5,
        "y": 438.5
      },
      "badgeAnchor": {
        "x": 197.5,
        "y": 438.5
      },
      "badgeRadius": 15.6,
      "badgeShrinksWithDigits": true,
      "adjacencies": [
        "iron-plateau",
        "quartz-n",
        "quartz-ne"
      ],
      "oneWayBorders": [
        "ion-flats",
        "jade-reach",
        "silica-scarp"
      ],
      "borderDice": {
        "iron-plateau": {
          "defend": 7
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "quartz-nw",
      "name": "Quartz Northwest",
      "regionId": "quartz-mesa",
      "shape": "M 135.4 458.3 L 134.6 456.4 L 98.5 485.8 L 98.5 490.0 L 98.5 492.2 L 148.9 514.4 L 150.4 511.7 L 152.3 509.3 L 154.7 507.3 L 157.4 505.8 L 137.0 457.0 Z",
      "position": {
        "x": 128.7,
        "y": 485.3
      },
      "badgeAnchor": {
        "x": 128.7,
        "y": 485.3
      },
      "badgeRadius": 18.5,
      "adjacencies": [
        "quartz-core",
        "quartz-n",
        "quartz-w",
        "quartz-wnw-tower"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "quartz-s",
      "name": "Quartz South",
      "regionId": "quartz-mesa",
      "shape": "M 188.5 588.5 L 189.7 587.3 L 170.9 536.9 L 167.7 537.9 L 164.2 538.2 L 160.8 537.8 L 157.6 536.8 L 138.0 585.0 L 136.1 584.3 L 135.1 586.7 L 181.1 591.3 L 181.3 591.0 L 182.5 591.3 L 182.5 591.5 L 186.7 591.9 L 188.5 590.5 L 188.5 589.5 Z",
      "position": {
        "x": 163.8,
        "y": 570.8
      },
      "badgeAnchor": {
        "x": 163.8,
        "y": 570.8
      },
      "badgeRadius": 18.5,
      "adjacencies": [
        "quartz-core",
        "quartz-se",
        "quartz-sse-tower",
        "quartz-sw"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "quartz-se",
      "name": "Quartz Southeast",
      "regionId": "quartz-mesa",
      "shape": "M 180.0 528.0 L 178.4 530.8 L 176.3 533.3 L 173.8 535.4 L 170.9 536.9 L 189.7 587.3 L 192.5 584.5 L 199.6 584.5 L 203.3 584.5 L 233.5 553.3 L 233.2 553.0 L 231.1 553.0 L 201.0 584.0 L 233.0 551.0 L 233.0 550.0 Z",
      "position": {
        "x": 200.4,
        "y": 558.3
      },
      "badgeAnchor": {
        "x": 200.4,
        "y": 558.3
      },
      "badgeRadius": 18.3,
      "adjacencies": [
        "quartz-core",
        "quartz-e",
        "quartz-s",
        "quartz-sse-tower"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "quartz-sse-tower",
      "name": "Quartz South-Southeast Tower",
      "regionId": "quartz-sse-tower",
      "shape": "M 192.5 584.5 L 188.5 588.5 L 188.5 590.5 L 180.5 596.5 L 180.5 609.5 L 184.5 613.5 L 186.5 613.5 L 192.5 621.5 L 205.5 621.5 L 209.5 617.5 L 209.5 615.5 L 217.5 609.5 L 217.5 596.5 L 213.5 592.5 L 211.5 592.5 L 205.5 584.5 Z",
      "position": {
        "x": 199,
        "y": 603
      },
      "badgeAnchor": {
        "x": 199,
        "y": 603
      },
      "badgeRadius": 16.3,
      "badgeShrinksWithDigits": true,
      "adjacencies": [
        "ghost-basin",
        "quartz-s",
        "quartz-se"
      ],
      "oneWayBorders": [
        "cinder-steppe",
        "ion-dunes",
        "ozone-fields"
      ],
      "borderDice": {
        "ghost-basin": {
          "defend": 7
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "quartz-sw",
      "name": "Quartz Southwest",
      "regionId": "quartz-mesa",
      "shape": "M 154.7 535.2 L 152.2 533.1 L 150.2 530.6 L 148.7 527.7 L 98.5 547.4 L 98.5 553.2 L 98.5 560.5 L 98.5 560.5 L 98.6 560.8 L 98.8 561.0 L 99.8 561.0 L 101.2 554.4 L 125.8 582.7 L 135.4 586.2 L 136.1 584.3 L 138.0 585.0 L 157.6 536.8 Z",
      "position": {
        "x": 128.8,
        "y": 556.4
      },
      "badgeAnchor": {
        "x": 128.8,
        "y": 556.4
      },
      "badgeRadius": 19.3,
      "adjacencies": [
        "quartz-core",
        "quartz-s",
        "quartz-w",
        "quartz-wsw-tower"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "quartz-w",
      "name": "Quartz West",
      "regionId": "quartz-mesa",
      "shape": "M 95.5 543.5 L 98.5 546.5 L 98.5 547.4 L 148.7 527.7 L 147.7 524.4 L 147.4 521.0 L 147.8 517.6 L 148.9 514.4 L 98.5 492.2 L 98.5 495.5 L 94.0 499.1 L 93.5 499.5 L 92.5 498.5 L 92.0 499.0 L 92.0 542.7 L 92.5 543.5 L 94.3 543.5 Z",
      "position": {
        "x": 112.3,
        "y": 520.3
      },
      "badgeAnchor": {
        "x": 112.3,
        "y": 520.3
      },
      "badgeRadius": 20.1,
      "adjacencies": [
        "quartz-core",
        "quartz-nw",
        "quartz-sw",
        "quartz-wnw-tower",
        "quartz-wsw-tower",
        "west-warp"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "quartz-wnw-tower",
      "name": "Quartz West-Northwest Tower",
      "regionId": "quartz-wnw-tower",
      "shape": "M 75.5 469.5 L 69.5 473.5 L 69.5 476.5 L 67.5 478.5 L 64.5 478.5 L 61.5 481.5 L 61.5 495.5 L 65.5 499.5 L 67.5 499.5 L 72.5 506.5 L 84.5 507.5 L 90.5 503.5 L 90.5 500.5 L 92.5 498.5 L 93.5 499.5 L 98.5 495.5 L 98.5 481.5 L 95.5 478.5 L 93.5 478.5 L 87.5 470.5 Z",
      "position": {
        "x": 80,
        "y": 488.5
      },
      "badgeAnchor": {
        "x": 80,
        "y": 488.5
      },
      "badgeRadius": 15.9,
      "badgeShrinksWithDigits": true,
      "adjacencies": [
        "jade-reach",
        "quartz-nw",
        "quartz-w"
      ],
      "oneWayBorders": [
        "cinder-steppe",
        "glass-waste",
        "ion-flats",
        "iron-plateau"
      ],
      "borderDice": {
        "jade-reach": {
          "defend": 7
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "quartz-wsw-tower",
      "name": "Quartz West-Southwest Tower",
      "regionId": "quartz-wsw-tower",
      "shape": "M 74.5 534.5 L 69.5 538.5 L 67.5 542.5 L 61.5 546.5 L 61.5 560.5 L 67.5 564.5 L 72.5 571.5 L 85.5 572.5 L 90.5 568.5 L 90.5 566.5 L 93.5 563.5 L 95.5 563.5 L 98.5 560.5 L 98.5 546.5 L 95.5 543.5 L 92.5 543.5 L 87.5 535.5 Z",
      "position": {
        "x": 80,
        "y": 553.5
      },
      "badgeAnchor": {
        "x": 80,
        "y": 553.5
      },
      "badgeRadius": 16,
      "badgeShrinksWithDigits": true,
      "adjacencies": [
        "cinder-steppe",
        "quartz-sw",
        "quartz-w"
      ],
      "oneWayBorders": [
        "ghost-basin",
        "ion-dunes",
        "jade-reach",
        "ozone-fields",
        "salt-reach"
      ],
      "borderDice": {
        "cinder-steppe": {
          "defend": 7
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "quiet-drift",
      "name": "Quiet Drift",
      "shape": "M 1072.0 372.0 L 1084.0 355.0 L 1091.0 355.0 L 1097.8 355.2 L 1105.2 356.8 L 1112.7 358.8 L 1119.7 360.8 L 1125.7 362.9 L 1133.0 366.5 L 1140.3 370.1 L 1147.7 373.3 L 1155.0 376.5 L 1162.0 380.0 L 1172.0 381.0 L 1189.0 369.0 L 1207.0 371.0 L 1211.4 366.9 L 1215.2 359.6 L 1216.8 354.8 L 1217.7 347.8 L 1216.0 342.0 L 1212.8 336.6 L 1209.7 331.3 L 1207.6 326.4 L 1205.4 321.6 L 1202.4 312.6 L 1199.4 303.6 L 1196.1 294.9 L 1193.0 286.0 L 1185.5 289.0 L 1178.1 292.1 L 1170.4 295.4 L 1163.0 298.5 L 1155.2 301.7 L 1148.4 302.9 L 1141.6 304.6 L 1134.3 305.8 L 1128.0 306.0 L 1121.0 306.0 L 1115.2 303.3 L 1112.8 301.2 L 1109.2 296.8 L 1106.2 291.8 L 1100.0 285.0 L 1080.0 285.0 L 1074.7 290.2 L 1069.5 294.9 L 1063.3 299.8 L 1057.1 304.6 L 1051.0 309.5 L 1044.9 314.4 L 1039.6 317.6 L 1031.0 320.0 L 1019.0 313.0 L 1013.3 316.3 L 1007.0 320.0 L 1000.9 323.4 L 994.5 325.0 L 988.0 326.0 L 980.8 327.3 L 974.8 329.3 L 969.0 332.0 L 967.2 337.2 L 967.2 340.4 L 969.1 347.9 L 971.7 355.8 L 973.0 365.0 L 970.8 370.2 L 968.0 372.0 L 968.0 377.5 L 968.2 382.3 L 969.8 387.8 L 971.0 393.0 L 998.0 393.0 L 997.0 402.0 L 1001.6 402.9 L 1008.3 402.8 L 1017.8 400.8 L 1023.6 398.6 L 1031.3 394.3 L 1038.4 389.4 L 1046.3 384.9 L 1055.0 381.0 L 1063.7 376.7 Z",
      "position": {
        "x": 1162.7,
        "y": 338.7
      },
      "badgeAnchor": {
        "x": 1095.51,
        "y": 327.22
      },
      "badgeRadius": 37.8,
      "adjacencies": [
        "ashen-dunes",
        "ember-expanse",
        "hollow-reach",
        "mica-scarp",
        "opal-n-gate",
        "rust-shelf",
        "shale-hollows",
        "umber-drift"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "quiet-fields",
      "name": "Quiet Fields",
      "shape": "M 928.0 947.0 L 917.0 956.0 L 894.0 937.0 L 875.0 950.0 L 855.0 945.0 L 835.0 948.0 L 835.0 976.0 L 839.0 981.0 L 848.0 973.0 L 856.2 973.3 L 861.0 976.0 L 866.0 984.0 L 870.5 992.5 L 873.2 998.3 L 876.0 1004.5 L 878.7 1010.8 L 880.8 1017.7 L 881.0 1023.0 L 881.0 1029.0 L 874.0 1031.0 L 865.6 1030.9 L 859.5 1030.0 L 850.4 1030.4 L 844.0 1032.5 L 836.7 1036.2 L 830.0 1043.0 L 832.8 1043.0 L 830.8 1045.0 L 962.0 1045.0 L 962.0 1043.0 L 964.0 1043.0 L 964.0 1037.0 L 957.0 1031.5 L 953.7 1025.3 L 950.0 1020.0 L 952.6 1016.1 L 957.7 1014.2 L 962.8 1012.3 L 966.0 1008.0 L 965.4 1004.1 L 963.0 999.5 L 961.2 994.8 L 961.0 988.0 L 961.0 982.0 L 958.5 978.0 L 956.3 973.2 L 954.3 964.2 L 953.0 955.0 Z",
      "position": {
        "x": 916.8,
        "y": 996.7
      },
      "badgeAnchor": {
        "x": 916.8,
        "y": 996.7
      },
      "badgeRadius": 40.5,
      "adjacencies": [
        "ashen-reach",
        "ember-steppe",
        "glass-plateau",
        "halo-plateau",
        "hollow-basin"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "quiet-hollows",
      "name": "Quiet Hollows",
      "shape": "M 1018.6 711.4 L 1019.9 719.6 L 1019.9 728.4 L 1019.0 735.0 L 1014.2 742.2 L 1008.8 746.8 L 1003.0 752.0 L 1041.0 768.0 L 1005.0 752.9 L 1003.6 754.2 L 1002.4 753.9 L 1041.0 770.2 L 1045.4 768.4 L 1044.1 766.8 L 1046.0 766.0 L 1047.4 760.4 L 1050.4 754.4 L 1054.3 749.3 L 1060.0 745.0 L 1065.3 745.2 L 1071.2 746.3 L 1078.4 748.6 L 1085.9 751.1 L 1093.3 754.2 L 1100.5 758.0 L 1107.8 761.7 L 1113.1 762.9 L 1121.5 763.0 L 1127.9 761.9 L 1133.7 759.2 L 1139.8 756.3 L 1148.0 753.5 L 1156.0 750.5 L 1164.3 747.8 L 1172.8 745.3 L 1182.0 744.0 L 1191.5 743.1 L 1201.0 744.0 L 1200.0 727.0 L 1188.0 716.0 L 1191.0 693.0 L 1187.5 685.0 L 1183.8 679.2 L 1181.0 673.5 L 1179.2 667.3 L 1179.0 658.0 L 1172.0 659.0 L 1165.2 659.2 L 1157.9 660.9 L 1150.7 663.2 L 1143.4 664.8 L 1136.8 663.7 L 1132.0 662.0 L 1095.0 669.0 L 1088.7 665.8 L 1083.3 661.7 L 1078.5 656.0 L 1073.0 650.0 L 1063.0 649.0 L 1044.0 663.0 L 1042.6 667.6 L 1037.7 673.7 L 1033.5 679.5 L 1032.9 687.9 L 1032.0 696.0 L 1017.0 704.0 Z",
      "position": {
        "x": 1120.8,
        "y": 712.6
      },
      "badgeAnchor": {
        "x": 1104.18,
        "y": 708.12
      },
      "badgeRadius": 47.6,
      "adjacencies": [
        "ashen-ridge",
        "ember-basin",
        "ghost-steppe",
        "glass-barrens",
        "halo-barrens",
        "hollow-expanse"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "quiet-plateau",
      "name": "Quiet Plateau",
      "shape": "M 955.0 24.0 L 949.0 29.6 L 946.0 35.0 L 946.6 42.4 L 946.9 49.9 L 945.4 55.4 L 943.0 61.0 L 936.0 65.0 L 928.8 68.3 L 921.4 72.4 L 915.0 77.5 L 909.0 85.0 L 909.1 92.9 L 910.4 99.6 L 913.0 107.5 L 915.7 115.3 L 918.7 122.8 L 921.7 130.3 L 925.7 138.3 L 929.7 146.3 L 933.6 153.9 L 938.5 160.0 L 943.0 163.0 L 949.3 161.3 L 957.3 157.3 L 966.0 153.0 L 971.0 149.5 L 976.4 145.8 L 982.4 143.4 L 989.0 143.0 L 996.4 143.1 L 1005.0 144.5 L 1013.7 145.8 L 1018.9 145.9 L 1026.7 144.2 L 1035.6 140.6 L 1045.4 137.4 L 1051.1 136.1 L 1057.0 135.0 L 1058.0 129.0 L 1057.0 123.0 L 1043.0 124.0 L 1043.0 65.0 L 1034.5 66.0 L 1025.0 66.9 L 1017.5 66.0 L 1010.0 65.0 Z",
      "position": {
        "x": 973.3,
        "y": 97.4
      },
      "badgeAnchor": {
        "x": 973.3,
        "y": 97.4
      },
      "badgeRadius": 46.9,
      "adjacencies": [
        "cinder-basin",
        "cobalt-steppe",
        "corona-w-gate",
        "ion-scarp",
        "mica-fields",
        "ozone-hollows"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "rust-shelf",
      "name": "Rust Shelf",
      "shape": "M 1081.2 397.8 L 1081.0 393.0 L 1080.8 387.7 L 1079.2 381.3 L 1076.2 375.8 L 1072.0 372.0 L 1063.7 376.7 L 1055.0 381.0 L 1046.3 384.9 L 1038.4 389.4 L 1031.3 394.3 L 1023.6 398.6 L 1017.8 400.8 L 1008.3 402.8 L 1001.6 402.9 L 997.0 402.0 L 985.0 444.0 L 1022.0 478.0 L 986.8 445.6 L 986.4 448.0 L 1021.9 480.6 L 1050.1 459.9 L 1050.1 459.5 L 1048.5 459.5 L 1048.0 458.8 L 1048.0 458.8 L 1042.5 451.5 L 1040.5 451.5 L 1036.5 447.5 L 1036.5 434.5 L 1044.5 428.5 L 1044.5 426.5 L 1048.5 422.5 L 1061.5 422.5 L 1067.5 430.5 L 1069.5 430.5 L 1073.5 434.5 L 1073.5 447.5 L 1071.5 449.0 L 1071.5 452.3 L 1078.9 445.0 L 1106.0 444.0 L 1104.0 443.9 L 1104.0 442.1 L 1106.0 442.0 L 1106.0 420.0 L 1084.0 407.0 Z",
      "position": {
        "x": 1012.3,
        "y": 437.6
      },
      "badgeAnchor": {
        "x": 1017.03,
        "y": 428.59
      },
      "badgeRadius": 23.2,
      "adjacencies": [
        "hollow-reach",
        "jasper-nnw-tower",
        "mica-scarp",
        "opal-n-gate",
        "quiet-drift"
      ],
      "borderDice": {
        "jasper-nnw-tower": {
          "attack": 5
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "rust-steppe",
      "name": "Rust Steppe",
      "shape": "M 729.7 167.3 L 734.0 173.0 L 734.9 179.9 L 733.0 189.0 L 741.4 192.6 L 747.3 194.2 L 752.8 195.7 L 759.6 196.9 L 765.5 197.0 L 771.3 197.2 L 775.0 199.0 L 773.8 200.6 L 775.4 201.4 L 780.6 196.3 L 788.0 193.8 L 795.6 191.3 L 802.1 188.6 L 808.5 186.1 L 814.7 183.5 L 820.1 182.2 L 827.1 177.7 L 833.3 174.0 L 834.5 174.0 L 833.6 173.5 L 832.6 172.0 L 832.7 171.9 L 835.0 172.0 L 827.0 160.0 L 830.0 141.0 L 827.6 137.9 L 824.0 136.0 L 811.0 134.0 L 807.4 127.1 L 804.0 124.0 L 796.5 123.1 L 791.0 124.0 L 784.5 124.0 L 777.7 123.8 L 768.1 121.9 L 758.6 119.9 L 749.0 117.0 L 739.0 115.0 L 738.0 122.0 L 724.0 130.0 L 740.0 140.0 L 740.0 144.0 L 723.0 162.0 Z",
      "position": {
        "x": 773.6,
        "y": 160.2
      },
      "badgeAnchor": {
        "x": 773.6,
        "y": 160.2
      },
      "badgeRadius": 36.4,
      "adjacencies": [
        "ember-reach",
        "mica-fields",
        "sable-scarp",
        "shale-drift",
        "slate-dunes",
        "zenith-se-gate"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "rust-waste",
      "name": "Rust Waste",
      "shape": "M 612.5 888.5 L 612.5 875.5 L 618.5 871.5 L 620.5 867.5 L 625.5 863.5 L 637.4 864.4 L 637.7 863.5 L 636.8 859.2 L 634.4 851.6 L 631.5 844.0 L 629.7 836.8 L 627.7 828.8 L 623.1 821.9 L 618.3 818.2 L 610.9 814.6 L 601.7 812.8 L 592.2 810.8 L 583.0 807.5 L 577.5 804.0 L 571.9 800.6 L 566.0 797.0 L 557.7 797.2 L 550.8 799.3 L 545.4 802.4 L 540.8 805.8 L 535.6 811.1 L 530.5 819.0 L 528.3 825.8 L 528.0 834.5 L 528.0 843.0 L 527.0 849.0 L 518.0 857.0 L 516.2 864.7 L 516.0 873.0 L 518.6 876.9 L 522.3 880.7 L 528.0 883.0 L 574.0 841.0 L 578.7 849.3 L 583.5 858.0 L 588.3 866.7 L 593.2 875.3 L 598.0 884.0 L 603.2 887.8 L 609.0 892.0 L 610.0 892.0 Z",
      "position": {
        "x": 603.8,
        "y": 840.8
      },
      "badgeAnchor": {
        "x": 588.86,
        "y": 831.41
      },
      "badgeRadius": 26.1,
      "adjacencies": [
        "mica-flats",
        "nadir-n-tower",
        "nadir-nw-gate",
        "sable-dunes",
        "slate-reach"
      ],
      "borderDice": {
        "nadir-n-tower": {
          "attack": 5
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "sable-dunes",
      "name": "Sable Dunes",
      "shape": "M 574.8 778.2 L 569.5 773.0 L 566.0 768.0 L 566.1 759.1 L 567.9 749.4 L 567.7 743.8 L 565.6 735.4 L 562.5 729.0 L 558.2 722.8 L 556.0 721.0 L 549.0 720.0 L 540.4 720.4 L 531.1 723.1 L 522.0 726.5 L 512.7 729.7 L 503.8 733.2 L 494.8 735.8 L 486.0 736.0 L 477.5 736.0 L 472.0 735.0 L 463.0 742.0 L 461.6 749.6 L 460.1 757.1 L 459.1 764.1 L 459.0 771.5 L 459.0 778.0 L 457.8 787.3 L 455.9 796.9 L 454.1 806.1 L 452.0 815.0 L 480.0 850.0 L 483.1 851.0 L 489.5 851.0 L 495.8 851.2 L 503.6 852.9 L 511.0 855.0 L 518.0 857.0 L 527.0 849.0 L 528.0 843.0 L 528.0 834.5 L 528.3 825.8 L 530.5 819.0 L 535.6 811.1 L 540.8 805.8 L 545.4 802.4 L 550.8 799.3 L 557.7 797.2 L 566.0 797.0 L 580.0 783.0 Z",
      "position": {
        "x": 503.9,
        "y": 779.7
      },
      "badgeAnchor": {
        "x": 503.9,
        "y": 779.7
      },
      "badgeRadius": 44.6,
      "adjacencies": [
        "basalt-shelf",
        "frost-barrens",
        "mica-flats",
        "rust-waste",
        "silica-flats",
        "slate-reach"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "sable-flats",
      "name": "Sable Flats",
      "shape": "M 859.3 443.8 L 854.0 450.0 L 864.0 467.0 L 855.1 451.8 L 854.2 452.8 L 852.5 451.3 L 862.9 469.0 L 863.4 469.0 L 863.5 467.5 L 864.2 467.0 L 870.5 462.5 L 874.5 456.5 L 888.5 456.5 L 894.5 464.5 L 896.5 464.5 L 899.0 467.0 L 921.0 444.0 L 910.0 405.0 L 904.0 406.0 L 898.5 401.5 L 893.5 406.5 L 896.5 416.5 L 887.5 417.5 L 882.5 426.5 L 873.5 418.5 L 863.5 419.5 L 864.1 415.0 L 853.0 415.0 L 860.0 439.0 Z",
      "position": {
        "x": 898.4,
        "y": 438.7
      },
      "badgeAnchor": {
        "x": 898.4,
        "y": 438.7
      },
      "badgeRadius": 20,
      "adjacencies": [
        "aster-crystal",
        "frost-waste",
        "opal-n-gate",
        "shale-hollows",
        "topaz-ene-tower"
      ],
      "borderDice": {
        "topaz-ene-tower": {
          "attack": 5
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "sable-scarp",
      "name": "Sable Scarp",
      "shape": "M 614.2 190.8 L 617.6 197.4 L 619.5 206.0 L 621.9 214.6 L 624.3 219.7 L 627.4 224.6 L 634.0 232.0 L 643.2 234.8 L 651.6 235.4 L 660.1 236.9 L 667.7 240.3 L 675.0 244.4 L 683.0 248.0 L 691.5 248.9 L 699.0 248.0 L 703.7 245.2 L 708.2 242.2 L 713.2 237.2 L 718.0 232.4 L 722.8 225.3 L 724.9 218.9 L 725.0 210.0 L 725.3 201.8 L 729.2 193.7 L 733.0 189.0 L 734.9 179.9 L 734.0 173.0 L 729.7 167.3 L 723.0 162.0 L 678.0 204.0 L 651.0 161.0 L 650.4 159.1 L 638.6 160.8 L 637.3 154.4 L 634.5 154.7 L 634.5 156.5 L 636.5 158.5 L 636.5 160.5 L 636.5 172.5 L 628.5 177.5 L 628.5 180.5 L 625.5 183.5 L 611.5 183.5 L 610.8 183.0 L 610.6 184.9 Z",
      "position": {
        "x": 647.8,
        "y": 206.3
      },
      "badgeAnchor": {
        "x": 658.83,
        "y": 213.4
      },
      "badgeRadius": 26.8,
      "adjacencies": [
        "rust-steppe",
        "slate-dunes",
        "vapor-ridge",
        "zenith-s-tower",
        "zenith-se-gate"
      ],
      "borderDice": {
        "zenith-s-tower": {
          "attack": 5
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "salt-dunes",
      "name": "Salt Dunes",
      "shape": "M 153.9 198.1 L 156.8 201.2 L 163.8 207.2 L 171.0 212.0 L 202.0 210.0 L 203.8 214.7 L 204.0 223.0 L 206.0 222.8 L 206.0 223.9 L 204.8 224.9 L 208.5 224.6 L 215.7 222.4 L 222.3 220.2 L 230.0 218.6 L 237.8 216.9 L 245.4 215.5 L 252.8 214.1 L 260.7 214.1 L 266.1 215.0 L 270.9 215.9 L 279.9 216.5 L 288.0 217.1 L 292.3 218.4 L 300.6 218.0 L 308.6 217.9 L 315.7 216.9 L 321.6 216.0 L 331.0 216.8 L 340.7 217.8 L 343.9 217.1 L 342.0 216.5 L 342.0 215.5 L 344.0 215.0 L 344.2 209.7 L 345.4 203.9 L 348.0 199.5 L 351.1 194.7 L 353.5 189.0 L 353.9 180.6 L 352.3 173.7 L 348.6 167.4 L 344.5 164.0 L 340.0 161.0 L 328.0 162.0 L 323.4 167.4 L 319.4 173.9 L 315.4 180.9 L 310.5 188.0 L 305.2 195.2 L 301.4 198.9 L 297.0 202.0 L 288.0 201.0 L 283.2 193.8 L 277.0 190.0 L 271.2 190.2 L 262.9 192.9 L 255.0 192.0 L 251.5 187.5 L 250.0 183.0 L 242.1 180.4 L 234.4 176.6 L 228.4 170.6 L 222.5 164.0 L 216.2 157.8 L 208.0 152.5 L 199.3 147.2 L 195.0 146.0 L 193.2 152.7 L 191.9 159.4 L 190.0 166.5 L 187.3 173.3 L 184.0 180.0 L 177.9 185.4 L 170.3 189.8 L 161.8 192.8 L 153.0 195.0 Z",
      "position": {
        "x": 209.1,
        "y": 186.3
      },
      "badgeAnchor": {
        "x": 209.1,
        "y": 186.3
      },
      "badgeRadius": 24.7,
      "adjacencies": [
        "argent-reach",
        "dust-waste",
        "iron-barrens",
        "silica-fields"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "salt-reach",
      "name": "Salt Reach",
      "shape": "M 116.2 803.2 L 123.0 803.0 L 132.4 803.1 L 138.0 804.0 L 139.8 801.8 L 145.0 798.5 L 151.0 792.0 L 151.9 786.5 L 151.0 781.0 L 151.2 772.2 L 153.2 767.2 L 156.0 762.0 L 141.0 752.0 L 135.0 736.0 L 125.4 737.4 L 116.9 740.9 L 108.3 744.3 L 99.2 747.7 L 92.1 750.1 L 84.6 752.6 L 79.6 753.6 L 74.3 754.8 L 67.0 755.0 L 61.8 751.2 L 58.2 746.3 L 55.7 741.3 L 53.4 735.6 L 51.6 729.4 L 49.3 722.7 L 46.7 716.3 L 43.3 711.2 L 39.0 708.0 L 31.1 711.1 L 23.5 714.0 L 16.0 716.5 L 8.0 718.5 L 0.0 720.0 L 0.0 722.0 L -2.0 722.4 L -2.0 819.4 L 0.0 818.9 L 0.0 821.0 L 8.0 819.0 L 12.2 810.7 L 16.0 805.5 L 20.7 802.7 L 26.7 801.2 L 35.9 801.1 L 41.5 802.0 L 47.0 803.0 L 54.5 803.0 L 62.4 802.9 L 70.4 801.4 L 78.5 799.0 L 87.0 797.2 L 92.4 798.1 L 98.0 799.5 L 106.6 802.4 L 109.0 804.0 Z",
      "position": {
        "x": 31.8,
        "y": 767.1
      },
      "badgeAnchor": {
        "x": 31.8,
        "y": 767.1
      },
      "badgeRadius": 33.6,
      "adjacencies": [
        "chrome-ridge",
        "cinder-steppe",
        "dust-plateau",
        "ion-dunes",
        "iron-drift"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "salt-ridge",
      "name": "Salt Ridge",
      "shape": "M 355.5 464.5 L 358.5 464.5 L 361.5 458.5 L 365.5 455.5 L 377.5 455.5 L 385.5 464.5 L 388.5 466.0 L 389.5 466.5 L 389.5 468.0 L 389.9 468.0 L 407.9 446.0 L 406.0 446.0 L 405.7 445.6 L 389.0 466.0 L 407.0 444.0 L 385.4 416.6 L 379.5 423.5 L 370.5 418.5 L 361.5 420.5 L 361.5 411.5 L 349.5 404.5 L 349.7 404.3 L 343.0 405.0 L 333.0 441.0 L 354.0 466.0 Z",
      "position": {
        "x": 356.2,
        "y": 438.7
      },
      "badgeAnchor": {
        "x": 363.77,
        "y": 440.6
      },
      "badgeRadius": 19,
      "adjacencies": [
        "beryl-ene-tower",
        "beryl-n-gate",
        "dust-barrens",
        "lumen-crystal",
        "silica-scarp"
      ],
      "borderDice": {
        "beryl-ene-tower": {
          "attack": 5
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "shale-drift",
      "name": "Shale Drift",
      "shape": "M 710.8 0.0 L 709.8 -2.0 L 646.2 -2.0 L 695.0 47.8 L 695.0 113.2 L 697.0 114.0 L 700.5 118.0 L 706.7 121.8 L 713.7 125.3 L 720.0 129.0 L 724.0 130.0 L 738.0 122.0 L 739.0 115.0 L 738.8 107.7 L 737.3 99.2 L 735.6 91.4 L 733.4 84.6 L 731.0 78.5 L 728.6 72.4 L 725.3 65.2 L 722.4 58.6 L 720.3 51.2 L 720.0 41.5 L 721.0 32.0 L 720.8 22.7 L 719.4 15.1 L 716.5 7.0 L 713.0 0.0 Z",
      "position": {
        "x": 699.1,
        "y": 21.6
      },
      "badgeAnchor": {
        "x": 699.1,
        "y": 21.6
      },
      "badgeRadius": 21.2,
      "adjacencies": [
        "ember-reach",
        "rust-steppe",
        "zenith-se-gate"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "shale-fields",
      "name": "Shale Fields",
      "shape": "M 832.0 707.0 L 832.5 712.0 L 830.5 718.0 L 828.1 723.1 L 827.0 728.0 L 834.5 728.0 L 829.1 728.0 L 828.7 729.4 L 827.5 730.0 L 834.6 730.0 L 842.6 729.0 L 850.1 729.2 L 856.9 730.9 L 862.5 733.1 L 868.5 735.4 L 877.4 736.9 L 885.5 737.0 L 901.0 737.0 L 909.7 737.0 L 915.1 736.0 L 912.7 735.7 L 912.9 734.4 L 915.0 734.0 L 916.1 727.1 L 917.0 720.0 L 916.0 712.0 L 915.0 703.0 L 859.0 682.0 Z",
      "position": {
        "x": 870.7,
        "y": 711.3
      },
      "badgeAnchor": {
        "x": 870.7,
        "y": 711.3
      },
      "badgeRadius": 23.3,
      "adjacencies": [
        "ember-basin",
        "halo-barrens",
        "ochre-plateau",
        "pale-steppe"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "shale-hollows",
      "name": "Shale Hollows",
      "shape": "M 904.0 406.0 L 910.0 405.0 L 909.1 396.6 L 911.0 393.0 L 971.0 393.0 L 969.8 387.8 L 968.2 382.3 L 968.0 377.5 L 968.0 372.0 L 960.6 367.4 L 953.3 362.2 L 946.0 357.0 L 937.3 352.7 L 931.3 351.2 L 921.8 351.3 L 915.4 353.4 L 908.8 356.2 L 902.0 358.5 L 896.8 359.8 L 891.3 360.8 L 885.5 361.0 L 879.6 360.9 L 873.8 359.7 L 869.1 357.4 L 865.6 353.9 L 863.3 348.2 L 861.8 342.2 L 859.0 338.0 L 842.0 336.0 L 838.0 330.0 L 837.0 325.0 L 832.9 321.6 L 828.7 319.3 L 820.9 315.6 L 817.0 315.0 L 815.5 320.0 L 814.2 324.7 L 814.4 332.6 L 814.9 339.9 L 813.3 349.8 L 811.0 359.0 L 805.0 365.0 L 793.0 367.0 L 786.0 375.0 L 784.4 383.4 L 783.1 391.6 L 783.0 401.5 L 783.0 411.0 L 800.0 412.0 L 800.9 415.5 L 800.3 421.7 L 803.0 425.0 L 809.5 425.0 L 816.0 424.5 L 823.0 421.5 L 831.5 416.5 L 835.8 415.3 L 844.0 415.0 L 853.0 415.0 L 864.1 415.0 L 864.5 412.5 L 860.5 408.5 L 847.5 402.5 L 849.5 400.5 L 861.5 397.5 L 864.5 394.5 L 860.5 382.5 L 863.5 378.5 L 877.5 388.5 L 887.5 376.5 L 890.5 379.5 L 890.5 391.5 L 895.5 395.5 L 902.5 397.5 L 898.5 401.5 Z",
      "position": {
        "x": 821.2,
        "y": 389.2
      },
      "badgeAnchor": {
        "x": 821.2,
        "y": 389.2
      },
      "badgeRadius": 29.1,
      "adjacencies": [
        "aster-crystal",
        "ember-expanse",
        "frost-waste",
        "halo-waste",
        "opal-n-gate",
        "pale-basin",
        "quiet-drift",
        "sable-flats"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "shale-scarp",
      "name": "Shale Scarp",
      "shape": "M 702.5 1017.0 L 708.6 1016.1 L 714.3 1016.2 L 719.8 1018.2 L 724.6 1019.9 L 734.0 1019.0 L 740.3 1015.3 L 745.9 1011.4 L 752.0 1005.5 L 755.3 1001.3 L 758.2 997.2 L 760.0 992.0 L 757.6 987.4 L 755.0 982.5 L 749.0 977.0 L 743.0 971.0 L 742.0 951.0 L 730.0 940.0 L 728.0 923.0 L 711.0 933.0 L 711.0 935.3 L 709.0 936.4 L 709.0 1001.3 L 697.7 1014.5 L 698.7 1013.8 L 700.4 1014.3 L 711.0 1002.0 L 699.0 1016.0 Z",
      "position": {
        "x": 731.9,
        "y": 992.7
      },
      "badgeAnchor": {
        "x": 731.9,
        "y": 992.7
      },
      "badgeRadius": 22.9,
      "adjacencies": [
        "ember-steppe",
        "halo-plateau",
        "nadir-ne-gate"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "silica-dunes",
      "name": "Silica Dunes",
      "shape": "M 334.8 1038.4 L 334.0 1034.0 L 328.6 1032.4 L 323.3 1031.2 L 313.3 1030.2 L 304.0 1030.0 L 296.0 1021.0 L 290.0 1017.5 L 283.8 1014.2 L 278.1 1010.4 L 271.2 1004.8 L 264.6 1000.0 L 259.2 994.8 L 253.8 990.2 L 248.7 985.3 L 244.0 982.0 L 238.4 981.1 L 233.0 981.0 L 226.4 981.9 L 220.2 982.4 L 213.9 981.1 L 208.0 980.0 L 208.0 1012.0 L 158.0 1000.0 L 155.9 999.2 L 109.1 1045.0 L 330.1 1045.0 L 330.9 1043.0 L 333.0 1043.0 Z",
      "position": {
        "x": 237.7,
        "y": 1015.3
      },
      "badgeAnchor": {
        "x": 237.7,
        "y": 1015.3
      },
      "badgeRadius": 29.6,
      "adjacencies": [
        "basalt-waste",
        "umbra-e-gate",
        "vapor-expanse"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "silica-fields",
      "name": "Silica Fields",
      "shape": "M 208.0 93.0 L 208.0 125.0 L 196.0 124.0 L 195.0 146.0 L 199.3 147.2 L 208.0 152.5 L 216.2 157.8 L 222.5 164.0 L 228.4 170.6 L 234.4 176.6 L 242.1 180.4 L 250.0 183.0 L 286.0 147.0 L 279.0 131.0 L 297.0 112.0 L 299.0 96.0 L 295.9 89.7 L 293.1 82.9 L 291.0 75.0 L 289.0 67.0 L 286.6 68.6 L 283.2 72.2 L 279.4 76.0 L 271.7 81.7 L 263.9 87.4 L 259.1 90.6 L 254.3 93.8 L 249.3 96.3 L 244.0 99.0 Z",
      "position": {
        "x": 243.4,
        "y": 134.8
      },
      "badgeAnchor": {
        "x": 243.4,
        "y": 134.8
      },
      "badgeRadius": 35.5,
      "adjacencies": [
        "ashen-flats",
        "basalt-basin",
        "dust-waste",
        "halcyon-e-gate",
        "iron-barrens",
        "salt-dunes"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "silica-flats",
      "name": "Silica Flats",
      "shape": "M 464.0 678.0 L 461.4 680.9 L 457.0 684.0 L 445.0 684.0 L 440.3 687.3 L 436.0 692.0 L 434.3 697.8 L 433.1 703.6 L 433.0 711.0 L 434.0 717.5 L 433.8 724.3 L 431.0 732.0 L 463.0 742.0 L 472.0 735.0 L 477.5 736.0 L 486.0 736.0 L 494.8 735.8 L 503.8 733.2 L 512.7 729.7 L 522.0 726.5 L 531.1 723.1 L 540.4 720.4 L 549.0 720.0 L 556.0 721.0 L 556.0 714.0 L 561.0 708.0 L 556.7 705.3 L 559.3 706.9 L 560.4 705.6 L 561.9 706.2 L 557.7 703.6 L 553.4 700.8 L 549.8 697.0 L 547.8 689.6 L 546.1 682.0 L 547.5 675.6 L 549.8 668.9 L 552.7 664.7 L 557.5 661.4 L 562.8 657.5 L 567.9 652.5 L 573.8 647.0 L 575.0 641.2 L 574.8 641.3 L 573.0 641.0 L 565.0 627.0 L 537.0 622.0 L 518.0 625.0 L 508.0 638.0 L 501.6 637.4 L 495.0 636.5 L 488.0 636.0 L 481.6 637.1 L 474.8 638.8 L 468.0 640.0 Z",
      "position": {
        "x": 504.8,
        "y": 686.6
      },
      "badgeAnchor": {
        "x": 504.8,
        "y": 686.6
      },
      "badgeRadius": 41.6,
      "adjacencies": [
        "argent-expanse",
        "basalt-shelf",
        "flint-drift",
        "frost-barrens",
        "sable-dunes",
        "vapor-reach"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "silica-scarp",
      "name": "Silica Scarp",
      "shape": "M 345.0 391.0 L 343.0 405.0 L 349.7 404.3 L 359.5 395.5 L 353.5 380.5 L 356.5 377.5 L 370.5 386.5 L 380.5 373.5 L 383.5 376.5 L 384.5 389.5 L 391.5 394.5 L 386.5 402.5 L 390.3 405.5 L 392.7 401.7 L 396.0 397.0 L 399.0 389.0 L 398.8 383.7 L 397.6 379.4 L 392.2 371.3 L 390.6 367.4 L 391.0 362.0 L 382.3 359.2 L 373.8 356.8 L 365.5 354.0 L 357.0 351.0 L 348.9 348.1 L 340.6 345.4 L 333.8 343.7 L 327.8 342.2 L 320.2 341.3 L 313.0 340.0 L 307.7 340.2 L 303.0 342.0 L 292.0 355.0 L 285.5 355.0 L 278.4 354.6 L 271.0 352.0 L 263.6 348.4 L 258.8 346.8 L 253.8 345.2 L 245.0 345.0 L 236.0 345.0 L 230.2 347.2 L 224.7 348.7 L 220.0 352.0 L 218.2 359.2 L 217.4 365.9 L 214.2 371.7 L 210.5 377.0 L 207.7 382.7 L 207.0 386.0 L 210.7 393.3 L 214.3 400.7 L 217.6 408.4 L 219.4 415.6 L 220.8 423.2 L 222.0 431.0 L 226.0 434.0 L 233.0 438.0 L 240.4 441.6 L 249.8 444.7 L 254.6 445.4 L 260.0 446.0 L 263.8 444.7 L 261.1 447.7 L 268.1 445.4 L 267.1 443.7 L 267.1 443.6 L 269.0 443.0 L 257.0 391.0 Z",
      "position": {
        "x": 244.1,
        "y": 369.9
      },
      "badgeAnchor": {
        "x": 308.16,
        "y": 368.37
      },
      "badgeRadius": 24.7,
      "adjacencies": [
        "basalt-steppe",
        "beryl-n-gate",
        "cobalt-shelf",
        "dust-barrens",
        "ion-flats",
        "iron-plateau",
        "lumen-crystal",
        "salt-ridge"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "slate-dunes",
      "name": "Slate Dunes",
      "shape": "M 789.1 299.4 L 789.1 292.1 L 790.5 287.0 L 791.8 281.8 L 792.9 272.5 L 792.0 266.0 L 792.0 260.0 L 792.1 253.1 L 793.0 246.5 L 794.2 239.2 L 798.0 231.0 L 796.3 229.9 L 796.7 229.0 L 798.6 229.0 L 795.1 226.7 L 788.9 219.6 L 782.0 213.0 L 779.2 211.5 L 776.3 211.2 L 774.0 209.1 L 774.2 203.4 L 776.5 200.3 L 775.4 201.4 L 773.8 200.6 L 775.0 199.0 L 771.3 197.2 L 765.5 197.0 L 759.6 196.9 L 752.8 195.7 L 747.3 194.2 L 741.4 192.6 L 733.0 189.0 L 729.2 193.7 L 725.3 201.8 L 725.0 210.0 L 724.9 218.9 L 722.8 225.3 L 718.0 232.4 L 713.2 237.2 L 708.2 242.2 L 703.7 245.2 L 699.0 248.0 L 691.5 248.9 L 683.0 248.0 L 672.0 259.0 L 675.8 262.2 L 680.0 265.6 L 685.0 274.0 L 683.0 305.0 L 687.0 312.0 L 691.8 319.2 L 694.8 322.2 L 698.0 324.0 L 702.6 324.9 L 709.2 324.7 L 716.2 322.7 L 722.0 320.4 L 727.2 318.2 L 735.2 316.2 L 743.4 314.4 L 751.1 313.1 L 756.5 313.0 L 761.4 313.1 L 769.3 314.2 L 777.0 315.0 L 783.2 312.2 L 790.0 305.0 Z",
      "position": {
        "x": 746.6,
        "y": 267.8
      },
      "badgeAnchor": {
        "x": 737.23,
        "y": 265.1
      },
      "badgeRadius": 45.2,
      "adjacencies": [
        "halo-waste",
        "ochre-barrens",
        "pale-basin",
        "rust-steppe",
        "sable-scarp",
        "vapor-ridge"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "slate-reach",
      "name": "Slate Reach",
      "shape": "M 424.0 885.0 L 422.0 905.0 L 428.0 912.0 L 440.0 913.0 L 443.0 922.0 L 446.5 924.5 L 450.2 925.8 L 457.5 926.0 L 464.5 926.0 L 471.3 926.2 L 479.8 927.7 L 488.0 929.5 L 495.8 931.7 L 504.0 933.5 L 512.0 935.0 L 514.0 929.5 L 516.6 924.1 L 520.3 920.3 L 526.0 916.0 L 512.0 901.0 L 528.0 883.0 L 522.3 880.7 L 518.6 876.9 L 516.0 873.0 L 516.2 864.7 L 518.0 857.0 L 511.0 855.0 L 503.6 852.9 L 495.8 851.2 L 489.5 851.0 L 483.1 851.0 L 480.0 850.0 L 476.2 850.2 L 477.6 850.2 L 476.0 848.2 L 475.9 848.3 L 471.2 849.8 L 465.9 849.4 L 461.1 850.2 L 453.5 853.5 L 448.1 854.1 L 441.4 860.2 L 437.8 861.6 L 433.5 861.6 L 428.0 864.4 L 421.7 866.3 L 415.8 875.2 L 417.7 874.8 L 418.1 875.3 L 417.0 877.0 Z",
      "position": {
        "x": 472.7,
        "y": 888.2
      },
      "badgeAnchor": {
        "x": 472.7,
        "y": 888.2
      },
      "badgeRadius": 38,
      "adjacencies": [
        "nadir-nw-gate",
        "ochre-drift",
        "pale-shelf",
        "rust-waste",
        "sable-dunes",
        "static-flats"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "slate-ridge",
      "name": "Slate Ridge",
      "shape": "M 919.6 600.4 L 920.6 598.6 L 899.9 576.0 L 899.6 576.0 L 899.5 577.5 L 898.8 578.0 L 892.5 582.5 L 888.5 588.5 L 874.5 588.5 L 868.5 580.5 L 866.5 580.5 L 865.0 579.0 L 846.0 602.0 L 854.8 631.3 L 858.5 629.5 L 861.5 630.5 L 865.5 626.5 L 866.5 619.5 L 876.5 622.5 L 884.5 616.5 L 889.5 625.5 L 904.5 623.5 L 907.5 626.5 L 902.1 631.0 L 912.0 634.0 L 921.0 602.0 Z",
      "position": {
        "x": 899.8,
        "y": 604.6
      },
      "badgeAnchor": {
        "x": 882.69,
        "y": 601.8
      },
      "badgeRadius": 19.4,
      "adjacencies": [
        "halo-barrens",
        "nova-crystal",
        "ochre-plateau",
        "opal-s-gate",
        "topaz-ese-tower"
      ],
      "borderDice": {
        "topaz-ese-tower": {
          "attack": 5
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "static-fields",
      "name": "Static Fields",
      "shape": "M 518.2 408.2 L 527.2 405.2 L 532.5 404.0 L 537.1 403.1 L 545.5 404.0 L 553.5 404.0 L 561.5 404.0 L 569.5 404.0 L 577.0 404.0 L 583.1 403.1 L 589.0 402.0 L 588.3 400.1 L 589.7 399.8 L 590.7 400.9 L 587.6 392.8 L 586.7 388.0 L 587.0 381.6 L 587.1 375.8 L 587.9 372.7 L 586.9 374.5 L 585.5 373.9 L 585.1 375.6 L 586.0 372.0 L 581.7 370.3 L 576.8 367.2 L 572.8 363.2 L 569.0 359.0 L 567.6 354.4 L 566.2 349.3 L 566.0 343.0 L 566.1 336.6 L 567.5 329.0 L 569.2 321.2 L 571.7 313.7 L 575.4 306.4 L 580.2 300.7 L 584.3 297.3 L 588.7 294.2 L 597.8 290.8 L 600.0 289.0 L 599.1 286.9 L 595.0 283.5 L 591.0 279.5 L 588.0 275.6 L 584.0 271.4 L 581.0 267.5 L 578.2 263.3 L 575.4 256.6 L 573.0 249.5 L 570.6 239.9 L 569.0 237.0 L 561.0 249.0 L 548.0 254.0 L 545.0 267.0 L 537.0 270.0 L 535.9 271.9 L 530.0 276.5 L 526.2 280.2 L 522.3 284.3 L 519.0 289.0 L 516.0 294.0 L 514.0 303.5 L 514.2 312.3 L 515.7 318.8 L 516.9 325.5 L 515.0 335.0 L 508.5 337.0 L 501.4 338.4 L 496.1 341.6 L 490.2 347.2 L 484.2 353.2 L 479.0 359.5 L 473.0 365.5 L 466.6 370.6 L 462.1 373.6 L 457.1 376.6 L 455.0 379.0 L 459.2 382.8 L 464.0 386.5 L 469.0 391.5 L 474.0 396.5 L 479.3 401.7 L 486.7 406.8 L 491.8 408.7 L 497.2 409.8 L 505.9 410.1 L 509.0 411.0 Z",
      "position": {
        "x": 532.2,
        "y": 367.1
      },
      "badgeAnchor": {
        "x": 532.2,
        "y": 367.1
      },
      "badgeRadius": 36.3,
      "adjacencies": [
        "chrome-dunes",
        "dust-barrens",
        "flint-plateau",
        "frost-shelf",
        "ochre-barrens",
        "vapor-ridge"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "static-flats",
      "name": "Static Flats",
      "shape": "M 418.0 924.0 L 427.0 937.0 L 405.0 959.0 L 405.0 963.0 L 408.6 970.0 L 412.2 977.3 L 416.1 984.5 L 422.8 991.2 L 428.0 994.5 L 433.7 998.3 L 437.5 1002.0 L 441.0 1006.0 L 442.0 1012.0 L 442.0 1017.0 L 441.9 1022.4 L 440.0 1030.0 L 438.2 1038.2 L 438.0 1043.0 L 440.0 1043.0 L 439.9 1045.0 L 534.6 1045.0 L 533.9 1043.0 L 536.0 1043.0 L 532.9 1034.1 L 530.2 1025.3 L 530.0 1017.0 L 530.0 1009.0 L 530.0 1001.0 L 528.7 993.8 L 526.9 987.1 L 524.9 981.1 L 521.9 973.1 L 518.9 965.6 L 516.0 957.5 L 513.5 950.0 L 512.3 942.2 L 512.0 935.0 L 504.0 933.5 L 495.8 931.7 L 488.0 929.5 L 479.8 927.7 L 471.3 926.2 L 464.5 926.0 L 457.5 926.0 L 450.2 925.8 L 446.5 924.5 L 443.0 922.0 L 440.0 913.0 L 428.0 912.0 Z",
      "position": {
        "x": 473.2,
        "y": 973.7
      },
      "badgeAnchor": {
        "x": 473.2,
        "y": 973.7
      },
      "badgeRadius": 45.5,
      "adjacencies": [
        "basalt-waste",
        "ochre-drift",
        "pale-shelf",
        "slate-reach"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "static-hollows",
      "name": "Static Hollows",
      "shape": "M 523.0 124.0 L 521.0 109.0 L 510.0 98.0 L 508.2 91.8 L 507.8 82.7 L 506.4 78.0 L 503.9 73.5 L 499.8 69.2 L 496.2 65.3 L 493.0 56.0 L 490.0 57.5 L 484.2 63.2 L 478.9 68.4 L 474.3 70.8 L 470.0 73.0 L 461.1 72.9 L 455.0 71.5 L 448.7 69.3 L 439.7 65.3 L 431.0 61.0 L 421.2 61.2 L 416.0 64.0 L 419.0 100.0 L 398.0 103.0 L 420.0 124.0 L 420.9 129.7 L 421.9 136.1 L 422.0 141.0 L 422.2 146.8 L 424.3 152.7 L 427.0 159.0 L 437.0 159.0 L 445.0 149.0 L 449.0 149.0 L 453.8 156.7 L 456.6 163.4 L 459.3 170.2 L 462.2 176.3 L 465.6 180.4 L 469.7 183.8 L 474.6 185.9 L 480.9 187.1 L 486.5 187.9 L 495.2 186.7 L 500.4 185.4 L 505.0 184.0 L 505.2 177.7 L 507.0 172.0 L 516.0 165.0 L 496.0 141.0 Z",
      "position": {
        "x": 466.6,
        "y": 112.9
      },
      "badgeAnchor": {
        "x": 466.6,
        "y": 112.9
      },
      "badgeRadius": 39.9,
      "adjacencies": [
        "basalt-basin",
        "chrome-flats",
        "dust-waste",
        "frost-shelf",
        "glass-shelf",
        "pale-expanse",
        "zenith-sw-gate"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "static-scarp",
      "name": "Static Scarp",
      "shape": "M 672.3 676.2 L 678.5 680.0 L 681.4 683.1 L 684.0 688.0 L 684.3 695.8 L 683.9 703.4 L 682.9 710.4 L 681.8 716.8 L 679.4 726.4 L 677.0 735.5 L 674.5 741.0 L 672.0 746.0 L 663.6 751.1 L 656.6 753.6 L 650.0 756.0 L 657.0 761.5 L 662.0 766.5 L 666.5 771.0 L 669.6 775.4 L 673.6 783.4 L 676.2 791.2 L 678.8 798.8 L 681.1 805.9 L 683.0 809.0 L 686.0 807.5 L 690.2 803.2 L 694.8 798.8 L 699.0 796.0 L 703.4 793.4 L 705.1 787.6 L 706.7 781.7 L 708.1 779.1 L 710.0 778.0 L 711.1 775.6 L 714.5 772.0 L 721.0 768.0 L 726.9 764.4 L 731.0 760.5 L 734.3 755.3 L 736.7 750.2 L 737.9 745.9 L 737.8 738.7 L 735.3 730.7 L 733.0 723.0 L 733.2 717.2 L 735.0 711.0 L 753.0 709.0 L 759.0 702.5 L 765.0 696.5 L 771.0 690.5 L 777.0 684.5 L 783.8 678.8 L 790.4 673.4 L 797.0 668.0 L 793.5 664.0 L 787.5 660.0 L 781.9 655.6 L 775.8 651.2 L 770.6 646.4 L 765.0 642.0 L 759.7 639.8 L 754.2 638.3 L 746.0 638.0 L 739.6 640.1 L 733.2 641.7 L 724.4 642.9 L 714.6 642.9 L 705.5 642.0 L 697.0 641.0 L 688.5 641.0 L 681.0 641.0 L 673.2 642.2 L 666.0 644.0 L 664.3 642.7 L 662.1 649.5 L 664.8 656.1 L 664.9 663.1 L 661.7 671.5 L 664.6 674.5 L 666.5 673.5 L 668.0 675.0 Z",
      "position": {
        "x": 719.6,
        "y": 678.8
      },
      "badgeAnchor": {
        "x": 716.61,
        "y": 688.93
      },
      "badgeRadius": 35.7,
      "adjacencies": [
        "basalt-shelf",
        "cinder-shelf",
        "mica-flats",
        "ochre-plateau",
        "pale-steppe",
        "vapor-reach"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "topaz-core",
      "name": "Topaz Core",
      "regionId": "topaz-mesa",
      "shape": "M 797.5 516.2 L 796.5 519.5 L 796.1 523.0 L 796.5 526.5 L 797.5 529.8 L 799.0 532.5 L 801.0 535.0 L 803.5 537.0 L 806.2 538.5 L 809.5 539.5 L 813.0 539.9 L 816.5 539.5 L 819.8 538.5 L 822.7 536.8 L 825.2 534.6 L 827.3 531.9 L 828.8 528.9 L 829.6 525.8 L 829.8 522.5 L 829.4 519.3 L 828.4 516.3 L 826.9 513.5 L 824.9 511.1 L 822.5 509.1 L 819.7 507.6 L 816.4 506.5 L 813.0 506.2 L 809.5 506.5 L 806.2 507.6 L 803.5 509.1 L 801.1 511.1 L 799.1 513.5 Z",
      "position": {
        "x": 812.9,
        "y": 523.1
      },
      "badgeAnchor": {
        "x": 812.9,
        "y": 523.1
      },
      "badgeRadius": 16.7,
      "adjacencies": [
        "topaz-e",
        "topaz-n",
        "topaz-ne",
        "topaz-nw",
        "topaz-s",
        "topaz-se",
        "topaz-sw",
        "topaz-w"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "topaz-e",
      "name": "Topaz East",
      "regionId": "topaz-mesa",
      "shape": "M 829.8 522.5 L 829.6 525.8 L 828.8 528.9 L 877.9 551.5 L 880.5 551.5 L 882.0 551.0 L 883.0 494.0 L 880.5 493.5 L 876.9 493.5 L 828.4 516.3 L 829.4 519.3 Z",
      "position": {
        "x": 862.6,
        "y": 522.4
      },
      "badgeAnchor": {
        "x": 862.6,
        "y": 522.4
      },
      "badgeRadius": 19.9,
      "adjacencies": [
        "opal-w",
        "topaz-core",
        "topaz-ene-tower",
        "topaz-ese-tower",
        "topaz-ne",
        "topaz-se"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "topaz-ene-tower",
      "name": "Topaz East-Northeast Tower",
      "regionId": "topaz-ene-tower",
      "shape": "M 874.5 456.5 L 870.5 462.5 L 863.5 467.5 L 862.5 481.5 L 866.5 485.5 L 869.5 485.5 L 874.5 493.5 L 887.5 493.5 L 891.5 490.5 L 891.5 487.5 L 899.5 482.5 L 899.5 467.5 L 896.5 464.5 L 894.5 464.5 L 888.5 456.5 Z",
      "position": {
        "x": 881.5,
        "y": 475
      },
      "badgeAnchor": {
        "x": 881.5,
        "y": 475
      },
      "badgeRadius": 15.9,
      "badgeShrinksWithDigits": true,
      "adjacencies": [
        "opal-nw",
        "opal-w",
        "sable-flats",
        "topaz-e",
        "topaz-ne"
      ],
      "oneWayBorders": [
        "aster-crystal",
        "frost-waste",
        "shale-hollows"
      ],
      "borderDice": {
        "sable-flats": {
          "defend": 7
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "topaz-ese-tower",
      "name": "Topaz East-Southeast Tower",
      "regionId": "topaz-ese-tower",
      "shape": "M 874.5 551.5 L 871.5 554.5 L 871.5 557.5 L 869.5 559.5 L 866.5 559.5 L 862.5 564.5 L 863.5 577.5 L 866.5 580.5 L 868.5 580.5 L 874.5 588.5 L 888.5 588.5 L 892.5 582.5 L 899.5 577.5 L 900.5 563.5 L 896.5 559.5 L 893.5 559.5 L 888.5 551.5 Z",
      "position": {
        "x": 881.5,
        "y": 570
      },
      "badgeAnchor": {
        "x": 881.5,
        "y": 570
      },
      "badgeRadius": 15.9,
      "badgeShrinksWithDigits": true,
      "adjacencies": [
        "opal-sw",
        "opal-w",
        "slate-ridge",
        "topaz-e",
        "topaz-se"
      ],
      "oneWayBorders": [
        "halo-barrens",
        "nova-crystal",
        "ochre-plateau"
      ],
      "borderDice": {
        "slate-ridge": {
          "defend": 7
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "topaz-n",
      "name": "Topaz North",
      "regionId": "topaz-mesa",
      "shape": "M 787.5 454.5 L 784.3 457.7 L 806.2 507.6 L 809.5 506.5 L 813.0 506.2 L 816.4 506.5 L 819.7 507.6 L 840.0 459.0 L 841.9 459.7 L 842.9 457.3 L 789.3 451.1 L 787.5 452.5 L 787.5 453.5 Z",
      "position": {
        "x": 812.7,
        "y": 473.7
      },
      "badgeAnchor": {
        "x": 812.7,
        "y": 473.7
      },
      "badgeRadius": 19.5,
      "adjacencies": [
        "topaz-core",
        "topaz-ne",
        "topaz-nnw-tower",
        "topaz-nw"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "topaz-ne",
      "name": "Topaz Northeast",
      "regionId": "topaz-mesa",
      "shape": "M 874.5 493.5 L 869.5 485.5 L 866.5 485.5 L 862.5 481.5 L 862.9 475.4 L 863.4 469.4 L 861.9 469.2 L 860.9 475.7 L 851.3 461.4 L 842.6 457.9 L 841.9 459.7 L 840.0 459.0 L 819.7 507.6 L 822.5 509.1 L 824.9 511.1 L 826.9 513.5 L 828.4 516.3 L 876.9 493.5 Z",
      "position": {
        "x": 846.6,
        "y": 488.6
      },
      "badgeAnchor": {
        "x": 846.6,
        "y": 488.6
      },
      "badgeRadius": 17.3,
      "adjacencies": [
        "topaz-core",
        "topaz-e",
        "topaz-ene-tower",
        "topaz-n"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "topaz-nnw-tower",
      "name": "Topaz North-Northwest Tower",
      "regionId": "topaz-nnw-tower",
      "shape": "M 770.5 421.5 L 766.5 425.5 L 766.5 427.5 L 758.5 433.5 L 758.5 446.5 L 762.5 450.5 L 764.5 450.5 L 770.5 458.5 L 783.5 458.5 L 787.5 454.5 L 787.5 452.5 L 795.5 446.5 L 795.5 433.5 L 791.5 429.5 L 789.5 429.5 L 783.5 421.5 Z",
      "position": {
        "x": 777,
        "y": 440
      },
      "badgeAnchor": {
        "x": 777,
        "y": 440
      },
      "badgeRadius": 16.3,
      "badgeShrinksWithDigits": true,
      "adjacencies": [
        "frost-waste",
        "topaz-n",
        "topaz-nw"
      ],
      "oneWayBorders": [
        "chrome-dunes",
        "pale-basin",
        "sable-flats",
        "shale-hollows"
      ],
      "borderDice": {
        "frost-waste": {
          "defend": 7
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "topaz-nw",
      "name": "Topaz Northwest",
      "regionId": "topaz-mesa",
      "shape": "M 783.5 458.5 L 778.8 458.5 L 774.7 458.5 L 744.0 492.2 L 744.0 492.5 L 746.0 493.0 L 746.0 495.0 L 797.5 516.2 L 799.1 513.5 L 801.1 511.1 L 803.5 509.1 L 806.2 507.6 L 784.3 457.7 Z",
      "position": {
        "x": 775.8,
        "y": 486.3
      },
      "badgeAnchor": {
        "x": 775.8,
        "y": 486.3
      },
      "badgeRadius": 19.3,
      "adjacencies": [
        "topaz-core",
        "topaz-n",
        "topaz-nnw-tower",
        "topaz-w"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "topaz-s",
      "name": "Topaz South",
      "regionId": "topaz-mesa",
      "shape": "M 787.4 592.0 L 839.0 587.0 L 819.8 538.5 L 816.5 539.5 L 813.0 539.9 L 809.5 539.5 L 806.2 538.5 L 785.0 589.0 L 784.8 588.9 L 786.5 591.5 L 786.8 591.6 Z",
      "position": {
        "x": 812.7,
        "y": 570.8
      },
      "badgeAnchor": {
        "x": 812.7,
        "y": 570.8
      },
      "badgeRadius": 18.5,
      "adjacencies": [
        "topaz-core",
        "topaz-se",
        "topaz-ssw-tower",
        "topaz-sw"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "topaz-se",
      "name": "Topaz Southeast",
      "regionId": "topaz-mesa",
      "shape": "M 825.2 534.6 L 822.7 536.8 L 819.8 538.5 L 839.0 587.0 L 863.0 571.0 L 862.5 564.5 L 866.5 559.5 L 869.5 559.5 L 871.5 557.5 L 871.5 554.5 L 874.5 551.5 L 877.9 551.5 L 828.8 528.9 L 827.3 531.9 Z",
      "position": {
        "x": 846.3,
        "y": 556.8
      },
      "badgeAnchor": {
        "x": 846.3,
        "y": 556.8
      },
      "badgeRadius": 17.9,
      "adjacencies": [
        "topaz-core",
        "topaz-e",
        "topaz-ese-tower",
        "topaz-s"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "topaz-ssw-tower",
      "name": "Topaz South-Southwest Tower",
      "regionId": "topaz-ssw-tower",
      "shape": "M 768.5 585.5 L 765.5 588.5 L 765.5 591.5 L 757.5 596.5 L 757.5 611.5 L 760.5 614.5 L 763.5 614.5 L 768.5 622.5 L 782.5 622.5 L 786.5 618.5 L 786.5 616.5 L 794.5 610.5 L 794.5 598.5 L 790.5 593.5 L 786.5 591.5 L 782.5 585.5 Z",
      "position": {
        "x": 775.5,
        "y": 604
      },
      "badgeAnchor": {
        "x": 775.5,
        "y": 604
      },
      "badgeRadius": 15.9,
      "badgeShrinksWithDigits": true,
      "adjacencies": [
        "ochre-plateau",
        "topaz-s",
        "topaz-sw"
      ],
      "oneWayBorders": [
        "halo-barrens",
        "nova-crystal",
        "pale-steppe",
        "shale-fields",
        "slate-ridge",
        "static-scarp",
        "vapor-reach"
      ],
      "borderDice": {
        "ochre-plateau": {
          "defend": 7
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "topaz-sw",
      "name": "Topaz Southwest",
      "regionId": "topaz-mesa",
      "shape": "M 745.0 553.0 L 742.9 553.7 L 772.7 585.5 L 776.2 585.5 L 782.5 585.5 L 784.8 588.9 L 785.0 589.0 L 806.2 538.5 L 803.5 537.0 L 801.0 535.0 L 799.0 532.5 L 797.5 529.8 L 746.0 551.0 Z",
      "position": {
        "x": 775.9,
        "y": 560.1
      },
      "badgeAnchor": {
        "x": 775.9,
        "y": 560.1
      },
      "badgeRadius": 19.6,
      "adjacencies": [
        "topaz-core",
        "topaz-s",
        "topaz-ssw-tower",
        "topaz-w"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "topaz-w",
      "name": "Topaz West",
      "regionId": "topaz-mesa",
      "shape": "M 746.0 551.0 L 797.5 529.8 L 796.5 526.5 L 796.1 523.0 L 796.5 519.5 L 797.5 516.2 L 746.0 495.0 Z",
      "position": {
        "x": 764.9,
        "y": 523.1
      },
      "badgeAnchor": {
        "x": 764.9,
        "y": 523.1
      },
      "badgeRadius": 18.6,
      "adjacencies": [
        "topaz-core",
        "topaz-nw",
        "topaz-sw",
        "topaz-w-gate"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "topaz-w-gate",
      "name": "Topaz West Gate",
      "shape": "M 733.0 557.0 L 735.2 556.3 L 736.9 557.8 L 744.4 555.3 L 742.9 553.7 L 745.0 553.0 L 746.0 551.0 L 746.0 495.0 L 746.0 493.0 L 744.0 492.5 L 734.0 490.0 L 689.0 478.0 L 681.0 478.0 L 681.0 523.0 L 681.0 568.0 L 710.0 563.0 Z",
      "position": {
        "x": 713.6,
        "y": 523.4
      },
      "badgeAnchor": {
        "x": 713.6,
        "y": 523.4
      },
      "badgeRadius": 32.4,
      "adjacencies": [
        "chrome-dunes",
        "frost-waste",
        "nexus-warp",
        "ochre-plateau",
        "topaz-w",
        "vapor-reach"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "umber-drift",
      "name": "Umber Drift",
      "shape": "M 1104.0 256.0 L 1104.8 264.2 L 1105.8 272.3 L 1104.3 278.3 L 1100.0 285.0 L 1106.2 291.8 L 1109.2 296.8 L 1112.8 301.2 L 1115.2 303.3 L 1121.0 306.0 L 1128.0 306.0 L 1134.3 305.8 L 1141.6 304.6 L 1148.4 302.9 L 1155.2 301.7 L 1163.0 298.5 L 1170.4 295.4 L 1178.1 292.1 L 1185.5 289.0 L 1193.0 286.0 L 1199.5 279.0 L 1206.5 272.0 L 1213.5 265.0 L 1220.5 258.0 L 1226.4 250.4 L 1233.0 242.5 L 1237.3 239.3 L 1241.7 236.2 L 1246.7 233.7 L 1252.0 231.0 L 1252.0 228.8 L 1254.0 227.8 L 1254.0 231.0 L 1254.0 111.2 L 1209.0 156.2 L 1206.2 156.7 L 1206.9 158.4 L 1207.0 158.6 L 1210.0 158.0 L 1205.0 159.0 L 1218.0 211.0 L 1175.0 211.0 L 1174.2 217.2 L 1172.7 223.2 L 1170.2 229.7 L 1166.0 235.5 L 1158.3 241.8 L 1150.6 244.6 L 1143.5 246.0 L 1136.0 246.0 L 1129.1 245.9 L 1123.2 244.2 L 1118.0 243.0 Z",
      "position": {
        "x": 1137.2,
        "y": 275.1
      },
      "badgeAnchor": {
        "x": 1192.22,
        "y": 241.07
      },
      "badgeRadius": 29.1,
      "adjacencies": [
        "ashen-dunes",
        "corona-s-gate",
        "ghost-expanse",
        "mica-scarp",
        "quiet-drift"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "umber-fields",
      "name": "Umber Fields",
      "shape": "M 1212.9 764.9 L 1208.3 768.8 L 1203.5 773.0 L 1199.0 779.0 L 1199.2 787.3 L 1201.0 792.0 L 1206.5 799.0 L 1212.2 805.8 L 1218.0 813.0 L 1216.9 820.9 L 1211.9 829.4 L 1211.0 833.0 L 1218.0 834.0 L 1204.0 888.0 L 1206.0 888.4 L 1205.9 888.8 L 1205.0 890.2 L 1208.0 890.8 L 1254.0 935.7 L 1254.0 784.6 L 1252.0 782.8 L 1252.0 780.0 L 1234.0 763.0 L 1214.0 763.0 Z",
      "position": {
        "x": 1231.1,
        "y": 875.8
      },
      "badgeAnchor": {
        "x": 1231.1,
        "y": 875.8
      },
      "badgeRadius": 22.9,
      "adjacencies": [
        "ghost-steppe",
        "hollow-expanse",
        "penumbra-n-gate"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "umber-hollows",
      "name": "Umber Hollows",
      "shape": "M 393.3 607.8 L 394.5 601.5 L 400.0 594.0 L 398.7 592.3 L 399.6 591.1 L 401.5 592.6 L 389.4 576.6 L 387.5 577.9 L 382.5 581.5 L 378.5 587.5 L 364.5 587.5 L 358.5 579.5 L 356.5 579.5 L 355.0 578.0 L 333.0 603.0 L 344.0 640.0 L 359.4 635.2 L 356.5 624.5 L 365.5 623.5 L 371.5 615.5 L 379.5 623.5 L 388.5 622.5 L 387.9 625.0 L 388.0 625.0 L 390.7 621.2 L 392.0 614.5 Z",
      "position": {
        "x": 355.9,
        "y": 605.3
      },
      "badgeAnchor": {
        "x": 355.9,
        "y": 605.3
      },
      "badgeRadius": 18.6,
      "adjacencies": [
        "argent-expanse",
        "beryl-ese-tower",
        "beryl-s-gate",
        "flint-drift",
        "vesper-crystal"
      ],
      "borderDice": {
        "beryl-ese-tower": {
          "attack": 5
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "umbra-core",
      "name": "Umbra Core",
      "regionId": "umbra-mesa",
      "shape": "M 86.8 982.6 L 89.7 981.1 L 92.2 979.1 L 94.3 976.7 L 96.0 974.0 L 97.1 970.9 L 97.6 967.7 L 97.6 964.4 L 96.9 961.2 L 95.6 958.2 L 94.0 955.7 L 92.0 953.5 L 89.6 951.6 L 86.9 950.3 L 84.0 949.4 L 81.1 949.0 L 78.1 949.1 L 75.2 949.7 L 72.4 950.8 L 69.7 952.5 L 67.3 954.7 L 65.4 957.3 L 63.9 960.1 L 63.1 963.2 L 62.8 966.5 L 63.1 969.6 L 64.0 972.7 L 65.4 975.6 L 67.3 978.2 L 69.7 980.4 L 72.5 982.0 L 75.2 983.1 L 78.1 983.7 L 81.1 983.8 L 84.0 983.5 Z",
      "position": {
        "x": 80.2,
        "y": 966.4
      },
      "badgeAnchor": {
        "x": 80.2,
        "y": 966.4
      },
      "badgeRadius": 17.3,
      "adjacencies": [
        "umbra-e",
        "umbra-n",
        "umbra-ne",
        "umbra-s",
        "umbra-se",
        "umbra-w"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "umbra-crystal",
      "name": "Umbra Crystal",
      "regionId": "umbra-crystal",
      "shape": "M 46.5 949.5 L 36.5 961.5 L 26.5 955.5 L 22.5 957.5 L 26.5 971.5 L 19.5 978.5 L 24.5 984.5 L 23.5 994.5 L 26.5 996.5 L 35.5 993.5 L 44.5 1007.5 L 47.5 1004.5 L 48.5 994.5 L 51.5 991.5 L 61.5 991.5 L 55.5 979.5 L 56.5 970.5 L 49.5 965.5 L 49.5 952.5 Z",
      "position": {
        "x": 40.2,
        "y": 978.6
      },
      "badgeAnchor": {
        "x": 40.2,
        "y": 978.6
      },
      "badgeRadius": 15.3,
      "badgeShrinksWithDigits": true,
      "adjacencies": [
        "umbra-w"
      ],
      "borderDice": {
        "umbra-w": {
          "defend": 4
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "umbra-e",
      "name": "Umbra East",
      "regionId": "umbra-mesa",
      "shape": "M 95.6 958.2 L 96.9 961.2 L 97.6 964.4 L 97.6 967.7 L 97.1 970.9 L 96.0 974.0 L 146.0 995.0 L 146.0 939.0 Z",
      "position": {
        "x": 127.1,
        "y": 966.6
      },
      "badgeAnchor": {
        "x": 127.1,
        "y": 966.6
      },
      "badgeRadius": 18.9,
      "adjacencies": [
        "umbra-core",
        "umbra-e-gate",
        "umbra-ne",
        "umbra-se"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "umbra-e-gate",
      "name": "Umbra East Gate",
      "shape": "M 189.8 925.8 L 184.6 927.1 L 179.9 927.6 L 170.6 930.6 L 161.4 932.8 L 154.6 931.4 L 148.0 930.0 L 146.0 939.0 L 146.0 995.0 L 147.0 996.0 L 148.0 996.4 L 148.0 998.0 L 145.7 997.0 L 145.4 997.3 L 145.9 997.7 L 154.3 1000.8 L 155.9 999.2 L 158.0 1000.0 L 208.0 1012.0 L 208.0 980.0 L 208.0 922.0 L 193.0 924.0 Z",
      "position": {
        "x": 177.1,
        "y": 966.8
      },
      "badgeAnchor": {
        "x": 177.1,
        "y": 966.8
      },
      "badgeRadius": 30.9,
      "adjacencies": [
        "argent-basin",
        "silica-dunes",
        "umbra-e",
        "vapor-expanse"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "umbra-n",
      "name": "Umbra North",
      "regionId": "umbra-mesa",
      "shape": "M 106.0 901.0 L 107.6 902.4 L 108.2 900.9 L 106.2 897.0 L 105.9 897.0 L 105.0 899.0 L 55.0 900.0 L 54.1 898.0 L 53.8 898.0 L 51.8 901.9 L 52.0 902.3 L 54.0 902.0 L 72.4 950.8 L 75.2 949.7 L 78.1 949.1 L 81.1 949.0 L 84.0 949.4 L 86.9 950.3 Z",
      "position": {
        "x": 79.7,
        "y": 918.1
      },
      "badgeAnchor": {
        "x": 79.7,
        "y": 918.1
      },
      "badgeRadius": 18.3,
      "adjacencies": [
        "umbra-core",
        "umbra-n-gate",
        "umbra-ne",
        "umbra-w"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "umbra-n-gate",
      "name": "Umbra North Gate",
      "shape": "M 124.0 835.0 L 93.0 834.0 L 36.0 836.0 L 49.0 887.0 L 54.1 898.0 L 55.0 900.0 L 105.0 899.0 L 111.0 885.0 L 121.0 849.0 Z",
      "position": {
        "x": 79.9,
        "y": 867.1
      },
      "badgeAnchor": {
        "x": 79.9,
        "y": 867.1
      },
      "badgeRadius": 32.4,
      "adjacencies": [
        "argent-basin",
        "dust-plateau",
        "iron-drift",
        "umbra-n"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "umbra-ne",
      "name": "Umbra Northeast",
      "regionId": "umbra-mesa",
      "shape": "M 89.6 951.6 L 92.0 953.5 L 94.0 955.7 L 95.6 958.2 L 146.0 939.0 L 148.0 930.0 L 146.0 928.0 L 144.0 927.3 L 144.0 925.5 L 138.5 925.5 L 130.5 925.5 L 128.5 923.5 L 128.5 918.5 L 126.5 916.5 L 122.5 916.5 L 119.5 913.5 L 119.5 907.2 L 119.5 902.1 L 119.0 901.0 L 118.0 901.0 L 116.7 907.3 L 107.6 899.7 L 108.2 900.9 L 107.6 902.4 L 106.0 901.0 L 86.9 950.3 Z",
      "position": {
        "x": 112.9,
        "y": 932.4
      },
      "badgeAnchor": {
        "x": 112.9,
        "y": 932.4
      },
      "badgeRadius": 17.8,
      "adjacencies": [
        "umbra-core",
        "umbra-e",
        "umbra-n",
        "umbra-ne-tower"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "umbra-ne-tower",
      "name": "Umbra Northeast Tower",
      "regionId": "umbra-ne-tower",
      "shape": "M 131.5 888.5 L 127.5 892.5 L 127.5 894.5 L 119.5 900.5 L 119.5 913.5 L 122.5 916.5 L 126.5 916.5 L 128.5 918.5 L 128.5 923.5 L 130.5 925.5 L 145.5 925.5 L 148.5 922.5 L 148.5 919.5 L 156.5 913.5 L 156.5 900.5 L 152.5 896.5 L 150.5 896.5 L 144.5 888.5 Z",
      "position": {
        "x": 138,
        "y": 907.3
      },
      "badgeAnchor": {
        "x": 138,
        "y": 907.3
      },
      "badgeRadius": 14.6,
      "badgeShrinksWithDigits": true,
      "adjacencies": [
        "argent-basin",
        "umbra-ne"
      ],
      "oneWayBorders": [
        "chrome-ridge",
        "dust-plateau",
        "flint-hollows",
        "vapor-expanse"
      ],
      "borderDice": {
        "argent-basin": {
          "defend": 7
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "umbra-s",
      "name": "Umbra South",
      "regionId": "umbra-mesa",
      "shape": "M 84.0 983.5 L 81.1 983.8 L 78.1 983.7 L 75.2 983.1 L 72.5 982.0 L 52.0 1029.0 L 50.4 1027.6 L 49.6 1029.6 L 56.3 1035.0 L 104.0 1035.0 L 108.3 1029.3 L 107.6 1027.7 L 106.0 1029.0 L 86.8 982.6 Z",
      "position": {
        "x": 79.3,
        "y": 1015.4
      },
      "badgeAnchor": {
        "x": 79.3,
        "y": 1015.4
      },
      "badgeRadius": 19.5,
      "adjacencies": [
        "umbra-core",
        "umbra-se",
        "umbra-w"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "umbra-se",
      "name": "Umbra Southeast",
      "regionId": "umbra-mesa",
      "shape": "M 94.3 976.7 L 92.2 979.1 L 89.7 981.1 L 86.8 982.6 L 106.0 1029.0 L 107.6 1027.7 L 108.3 1029.3 L 107.4 1030.4 L 147.4 998.3 L 145.9 997.7 L 145.4 997.3 L 110.5 1025.4 L 147.0 996.0 L 146.0 995.0 L 96.0 974.0 Z",
      "position": {
        "x": 114.3,
        "y": 1001.4
      },
      "badgeAnchor": {
        "x": 114.3,
        "y": 1001.4
      },
      "badgeRadius": 16.3,
      "adjacencies": [
        "umbra-core",
        "umbra-e",
        "umbra-s"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "umbra-w",
      "name": "Umbra West",
      "regionId": "umbra-mesa",
      "shape": "M 67.3 978.2 L 65.4 975.6 L 64.0 972.7 L 63.1 969.6 L 62.8 966.5 L 63.1 963.2 L 63.9 960.1 L 65.4 957.3 L 67.3 954.7 L 69.7 952.5 L 72.4 950.8 L 54.0 902.0 L 52.0 902.3 L 51.8 901.9 L 52.7 900.1 L 45.0 901.1 L 9.0 940.2 L 9.0 992.9 L 49.6 1029.5 L 50.4 1027.6 L 52.0 1029.0 L 72.5 982.0 L 69.7 980.4 Z M 49.5 965.5 L 56.5 970.5 L 55.5 979.5 L 61.5 991.5 L 51.5 991.5 L 48.5 994.5 L 47.5 1004.5 L 44.5 1007.5 L 35.5 993.5 L 26.5 996.5 L 23.5 994.5 L 24.5 984.5 L 19.5 978.5 L 26.5 971.5 L 22.5 957.5 L 26.5 955.5 L 36.5 961.5 L 46.5 949.5 L 49.5 952.5 Z",
      "position": {
        "x": 44.1,
        "y": 930.6
      },
      "badgeAnchor": {
        "x": 44.1,
        "y": 930.6
      },
      "badgeRadius": 19.1,
      "adjacencies": [
        "umbra-core",
        "umbra-crystal",
        "umbra-n",
        "umbra-s"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "vapor-expanse",
      "name": "Vapor Expanse",
      "shape": "M 296.0 1021.0 L 306.0 987.0 L 344.0 963.0 L 344.9 957.0 L 344.4 953.1 L 340.7 945.3 L 336.9 937.6 L 333.6 930.0 L 330.0 920.5 L 326.6 911.4 L 323.1 902.4 L 319.8 895.7 L 316.2 889.8 L 311.6 885.4 L 307.0 882.0 L 300.0 882.5 L 295.0 884.5 L 290.4 886.9 L 285.8 889.8 L 281.6 893.1 L 276.2 899.2 L 269.0 903.0 L 260.5 904.0 L 252.5 904.0 L 245.0 904.0 L 239.5 903.1 L 233.5 904.0 L 227.6 904.1 L 218.4 905.4 L 209.2 907.2 L 200.3 908.8 L 195.0 909.0 L 193.0 924.0 L 208.0 922.0 L 208.0 980.0 L 213.9 981.1 L 220.2 982.4 L 226.4 981.9 L 233.0 981.0 L 238.4 981.1 L 244.0 982.0 L 248.7 985.3 L 253.8 990.2 L 259.2 994.8 L 264.6 1000.0 L 271.2 1004.8 L 278.1 1010.4 L 283.8 1014.2 L 290.0 1017.5 Z",
      "position": {
        "x": 279.6,
        "y": 948.4
      },
      "badgeAnchor": {
        "x": 279.6,
        "y": 948.4
      },
      "badgeRadius": 46.6,
      "adjacencies": [
        "argent-basin",
        "basalt-waste",
        "flint-hollows",
        "ochre-drift",
        "silica-dunes",
        "umbra-e-gate"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "vapor-reach",
      "name": "Vapor Reach",
      "shape": "M 573.0 523.0 L 573.0 569.0 L 562.0 568.0 L 561.9 577.4 L 560.8 584.8 L 559.3 590.3 L 557.1 595.6 L 553.5 603.0 L 549.2 610.2 L 543.2 616.2 L 537.0 622.0 L 565.0 627.0 L 573.0 641.0 L 574.8 641.3 L 576.9 640.4 L 575.0 641.2 L 574.6 643.3 L 575.1 643.4 L 578.0 642.1 L 583.4 637.0 L 588.9 632.0 L 589.5 627.6 L 588.4 623.1 L 590.2 615.5 L 593.3 609.0 L 596.6 602.8 L 598.3 601.4 L 605.0 598.3 L 605.0 589.8 L 609.8 585.0 L 615.7 585.4 L 622.9 588.5 L 627.3 591.3 L 630.0 599.5 L 634.7 607.7 L 639.8 614.8 L 644.6 621.5 L 649.4 628.2 L 654.4 634.7 L 659.4 641.6 L 663.7 644.7 L 664.3 642.7 L 666.0 644.0 L 673.2 642.2 L 681.0 641.0 L 688.5 641.0 L 697.0 641.0 L 705.5 642.0 L 714.6 642.9 L 724.4 642.9 L 733.2 641.7 L 739.6 640.1 L 746.0 638.0 L 746.0 634.0 L 718.0 605.0 L 717.1 597.5 L 718.9 587.9 L 718.8 580.2 L 717.0 576.0 L 711.5 568.0 L 710.0 563.0 L 681.0 568.0 L 681.0 523.0 L 665.8 523.0 L 665.8 526.4 L 665.4 529.9 L 664.8 533.2 L 663.8 536.6 L 662.6 539.8 L 661.1 542.9 L 659.4 545.9 L 657.3 548.6 L 655.1 551.3 L 652.6 553.7 L 650.0 555.9 L 647.1 557.9 L 644.1 559.5 L 641.0 561.0 L 637.8 562.2 L 634.5 563.0 L 631.0 563.6 L 627.6 563.9 L 624.2 563.9 L 620.7 563.6 L 617.3 563.1 L 614.0 562.2 L 610.8 561.0 L 607.6 559.6 L 604.6 557.9 L 601.8 555.9 L 599.1 553.7 L 596.7 551.3 L 594.4 548.7 L 592.4 545.9 L 590.6 542.9 L 589.1 539.8 L 587.9 536.6 L 587.0 533.3 L 586.3 529.9 L 586.0 526.5 L 585.9 523.0 Z",
      "position": {
        "x": 678.9,
        "y": 604.6
      },
      "badgeAnchor": {
        "x": 672.07,
        "y": 597.1
      },
      "badgeRadius": 36.5,
      "adjacencies": [
        "chrome-dunes",
        "flint-drift",
        "garnet-e-gate",
        "nexus-warp",
        "ochre-plateau",
        "silica-flats",
        "static-scarp",
        "topaz-w-gate"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "vapor-ridge",
      "name": "Vapor Ridge",
      "shape": "M 675.0 244.4 L 667.7 240.3 L 660.1 236.9 L 651.6 235.4 L 643.2 234.8 L 634.0 232.0 L 627.4 224.6 L 624.3 219.7 L 621.9 214.6 L 619.5 206.0 L 617.6 197.4 L 614.2 190.8 L 610.6 184.9 L 610.8 183.0 L 607.5 180.5 L 607.5 177.5 L 605.5 175.5 L 604.7 175.5 L 602.9 178.4 L 598.5 182.0 L 594.8 185.8 L 591.2 190.7 L 589.3 194.8 L 588.7 201.2 L 587.8 206.8 L 586.3 211.8 L 581.0 219.4 L 574.4 226.4 L 570.0 233.0 L 569.0 237.0 L 570.6 239.9 L 573.0 249.5 L 575.4 256.6 L 578.2 263.3 L 581.0 267.5 L 584.0 271.4 L 588.0 275.6 L 591.0 279.5 L 595.0 283.5 L 599.1 286.9 L 600.0 289.0 L 616.0 288.0 L 620.6 285.1 L 625.2 282.2 L 631.2 276.2 L 637.3 270.3 L 642.4 266.9 L 647.7 265.2 L 654.5 265.0 L 660.6 264.6 L 665.7 262.7 L 672.0 259.0 L 683.0 248.0 Z",
      "position": {
        "x": 607.8,
        "y": 250.2
      },
      "badgeAnchor": {
        "x": 607.8,
        "y": 250.2
      },
      "badgeRadius": 31.7,
      "adjacencies": [
        "frost-shelf",
        "ochre-barrens",
        "sable-scarp",
        "slate-dunes",
        "static-fields",
        "zenith-s-tower"
      ],
      "borderDice": {
        "zenith-s-tower": {
          "attack": 5
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "vesper-crystal",
      "name": "Vesper Crystal",
      "regionId": "vesper-crystal",
      "shape": "M 371.5 615.5 L 365.5 623.5 L 356.5 624.5 L 359.5 635.5 L 350.5 643.5 L 361.5 649.5 L 361.5 662.5 L 364.5 665.5 L 374.5 653.5 L 384.5 663.5 L 387.5 660.5 L 386.5 647.5 L 389.5 644.5 L 400.5 643.5 L 403.5 640.5 L 402.5 638.5 L 393.5 635.5 L 386.5 630.5 L 388.5 622.5 L 379.5 623.5 Z",
      "position": {
        "x": 374.1,
        "y": 638.6
      },
      "badgeAnchor": {
        "x": 374.1,
        "y": 638.6
      },
      "badgeRadius": 14.8,
      "badgeShrinksWithDigits": true,
      "adjacencies": [
        "argent-expanse",
        "flint-drift",
        "umber-hollows"
      ],
      "borderDice": {
        "argent-expanse": {
          "defend": 4
        },
        "beryl-ese-tower": {
          "defend": 4
        },
        "flint-drift": {
          "defend": 4
        },
        "garnet-sse-tower": {
          "defend": 4
        },
        "umber-hollows": {
          "defend": 4
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "west-warp",
      "name": "Westrift Warp",
      "regionId": "west-warp",
      "shape": "M 5.3 523.0 L 5.5 526.5 L 6.2 529.9 L 7.2 533.2 L 8.7 536.4 L 10.4 539.4 L 12.6 542.2 L 15.0 544.7 L 17.6 546.9 L 20.6 548.8 L 23.7 550.4 L 27.0 551.6 L 30.4 552.4 L 33.9 552.8 L 37.3 552.8 L 40.8 552.4 L 44.2 551.6 L 47.5 550.4 L 50.6 548.8 L 53.5 546.9 L 56.2 544.7 L 58.6 542.2 L 60.7 539.4 L 62.5 536.4 L 63.9 533.2 L 65.0 529.9 L 65.6 526.5 L 65.9 523.0 L 65.8 519.5 L 65.2 516.1 L 64.3 512.8 L 63.0 509.6 L 61.4 506.6 L 59.5 503.8 L 57.2 501.2 L 54.6 498.9 L 51.9 496.9 L 48.9 495.2 L 45.7 493.9 L 42.4 492.9 L 39.0 492.4 L 35.6 492.2 L 32.1 492.4 L 28.8 493.0 L 25.4 493.9 L 22.3 495.2 L 19.3 496.9 L 16.5 498.9 L 13.9 501.2 L 11.7 503.8 L 9.7 506.6 L 8.1 509.7 L 6.8 512.9 L 5.9 516.2 L 5.4 519.6 Z",
      "position": {
        "x": 35.6,
        "y": 522.4
      },
      "badgeAnchor": {
        "x": 35.6,
        "y": 522.4
      },
      "badgeRadius": 30.2,
      "adjacencies": [
        "cinder-steppe",
        "east-warp",
        "jade-reach",
        "nexus-warp",
        "quartz-w"
      ],
      "borderDice": {
        "cinder-steppe": {
          "defend": 4
        },
        "east-warp": {
          "attack": 5,
          "defend": 7
        },
        "jade-reach": {
          "defend": 4
        },
        "nexus-warp": {
          "attack": 5,
          "defend": 7
        },
        "quartz-w": {
          "defend": 4
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "zenith-core",
      "name": "Zenith Core",
      "regionId": "zenith-mesa",
      "shape": "M 611.2 66.4 L 608.8 67.9 L 606.6 69.7 L 604.8 71.8 L 603.4 74.2 L 602.2 77.0 L 601.6 79.9 L 601.5 82.8 L 601.9 85.8 L 602.8 88.7 L 604.4 91.5 L 606.4 94.0 L 608.8 96.1 L 611.6 97.7 L 614.4 98.7 L 617.3 99.2 L 620.2 99.2 L 623.1 98.8 L 625.9 97.8 L 628.7 96.2 L 631.1 94.2 L 633.2 91.7 L 634.7 88.9 L 635.7 85.8 L 636.1 82.6 L 635.9 79.3 L 635.1 76.2 L 633.8 73.3 L 631.9 70.6 L 629.6 68.4 L 626.8 66.6 L 623.8 65.4 L 620.7 64.8 L 617.4 64.7 L 614.2 65.3 Z",
      "position": {
        "x": 618.8,
        "y": 81.9
      },
      "badgeAnchor": {
        "x": 618.8,
        "y": 81.9
      },
      "badgeRadius": 17.2,
      "adjacencies": [
        "zenith-ne",
        "zenith-nw",
        "zenith-s",
        "zenith-se",
        "zenith-sw",
        "zenith-w"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "zenith-crystal",
      "name": "Zenith Crystal",
      "regionId": "zenith-crystal",
      "shape": "M 619.5 24.5 L 617.5 27.5 L 624.5 41.5 L 614.5 50.5 L 617.5 53.5 L 625.5 53.5 L 630.5 60.5 L 640.5 60.5 L 651.5 69.5 L 654.5 66.5 L 652.5 58.5 L 655.5 55.5 L 667.5 55.5 L 670.5 52.5 L 654.5 39.5 L 655.5 33.5 L 649.5 31.5 L 639.5 20.5 L 633.5 29.5 Z",
      "position": {
        "x": 639.8,
        "y": 44.7
      },
      "badgeAnchor": {
        "x": 639.8,
        "y": 44.7
      },
      "badgeRadius": 15.6,
      "badgeShrinksWithDigits": true,
      "adjacencies": [
        "zenith-ne"
      ],
      "borderDice": {
        "zenith-ne": {
          "defend": 4
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "zenith-ne",
      "name": "Zenith Northeast",
      "regionId": "zenith-mesa",
      "shape": "M 611.2 66.4 L 614.2 65.3 L 617.4 64.7 L 620.7 64.8 L 623.8 65.4 L 626.8 66.6 L 629.6 68.4 L 631.9 70.6 L 633.8 73.3 L 635.1 76.2 L 635.9 79.3 L 636.1 82.6 L 635.7 85.8 L 634.7 88.9 L 685.0 109.0 L 686.9 109.8 L 690.0 104.6 L 690.0 51.9 L 676.6 43.6 L 672.7 33.8 L 644.7 12.0 L 602.6 10.0 L 589.5 16.0 L 590.4 18.5 L 592.0 17.0 Z M 639.5 20.5 L 649.5 31.5 L 655.5 33.5 L 654.5 39.5 L 670.5 52.5 L 667.5 55.5 L 655.5 55.5 L 652.5 58.5 L 654.5 66.5 L 651.5 69.5 L 640.5 60.5 L 630.5 60.5 L 625.5 53.5 L 617.5 53.5 L 614.5 50.5 L 624.5 41.5 L 617.5 27.5 L 619.5 24.5 L 633.5 29.5 Z",
      "position": {
        "x": 669.6,
        "y": 80.4
      },
      "badgeAnchor": {
        "x": 669.6,
        "y": 80.4
      },
      "badgeRadius": 20.4,
      "adjacencies": [
        "zenith-core",
        "zenith-crystal",
        "zenith-nw",
        "zenith-se"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "zenith-nw",
      "name": "Zenith Northwest",
      "regionId": "zenith-mesa",
      "shape": "M 604.8 71.8 L 606.6 69.7 L 608.8 67.9 L 611.2 66.4 L 592.0 17.0 L 590.4 18.5 L 589.6 16.5 L 549.4 53.6 L 552.9 55.1 L 553.0 53.0 L 603.4 74.2 Z",
      "position": {
        "x": 584.1,
        "y": 46.4
      },
      "badgeAnchor": {
        "x": 584.1,
        "y": 46.4
      },
      "badgeRadius": 18,
      "adjacencies": [
        "zenith-core",
        "zenith-ne",
        "zenith-w"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "zenith-s",
      "name": "Zenith South",
      "regionId": "zenith-mesa",
      "shape": "M 611.5 146.5 L 624.5 146.5 L 628.1 151.4 L 628.1 151.4 L 630.5 154.5 L 631.2 154.5 L 630.8 150.0 L 632.5 149.0 L 647.7 150.1 L 647.0 148.0 L 646.0 148.0 L 625.9 97.8 L 623.1 98.8 L 620.2 99.2 L 617.3 99.2 L 614.4 98.7 L 611.6 97.7 L 592.0 148.0 L 589.9 148.0 L 589.3 149.5 L 607.0 152.9 L 607.5 152.5 L 608.9 150.4 Z",
      "position": {
        "x": 618.9,
        "y": 128.6
      },
      "badgeAnchor": {
        "x": 618.9,
        "y": 128.6
      },
      "badgeRadius": 17.9,
      "adjacencies": [
        "zenith-core",
        "zenith-s-tower",
        "zenith-se",
        "zenith-sw"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "zenith-s-tower",
      "name": "Zenith South Tower",
      "regionId": "zenith-s-tower",
      "shape": "M 611.5 146.5 L 607.5 152.5 L 599.5 158.5 L 599.5 172.5 L 602.5 175.5 L 605.5 175.5 L 607.5 177.5 L 607.5 180.5 L 611.5 183.5 L 625.5 183.5 L 628.5 180.5 L 628.5 177.5 L 636.5 172.5 L 636.5 158.5 L 632.5 154.5 L 630.5 154.5 L 624.5 146.5 Z",
      "position": {
        "x": 618,
        "y": 165.5
      },
      "badgeAnchor": {
        "x": 618,
        "y": 165.5
      },
      "badgeRadius": 15.9,
      "badgeShrinksWithDigits": true,
      "adjacencies": [
        "frost-shelf",
        "sable-scarp",
        "vapor-ridge",
        "zenith-s"
      ],
      "oneWayBorders": [
        "chrome-flats",
        "flint-plateau",
        "ochre-barrens",
        "rust-steppe",
        "slate-dunes",
        "static-fields",
        "static-hollows"
      ],
      "borderDice": {
        "frost-shelf": {
          "defend": 7
        },
        "sable-scarp": {
          "defend": 7
        },
        "vapor-ridge": {
          "defend": 7
        }
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "zenith-se",
      "name": "Zenith Southeast",
      "regionId": "zenith-mesa",
      "shape": "M 647.0 148.0 L 652.0 145.5 L 658.5 139.0 L 665.0 132.5 L 671.5 126.0 L 678.0 119.5 L 683.6 112.6 L 685.0 109.0 L 634.7 88.9 L 633.2 91.7 L 631.1 94.2 L 628.7 96.2 L 625.9 97.8 L 646.0 148.0 Z",
      "position": {
        "x": 653.9,
        "y": 116.8
      },
      "badgeAnchor": {
        "x": 653.9,
        "y": 116.8
      },
      "badgeRadius": 18.8,
      "adjacencies": [
        "zenith-core",
        "zenith-ne",
        "zenith-s",
        "zenith-se-gate"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "zenith-se-gate",
      "name": "Zenith Southeast Gate",
      "shape": "M 678.0 204.0 L 723.0 162.0 L 740.0 144.0 L 740.0 140.0 L 724.0 130.0 L 720.0 129.0 L 713.7 125.3 L 706.7 121.8 L 700.5 118.0 L 697.0 114.0 L 695.0 113.2 L 695.0 111.0 L 687.9 108.0 L 686.9 109.8 L 693.4 112.5 L 685.0 109.0 L 683.6 112.6 L 678.0 119.5 L 671.5 126.0 L 665.0 132.5 L 658.5 139.0 L 652.0 145.5 L 647.0 148.0 L 651.0 161.0 Z",
      "position": {
        "x": 688.6,
        "y": 152.3
      },
      "badgeAnchor": {
        "x": 688.6,
        "y": 152.3
      },
      "badgeRadius": 30.6,
      "adjacencies": [
        "rust-steppe",
        "sable-scarp",
        "shale-drift",
        "zenith-se"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "zenith-sw",
      "name": "Zenith Southwest",
      "regionId": "zenith-mesa",
      "shape": "M 554.0 112.5 L 559.5 118.0 L 564.8 124.2 L 570.8 130.2 L 576.8 136.2 L 583.2 141.8 L 589.0 148.0 L 588.7 150.0 L 591.8 150.0 L 589.3 149.5 L 589.9 148.0 L 592.0 148.0 L 611.6 97.7 L 608.8 96.1 L 606.4 94.0 L 604.4 91.5 L 602.8 88.7 L 552.0 109.0 Z",
      "position": {
        "x": 583.9,
        "y": 116.7
      },
      "badgeAnchor": {
        "x": 583.9,
        "y": 116.7
      },
      "badgeRadius": 18.9,
      "adjacencies": [
        "zenith-core",
        "zenith-s",
        "zenith-sw-gate",
        "zenith-w"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "zenith-sw-gate",
      "name": "Zenith Southwest Gate",
      "shape": "M 559.0 204.0 L 587.0 160.0 L 587.3 157.9 L 589.4 157.6 L 590.7 150.0 L 588.7 150.0 L 589.0 148.0 L 583.2 141.8 L 576.8 136.2 L 570.8 130.2 L 564.8 124.2 L 559.5 118.0 L 554.0 112.5 L 552.0 109.0 L 550.0 108.0 L 541.0 113.7 L 539.0 115.0 L 536.6 117.6 L 531.0 121.0 L 525.9 123.4 L 523.0 124.0 L 496.0 141.0 L 516.0 165.0 Z",
      "position": {
        "x": 548.4,
        "y": 152.1
      },
      "badgeAnchor": {
        "x": 548.4,
        "y": 152.1
      },
      "badgeRadius": 31.3,
      "adjacencies": [
        "frost-shelf",
        "pale-expanse",
        "static-hollows",
        "zenith-sw"
      ],
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "zenith-w",
      "name": "Zenith West",
      "regionId": "zenith-mesa",
      "shape": "M 601.9 85.8 L 601.5 82.8 L 601.6 79.9 L 602.2 77.0 L 603.4 74.2 L 553.0 53.0 L 552.9 55.1 L 550.9 54.3 L 548.1 106.9 L 549.9 105.7 L 550.1 105.8 L 550.0 108.0 L 552.0 109.0 L 602.8 88.7 Z",
      "position": {
        "x": 569.2,
        "y": 81.1
      },
      "badgeAnchor": {
        "x": 569.2,
        "y": 81.1
      },
      "badgeRadius": 19.5,
      "adjacencies": [
        "zenith-core",
        "zenith-nw",
        "zenith-sw"
      ],
      "ownerId": "",
      "armies": 0
    }
  ],
  "ruleOverlay": {
    "sets": [
      {
        "id": "mesas",
        "label": "Mesa",
        "glyph": "octagon",
        "color": "#e48a1f",
        "regions": {
          "idSuffix": "-mesa"
        }
      },
      {
        "id": "crystals",
        "label": "Crystal",
        "glyph": "starburst",
        "color": "#27b6ea",
        "territories": {
          "idSuffix": "-crystal"
        }
      },
      {
        "id": "warps",
        "label": "Warp crystal",
        "glyph": "starburst",
        "color": "#2fa84f",
        "territories": {
          "idSuffix": "-warp"
        }
      },
      {
        "id": "towers",
        "label": "Tower",
        "glyph": "cross",
        "color": "#e5262c",
        "territories": {
          "idSuffix": "-tower"
        }
      },
      {
        "id": "plains",
        "label": "Plains",
        "glyph": "grass",
        "color": "#c9c9c6",
        "territories": {
          "noRegion": true,
          "notIdSuffix": "-gate"
        }
      }
    ],
    "rules": [
      {
        "id": "mesa",
        "set": "mesas",
        "facts": [
          {
            "kind": "bonus",
            "value": 8,
            "label": "whole mesa"
          }
        ]
      },
      {
        "id": "crystal",
        "set": "crystals",
        "facts": [
          {
            "kind": "bonus",
            "value": 5,
            "label": "each"
          },
          {
            "kind": "defend",
            "die": 4
          }
        ]
      },
      {
        "id": "warp",
        "set": "warps",
        "facts": [
          {
            "kind": "bonus",
            "value": 5,
            "label": "each"
          },
          {
            "kind": "defend",
            "die": 4
          },
          {
            "kind": "link",
            "from": "warps",
            "to": "warps",
            "pairs": "all",
            "style": "warp",
            "dice": {
              "attack": 5,
              "defend": 7
            }
          }
        ]
      },
      {
        "id": "tower",
        "set": "towers",
        "facts": [
          {
            "kind": "bonus",
            "value": 1,
            "label": "each"
          },
          {
            "kind": "reach",
            "to": "plains",
            "steps": 2,
            "oneWay": true,
            "example": "zenith-s-tower",
            "tagAt": {
              "x": 938,
              "y": 262
            }
          },
          {
            "kind": "matchup",
            "from": "plains",
            "to": "towers",
            "attack": 5,
            "defend": 7,
            "example": [
              "cinder-shelf",
              "nadir-n-tower"
            ]
          }
        ]
      }
    ],
    "chips": [
      {
        "icon": "none",
        "label": "Gates & plains: no bonus"
      }
    ]
  },
  "geometryVersion": "v1-56acfa95-981107b5",
  "seaRoutes": [
    {
      "aId": "beryl-e",
      "bId": "beryl-ese-tower",
      "from": {
        "x": 366.9,
        "y": 550.5
      },
      "to": {
        "x": 364.5,
        "y": 550.5
      }
    },
    {
      "aId": "beryl-ese-tower",
      "bId": "garnet-w",
      "from": {
        "x": 378.5,
        "y": 550.5
      },
      "to": {
        "x": 376.2,
        "y": 550.5
      }
    },
    {
      "aId": "garnet-ne",
      "bId": "garnet-nne-tower",
      "from": {
        "x": 470.5,
        "y": 456.5
      },
      "to": {
        "x": 470.5,
        "y": 456.5
      }
    },
    {
      "aId": "garnet-se",
      "bId": "garnet-sse-tower",
      "from": {
        "x": 470.5,
        "y": 586.5
      },
      "to": {
        "x": 470.5,
        "y": 586.5
      }
    },
    {
      "aId": "jasper-ene-tower",
      "bId": "jasper-ne",
      "from": {
        "x": 1155.5,
        "y": 495.5
      },
      "to": {
        "x": 1155.5,
        "y": 495.5
      }
    },
    {
      "aId": "jasper-s",
      "bId": "jasper-ssw-tower",
      "from": {
        "x": 1064.5,
        "y": 591
      },
      "to": {
        "x": 1065.5,
        "y": 592.5
      }
    },
    {
      "aId": "jasper-ssw-tower",
      "bId": "jasper-sw",
      "from": {
        "x": 1061.5,
        "y": 586.5
      },
      "to": {
        "x": 1061.5,
        "y": 586.5
      }
    },
    {
      "aId": "opal-w",
      "bId": "topaz-ese-tower",
      "from": {
        "x": 886.2,
        "y": 551.5
      },
      "to": {
        "x": 888.5,
        "y": 551.5
      }
    },
    {
      "aId": "quartz-se",
      "bId": "quartz-sse-tower",
      "from": {
        "x": 192.5,
        "y": 584.5
      },
      "to": {
        "x": 192.5,
        "y": 584.5
      }
    },
    {
      "aId": "topaz-e",
      "bId": "topaz-ese-tower",
      "from": {
        "x": 877.9,
        "y": 551.5
      },
      "to": {
        "x": 874.5,
        "y": 551.5
      }
    },
    {
      "aId": "topaz-nnw-tower",
      "bId": "topaz-nw",
      "from": {
        "x": 783.5,
        "y": 458.5
      },
      "to": {
        "x": 783.5,
        "y": 458.5
      }
    },
    {
      "aId": "topaz-ssw-tower",
      "bId": "topaz-sw",
      "from": {
        "x": 782.5,
        "y": 585.5
      },
      "to": {
        "x": 782.5,
        "y": 585.5
      }
    },
    {
      "aId": "jasper-ene-tower",
      "bId": "rust-shelf",
      "from": {
        "x": 1155.5,
        "y": 481.5
      },
      "to": {
        "x": 1106,
        "y": 444
      },
      "oneWay": true
    },
    {
      "aId": "jasper-ese-tower",
      "bId": "ashen-ridge",
      "from": {
        "x": 1158.5,
        "y": 567.5
      },
      "to": {
        "x": 1132.6,
        "y": 597.5
      },
      "oneWay": true
    },
    {
      "aId": "nadir-n-tower",
      "bId": "mica-flats",
      "from": {
        "x": 638.5,
        "y": 864.5
      },
      "to": {
        "x": 638.5,
        "y": 864.5
      },
      "oneWay": true
    }
  ]
}
